import React from "react";
import { useStore } from "../../stores/store";

interface Props {
  score: number | null;
  level: string | null;
  surveyCode: string;
  meterPoints: number;
}

export default function MeterChart({ score, level, surveyCode, meterPoints }: Props) {
  const { commonStore } = useStore();

  const getDegree = (): string => {
    let degree: number = 0;
    if (score == null) return "";
    else if (score < 50) degree = score * 2.11;
    else degree = score * 2.14;

    return `rotate(${degree}deg)`;
  };
  const getDegreeforthreepoints = (): string => {
    let degree: number = 0;
    if (score == null) return "";
    else degree = score * 2.18;

    return `rotate(${degree}deg)`;
  };

  const cambodiaLevels = (
    <g className="meter-lvls-eng-uz">
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M22.5,285.6l-1.1,0c-0.5,0-0.8,0.4-0.9,1.3c-0.9-0.7-1.8-1.2-2.7-1.5l0.5-0.7c0.2-0.3,0.4-0.6,0.4-0.9
		c0-0.1,0-0.3-0.1-0.4c0.6,0,0.9,0.2,1,0.5c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.5-0.4,0.9l0.8,0.4c0.3-0.6,0.7-0.9,1.4-0.9l6.7,0.3l0,1.2
		c-1.1,0.5-1.9,0.8-2.4,0.8c-0.6,0-0.9-0.3-0.9-0.7l0-0.3l-1.3,0l-0.2,4.1l4.6,0.2l0,1.2c-1.1,0.6-1.9,0.8-2.4,0.8
		c-0.6,0-0.9-0.3-0.9-0.7l0-0.3l-3.4-0.1c-0.5,0-0.8,0.4-0.9,1.3c-0.9-0.7-1.8-1.2-2.7-1.5l0.5-0.7c0.2-0.3,0.4-0.6,0.4-0.9
		c0-0.1,0-0.3-0.1-0.4c0.6,0,0.9,0.2,1,0.5c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.5-0.4,0.9l0.8,0.4c0.3-0.6,0.7-0.9,1.4-0.9l1.1,0
		L22.5,285.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M31.6,289.4c-0.1,1.1-0.5,1.7-1.4,1.6c-0.9-0.1-1.4-0.6-1.3-1.8l0.1-2.1l-0.7,0l0.1-1l0.7,0l0.1-2.3l1,0.1
		l-0.1,2.3l0.7,0c0-0.2,0.1-0.4,0.2-0.5s0.4-0.2,0.7-0.1c0.3,0,0.5,0.1,0.6,0.2c0.1,0.2,0.2,0.4,0.2,0.7s-0.1,0.5-0.3,0.6
		c-0.2,0.1-0.4,0.2-0.6,0.2C31.7,287.9,31.7,288.6,31.6,289.4z M30.3,290c0.2,0,0.3-0.2,0.3-0.7l0.1-2.1l-0.7,0l-0.1,2.1
		C29.9,289.8,30,290,30.3,290z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M19.5,281.5c-0.4-0.6-0.7-1.1-1-1.4c-0.3-0.3-0.4-0.6-0.4-0.7c0-0.1,0.1-0.3,0.3-0.6l0.3-0.4l0.5-0.7l-0.4-0.7
		l-0.2-0.3c-0.1-0.2-0.2-0.4-0.2-0.5c0-0.1,0.1-0.3,0.3-0.5l0.3-0.3c0.4-0.4,0.7-0.8,1-1.5c0.4,0.3,0.6,0.7,0.6,0.9
		c0,0.1,0,0.1-0.1,0.2c-0.2,0.3-0.5,0.7-1,1.2l0.9,1.5l-1.1,1.6l0.6,0.9l0.6-0.2l0.4,0.6l-0.8,0.9L19.5,281.5z M28.7,275.3l-0.1,1
		l-4.8-0.4c-1.1-0.1-1.8,0.6-1.9,1.9s0.4,2.1,1.6,2.2l4.8,0.4l-0.1,1l-4.8-0.4c-1.8-0.1-2.7-1.2-2.5-3.3c0.2-2,1.1-3,3-2.9
		L28.7,275.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M22.4,271.3c-0.5,0-0.8,0.4-1,1.3c-0.9-0.8-1.7-1.3-2.6-1.7l0.6-0.7c0.2-0.3,0.4-0.6,0.4-0.8
		c0-0.1,0-0.3-0.1-0.4c0.6,0.1,0.9,0.2,1,0.5c0,0.1,0,0.1,0,0.2c0,0.2-0.2,0.5-0.4,0.9l0.7,0.4c0.3-0.6,0.8-0.8,1.4-0.8l3.4,0.3
		l0-0.3c0-0.5,0.4-0.6,1-0.6c0.5,0,1.2,0.4,2.2,1.1l-0.1,1.2L22.4,271.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M31.7,266.9c0.9,0.1,1.4-0.4,1.6-1.5c0.1-1.1-0.3-1.7-1.2-1.9l-1.1-0.1l0.1-1l1.1,0.1c1.6,0.2,2.3,1.2,2.1,3
		s-1.1,2.6-2.7,2.4l-8.7-1c-0.5-0.1-0.8,0.4-1,1.3c-0.8-0.8-1.7-1.4-2.5-1.7l0.6-0.7c0.3-0.3,0.4-0.6,0.4-0.8c0-0.1,0-0.3,0-0.4
		c0.6,0.1,0.9,0.2,1,0.5c0,0.1,0,0.1,0,0.2c0,0.2-0.2,0.5-0.4,0.9l0.7,0.5c0.3-0.6,0.8-0.8,1.4-0.8L31.7,266.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M24.1,257.3c-0.5-0.1-0.8,0.4-1,1.2c-0.8-0.8-1.7-1.4-2.5-1.7l0.6-0.7c0.3-0.3,0.4-0.6,0.4-0.8
		c0-0.1,0-0.3,0-0.4c0.6,0.1,0.9,0.3,1,0.6c0,0.1,0,0.1,0,0.2c0,0.2-0.2,0.5-0.4,0.9l0.7,0.5c0.3-0.6,0.8-0.8,1.4-0.7l3.9,0.5
		c1.8,0.2,2.6,1.4,2.3,3.4c-0.3,2-1.3,2.9-3.1,2.7l-3.9-0.5c-0.5-0.1-0.8,0.4-1,1.2c-0.8-0.8-1.7-1.4-2.5-1.7l0.6-0.7
		c0.3-0.3,0.4-0.6,0.4-0.8c0-0.1,0-0.3,0-0.4c0.6,0.1,0.9,0.3,1,0.6c0,0.1,0,0.1,0,0.2c0,0.2-0.2,0.5-0.4,0.9l0.7,0.5
		c0.3-0.6,0.8-0.8,1.4-0.7l3.9,0.5c1.1,0.1,1.8-0.5,2-1.8c0.2-1.4-0.3-2.1-1.4-2.2L24.1,257.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M18.1,259.5c-0.2,1.1-0.7,1.6-1.6,1.5c-1.1-0.2-1.6-1-1.3-2.4c0.1-0.9,0.6-1.7,1.4-2.4c0.1,0,0.1-0.1,0.2-0.1
		l-1.8-0.3l0.2-1l3.7,0.6L18.1,259.5z M17.1,259.3l0.4-2.6c-0.7,0.4-1.1,1.1-1.2,2c-0.1,0.7,0,1,0.4,1.1
		C16.9,259.8,17,259.7,17.1,259.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M33.6,253.2c0.9,0.2,1.4-0.3,1.6-1.5s-0.2-1.8-1.1-1.9l-1.1-0.2l0.2-1l1.1,0.2c1.6,0.3,2.2,1.3,1.9,3.1
		c-0.3,1.8-1.2,2.6-2.8,2.3l-8.6-1.4c-0.5-0.1-0.8,0.3-1.1,1.2c-0.8-0.8-1.6-1.4-2.5-1.8l0.6-0.6c0.3-0.3,0.4-0.6,0.5-0.8
		c0-0.1,0-0.3,0-0.4c0.6,0.1,0.9,0.3,1,0.6c0,0.1,0,0.1,0,0.2c0,0.2-0.2,0.5-0.5,0.8l0.7,0.5c0.4-0.6,0.9-0.8,1.5-0.7L33.6,253.2z"
		/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M23.6,248.6l-0.5-1.5l-0.3-0.7c-0.2-0.5-0.2-0.8-0.2-1c0-0.2,0.2-0.5,0.4-0.8l0.3-0.5l0.7-1.1l-0.3-1l-0.1-0.5
		c-0.1-0.3-0.1-0.6-0.1-0.8c0-0.2,0.2-0.4,0.4-0.7l0.3-0.4l0.9-1.1c0.4-0.5,1-0.7,1.7-0.6l7.4,1.5l-0.2,1l-7.4-1.5
		c-0.3-0.1-0.6,0-0.7,0.2l-1.5,1.8l0.6,2.4l-1.5,2.3l0.7,1.8l0.6-0.2l0,1l-1,0.6L23.6,248.6z M32.7,246.6c-0.4,2-1.5,2.8-3.3,2.5
		l-2.6-0.5c-0.1,0.3-0.3,0.4-0.8,0.3c-0.8-0.2-1.2-0.6-1.1-1.3c0.1-0.3,0.3-0.4,0.8-0.3l4,0.8c1.1,0.2,1.8-0.3,2.1-1.7
		c0.3-1.3-0.2-2.1-1.3-2.3l-4.4-0.9l0.2-1l8,1.6l-0.2,1l-1.5-0.3C32.9,245.1,32.9,245.8,32.7,246.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M30.8,225.5c-0.5-0.1-0.9,0.2-1.2,1.1c-0.7-0.9-1.5-1.6-2.3-2L28,224c0.3-0.3,0.5-0.5,0.5-0.8
		c0-0.1,0-0.3,0-0.4c0.6,0.1,0.9,0.4,0.9,0.7c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.2,0.5-0.5,0.8l0.7,0.6c0.4-0.5,0.9-0.7,1.5-0.6l3.8,1
		c1.8,0.5,2.4,1.6,2,3.3c-0.4,1.8-1.6,2.4-3.3,2l-2-0.5c-1.1-0.3-1.8,0.2-2.1,1.4c-0.3,1.2,0.1,2,1.2,2.2l1.4,0.3
		c0-0.1,0-0.2,0.1-0.3c0.2-0.9,0.7-1.2,1.5-1c0.5,0.1,0.9,0.4,1.3,0.9c0.4,0.5,0.5,0.9,0.4,1.3l-0.3,1l-4.6-1.2
		c-1.3-0.3-2-1-2.1-2.1l-0.1,0c-0.3,0.1-0.5,0.5-0.8,1.3c-0.8-1.4-1.5-2.2-1.9-2.4l0.7-0.8c0.3-0.4,0.5-0.7,0.6-1.1
		c0-0.2,0.1-0.4,0-0.5c0.6,0.1,0.9,0.4,0.9,0.8c0,0.1,0,0.1,0,0.2c-0.1,0.4-0.4,0.9-0.8,1.4l0.5,0.7c0.2-0.2,0.3-0.4,0.5-0.5
		l0.4-0.2l0-0.2c0.5-1.9,1.6-2.6,3.4-2.1l2,0.5c1.1,0.3,1.8-0.1,2.1-1.2c0.3-1.1-0.1-1.8-1.2-2.1L30.8,225.5z M33.2,234.6l1,0.3
		c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.5-0.3-0.7-0.4c-0.2,0-0.3,0-0.3,0.3C32.9,234.4,33,234.5,33.2,234.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M22,224.5l2.3,0.6c0.4,0.1,0.5,0.3,0.5,0.7c-0.2,0.3-0.4,0.4-0.8,0.3l-2.3-0.6L22,224.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M37.6,217.4l1.5,3.4l-1.5,1.3c-0.3,0.2-0.5,0.3-0.7,0.3c-0.2-0.1-0.4-0.2-0.5-0.6l-1.9-4.3
		c-0.4-0.7-1-1.2-1.8-1.5c-0.4-0.1-1,0-1.6,0.5l0.5,1.3l-1.2,0.8c0.3,0.7,0.6,1.1,1,1.3c0.7,0.2,1.1,0,1.2-0.6
		c0.1-0.4,0.1-0.7-0.1-0.7c-0.3-0.1-0.5-0.3-0.4-0.6c0.1-0.3,0.3-0.4,0.7-0.3c0.9,0.3,1.1,0.9,0.8,2c-0.4,1.2-1.2,1.6-2.5,1.2
		c-0.5-0.1-0.9-0.4-1.1-0.8l-1-1.7l1.4-0.9l-0.7-1.6l1.7-0.9c0.5-0.2,0.9-0.2,1.4,0c1.2,0.4,2,1,2.4,1.9l1.8,4.2l0.6-0.6l-1.1-2.6
		c-0.3-0.6-0.5-0.9-0.8-1l0.3-1l3.9,1.2l-0.3,1L37.6,217.4z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M27.2,217.4c-0.3,1.1-1,1.5-1.8,1.2c-1.1-0.3-1.4-1.2-1-2.6c0.3-0.9,0.9-1.6,1.8-2.1c0.1,0,0.1-0.1,0.2-0.1
		l-1.8-0.6l0.3-1l3.6,1.1L27.2,217.4z M26.2,217.1l0.8-2.5c-0.7,0.3-1.2,0.9-1.5,1.8c-0.2,0.6-0.1,1,0.2,1.1
		C25.9,217.6,26.1,217.4,26.2,217.1z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M34.5,208c-0.2,0.6-0.6,1.1-1.2,1.5l-0.5,0.4l0.3,0.9c0.1,0,0.4-0.1,0.9-0.4l-0.1,1c-0.4,0.4-0.7,0.5-0.9,0.4
		l-0.3-0.1c-0.2-0.1-0.3-0.3-0.4-0.6l-0.1-0.5c-0.2-0.6-0.3-1-0.3-1.1c0-0.1,0.3-0.4,0.8-0.8c0.5-0.5,0.8-0.8,0.9-1.1
		c0.4-1,0.1-1.7-0.7-2c-0.7-0.2-1.2,0.3-1.6,1.5c-0.5-0.2-0.6-0.5-0.4-1.1c0.4-1.3,1.2-1.7,2.4-1.4C34.7,205.2,35.1,206.3,34.5,208z
		 M36,206.8l0.3-1l6.8,2.3l-0.3,1l-2.6,1.3l1.2,2.6l-0.3,1l-5.1-1.7c-0.1,0.3-0.4,0.4-0.9,0.2c-0.8-0.3-1.1-0.8-0.9-1.5
		c0.1-0.3,0.3-0.3,0.8-0.2l5.1,1.7l-1.2-2.6l2.6-1.3L36,206.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M30.2,208c-0.4,1.1-1,1.4-1.9,1.1c-1.1-0.4-1.4-1.3-0.9-2.6c0.3-0.9,0.9-1.5,1.8-2.1c0.1,0,0.1-0.1,0.2-0.1
		l-1.8-0.6l0.3-1l3.5,1.3L30.2,208z M29.2,207.6l0.9-2.5c-0.7,0.3-1.3,0.9-1.6,1.8c-0.2,0.6-0.2,1,0.2,1.1
		C28.9,208.1,29.1,208,29.2,207.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M37.9,198.8c-0.2,0.6-0.6,1.1-1.3,1.5l-0.5,0.4l0.2,0.9c0.1,0.1,0.4-0.1,0.9-0.4l-0.1,1
		c-0.4,0.3-0.7,0.5-0.9,0.4l-0.3-0.1c-0.2-0.1-0.3-0.3-0.4-0.6l-0.1-0.5c-0.2-0.6-0.3-1-0.2-1.1c0-0.1,0.3-0.4,0.8-0.8
		c0.5-0.4,0.8-0.8,0.9-1c0.4-1,0.2-1.7-0.6-2c-0.7-0.2-1.2,0.2-1.7,1.5c-0.5-0.2-0.6-0.6-0.4-1.2c0.5-1.3,1.3-1.7,2.4-1.3
		C38.1,196.1,38.5,197.2,37.9,198.8z M43.9,198.3c1.7,0.6,2.2,1.9,1.5,3.8c-0.7,1.9-1.9,2.5-3.6,1.9l-2.5-0.9
		c-0.1,0.3-0.4,0.4-0.9,0.2c-0.8-0.3-1.1-0.8-0.8-1.5c0.1-0.3,0.4-0.3,0.8-0.1l3.8,1.4c1.1,0.4,1.8,0,2.3-1.3
		c0.5-1.3,0.2-2.1-0.9-2.5l-2.2-0.8c-0.2,0.4-0.5,0.5-1.1,0.3c-0.7-0.3-0.9-0.7-0.7-1.3c0.2-0.4,0.5-0.6,0.9-0.4L43.9,198.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M45,193.9c0-0.1,0.1-0.2,0.1-0.3c0.4-0.8,0.9-1.1,1.7-0.8c0.4,0.2,0.8,0.5,1.1,1.1c0.3,0.5,0.4,1,0.2,1.4
		l-0.4,0.9l-6.9-3c-1.7-0.7-2.1-2-1.4-3.7c0.8-1.8,2-2.3,3.7-1.6l4.4,1.9c1,0.5,1.8,0.2,2.2-0.9c0.4-1,0.1-1.8-0.9-2.2l-3.6-1.6
		c-0.4-0.2-0.9,0.1-1.3,0.9c-0.6-1-1.2-1.8-1.9-2.4l0.7-0.5c0.3-0.2,0.5-0.4,0.7-0.7c0.1-0.1,0.1-0.3,0.1-0.4
		c0.6,0.2,0.8,0.5,0.8,0.8c0,0.1,0,0.1-0.1,0.2c-0.1,0.2-0.3,0.5-0.7,0.7l0.6,0.7c0.5-0.5,1-0.6,1.6-0.3l3.6,1.6
		c1.7,0.7,2.2,1.9,1.4,3.6c-0.7,1.7-1.9,2.1-3.6,1.4l-4.4-1.9c-1-0.5-1.8-0.1-2.3,1c-0.5,1.1-0.2,1.9,0.8,2.4L45,193.9z M46.2,194.4
		l0.9,0.4c0.1-0.2,0-0.4-0.2-0.6c-0.2-0.2-0.4-0.4-0.6-0.5c-0.2-0.1-0.3,0-0.4,0.2C45.9,194.2,45.9,194.3,46.2,194.4z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M47.2,177.1c-0.3,0.5-0.7,1-1.4,1.4l-0.6,0.3l0.2,0.9c0.1,0.1,0.5,0,1-0.3l-0.2,1c-0.4,0.3-0.7,0.4-1,0.3
		l-0.3-0.2c-0.2-0.1-0.3-0.3-0.3-0.6l-0.1-0.5c-0.1-0.6-0.2-1-0.1-1.1c0-0.1,0.3-0.3,0.9-0.7c0.6-0.4,0.9-0.7,1-0.9
		c0.5-1,0.3-1.7-0.4-2c-0.6-0.3-1.2,0.1-1.8,1.3c-0.5-0.2-0.5-0.6-0.3-1.2c0.6-1.2,1.4-1.6,2.5-1.1C47.7,174.4,48,175.5,47.2,177.1z
		 M53.3,177.1c1.6,0.8,2,2.1,1.1,4c-0.9,1.8-2.2,2.4-3.8,1.6l-2.4-1.2c-0.1,0.3-0.4,0.3-0.9,0.1c-0.8-0.4-1-0.9-0.7-1.5
		c0.1-0.2,0.4-0.3,0.8-0.1l3.6,1.8c1,0.5,1.8,0.1,2.4-1.1c0.6-1.2,0.4-2.1-0.7-2.6l-2.2-1c-0.2,0.4-0.6,0.5-1.2,0.2
		c-0.7-0.3-0.8-0.8-0.5-1.4c0.2-0.4,0.5-0.5,0.9-0.3L53.3,177.1z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M56.7,184.1c-0.2,0.4-0.5,0.7-0.8,0.8c-0.3,0.1-0.6,0.1-1-0.1c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.2,0-0.5,0.2-0.8
		l0.6,0.3c0.2,0.1,0.3,0,0.4-0.2c0,0,0-0.1,0-0.1l1.2-3.1l-1.2-0.6l0.5-0.9l1.2,0.6c0.2-0.4,0.5-0.6,0.8-0.7c0.4-0.1,0.7,0,1,0.1
		c0.3,0.2,0.5,0.4,0.5,0.6c0.1,0.3,0,0.6-0.2,0.9s-0.4,0.6-0.7,0.6c-0.3,0.1-0.6,0-1.1-0.2l-1.1,2.8l0,0c0,0.1-0.1,0.1-0.1,0.2
		C56.7,184,56.7,184,56.7,184.1z M58.9,179.7c-0.2-0.1-0.4,0-0.6,0.3c0.3,0.2,0.5,0.2,0.6,0l0,0C59.1,179.9,59,179.8,58.9,179.7z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M42.9,176.6c-0.5,1-1.2,1.3-2,0.9c-1-0.5-1.2-1.4-0.5-2.7c0.4-0.8,1.1-1.4,2.1-1.8c0.1,0,0.1-0.1,0.2-0.1
		L41,172l0.5-0.9l3.4,1.7L42.9,176.6z M42,176.1l1.2-2.4c-0.8,0.2-1.4,0.7-1.8,1.5c-0.3,0.6-0.3,1,0,1.2
		C41.6,176.5,41.8,176.4,42,176.1z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M51.4,172.2c-0.4-0.2-0.9,0.1-1.4,0.8c-0.5-1-1.1-1.9-1.8-2.5l0.8-0.4c0.3-0.2,0.6-0.4,0.7-0.6
		c0.1-0.1,0.1-0.2,0.1-0.4c0.5,0.3,0.8,0.6,0.7,0.9c0,0.1,0,0.1-0.1,0.2c-0.1,0.2-0.4,0.4-0.7,0.7l0.5,0.7c0.5-0.4,1.1-0.5,1.6-0.2
		l3,1.6l0.2-0.3c0.2-0.4,0.6-0.5,1.2-0.2c0.4,0.2,1,0.8,1.7,1.9l-0.5,1L51.4,172.2z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M53.8,164.4c-0.3,0.5-0.8,1-1.5,1.3l-0.6,0.3l0.1,0.9c0.1,0.1,0.5,0,1-0.2l-0.3,1c-0.4,0.3-0.8,0.4-1,0.2
		l-0.3-0.2c-0.1-0.1-0.2-0.3-0.3-0.7l0-0.5c-0.1-0.6-0.1-1-0.1-1.1c0.1-0.1,0.4-0.3,0.9-0.6c0.6-0.4,0.9-0.6,1.1-0.9
		c0.5-1,0.4-1.6-0.3-2c-0.6-0.3-1.2,0.1-1.9,1.2c-0.4-0.2-0.5-0.6-0.2-1.2c0.7-1.2,1.5-1.5,2.6-0.9
		C54.5,161.7,54.7,162.8,53.8,164.4z M56.2,162.8c0.1,0,0.2,0,0.4,0.1l3.3,1.8c1.6,0.9,1.9,2.2,0.9,4s-2.3,2.2-3.9,1.3l-2.3-1.3
		c-0.2,0.3-0.5,0.3-0.9,0.1c-0.8-0.4-1-1-0.6-1.6c0.1-0.2,0.4-0.2,0.8,0l3.5,2c1,0.6,1.8,0.2,2.5-1s0.5-2.1-0.5-2.6l-2.1-1.2
		c-0.2,0.4-0.6,0.4-1.2,0.1c-0.6-0.3-0.9-0.7-0.8-1.2l-1.2-3.7l2.5-1.3c0.3-0.2,0.6-0.2,1,0l6.9,3.8l-0.5,0.9l-6.9-3.8l-1.7,0.9
		L56.2,162.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M62.4,172.3c-0.2,0.4-0.5,0.6-0.8,0.7c-0.3,0.1-0.7,0-1-0.2c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.2,0.1-0.5,0.2-0.8
		l0.6,0.3c0.2,0.1,0.3,0,0.4-0.2c0,0,0-0.1,0-0.1l1.4-3l-1.2-0.7l0.5-0.9l1.2,0.7c0.2-0.4,0.5-0.6,0.9-0.7c0.4-0.1,0.7,0,1,0.2
		c0.3,0.2,0.5,0.4,0.5,0.6c0,0.3,0,0.6-0.2,0.9c-0.2,0.3-0.5,0.5-0.7,0.6c-0.3,0.1-0.6,0-1-0.3l-1.3,2.7l0,0c0,0.1-0.1,0.1-0.1,0.2
		C62.4,172.2,62.4,172.3,62.4,172.3z M64.9,168.1c-0.2-0.1-0.4,0-0.6,0.3c0.3,0.2,0.5,0.2,0.6,0l0,0
		C65.1,168.3,65.1,168.2,64.9,168.1z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M63.6,151.8c-0.4-0.3-0.7-0.3-1-0.3c-0.2,0.1-0.4,0.2-0.6,0.3c0,0.8-0.2,1.4-0.5,1.9c-0.4,0.7-0.9,1.1-1.3,1.3
		c-0.5,0.2-1,0.1-1.5-0.2c-0.3-0.2-0.6-0.5-0.8-0.9c-0.2-0.4-0.4-0.7-0.7-0.8c-0.4-0.2-0.8-0.1-1.1,0.5c-0.4-0.2-0.5-0.6-0.2-0.9
		c0.5-0.8,1.1-0.9,1.9-0.4c0.3,0.2,0.5,0.4,0.7,0.9c0.2,0.4,0.5,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.7,0c0.3-0.1,0.5-0.4,0.7-0.7
		c0.2-0.4,0.4-0.8,0.4-1c-0.4,0.2-0.8,0.2-1.1,0c-0.7-0.4-0.8-1-0.4-1.7c0.4-0.7,1-0.8,1.7-0.4c0.3,0.2,0.5,0.5,0.6,0.9
		c0.1-0.1,0.2-0.1,0.3-0.2c0.6-0.3,1.2-0.3,1.9,0.2l5.2,3.2l-0.5,0.9l-2.8,0.7l0.6,2.8l-0.5,0.9l-3.5-2.2c-0.2,0.4-0.6,0.4-1.2,0.1
		c-0.6-0.4-0.8-0.9-0.4-1.4l0.4-0.6l4,2.5l-0.6-2.8l2.8-0.7L63.6,151.8z M60.9,150.7c-0.2-0.1-0.4-0.1-0.5,0.1
		c-0.2,0.3-0.1,0.5,0.1,0.6c0.1,0.1,0.4,0.1,0.7-0.1C61.1,151.1,61.1,150.8,60.9,150.7z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M232.2,31.3l-0.3-1c-0.1-0.5-0.6-0.6-1.5-0.5c0.4-1.1,0.7-2.1,0.7-3l0.8,0.3c0.4,0.1,0.7,0.2,0.9,0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0.6,0.1,1-0.2,1.1c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.6,0-1-0.1l-0.2,0.8c0.7,0.1,1.1,0.5,1.2,1.1
		l1.6,6.5l-1.1,0.3c-0.8-0.9-1.3-1.6-1.4-2c-0.2-0.6,0-1,0.4-1.1l0.3-0.1l-0.3-1.3l-4,1l1.1,4.4l-1.1,0.3c-0.8-0.9-1.3-1.6-1.4-2
		c-0.2-0.6,0-1,0.4-1.1l0.3-0.1l-0.8-3.3c-0.1-0.5-0.6-0.6-1.5-0.5c0.4-1.1,0.7-2.1,0.7-3l0.8,0.3c0.4,0.1,0.7,0.2,0.9,0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0.6,0.1,1-0.2,1.1c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.6,0-1-0.1l-0.2,0.8c0.7,0.1,1.1,0.5,1.2,1.1
		l0.3,1L232.2,31.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M231,41.2c-1.1,0.3-1.8-0.1-2-0.9c-0.2-0.9,0.2-1.5,1.4-1.7l2.1-0.5l-0.2-0.7l1-0.2l0.2,0.7l2.3-0.5l0.2,1
		l-2.3,0.5l0.2,0.7c0.2,0,0.4,0,0.5,0.1s0.2,0.3,0.3,0.6c0.1,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.3,0.3-0.6,0.3c-0.3,0.1-0.5,0-0.7-0.1
		c-0.2-0.1-0.3-0.3-0.3-0.5C232.5,40.8,231.9,41,231,41.2z M230.1,40c0,0.2,0.3,0.2,0.7,0.1l2.1-0.5l-0.2-0.7l-2.1,0.5
		C230.2,39.6,230,39.8,230.1,40z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M235.3,27.3c0.5-0.6,0.9-1,1.1-1.3c0.2-0.3,0.4-0.5,0.6-0.5c0.1,0,0.3,0,0.6,0.1l0.4,0.1l0.9,0.3l0.5-0.6
		l0.3-0.3c0.2-0.2,0.3-0.3,0.5-0.3c0.1,0,0.3,0,0.5,0.1l0.3,0.2c0.4,0.2,1,0.4,1.7,0.6c-0.2,0.5-0.5,0.8-0.7,0.8c-0.1,0-0.1,0-0.2,0
		c-0.3-0.1-0.8-0.3-1.4-0.6l-1.2,1.3l-1.8-0.7l-0.7,0.8l0.4,0.5l-0.5,0.5l-1.1-0.6L235.3,27.3z M243.8,34.5l-1,0.2l-1-4.7
		c-0.2-1.1-1-1.5-2.4-1.3c-1.3,0.3-1.9,1-1.7,2.1l1,4.7l-1,0.2l-1-4.7c-0.4-1.8,0.4-2.9,2.4-3.3c2-0.4,3.2,0.3,3.6,2L243.8,34.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M251.1,27.5l-0.2-1.1c-0.1-0.5-0.6-0.7-1.5-0.6c0.5-1,0.8-2,0.9-2.9l0.8,0.4c0.4,0.2,0.7,0.2,0.9,0.2
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0.6,0,1-0.2,1.1c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0-0.6,0-1-0.2l-0.2,0.8c0.6,0.2,1,0.5,1.1,1.2l1.1,6.6
		L252,33c-0.8-0.9-1.2-1.6-1.3-2.1c-0.1-0.6,0.1-1,0.5-1.1l0.3-0.1l-0.2-1.3l-4,0.7l0.8,4.5l-1.1,0.2c-0.8-0.9-1.2-1.6-1.3-2.1
		c-0.1-0.6,0.1-1,0.5-1.1l0.3-0.1l-0.6-3.3c-0.1-0.5-0.6-0.7-1.5-0.6c0.5-1,0.8-2,0.9-2.9l0.8,0.4c0.4,0.2,0.7,0.2,0.9,0.2
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0.6,0,1-0.2,1.1c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0-0.6,0-1-0.2l-0.2,0.8c0.6,0.2,1,0.5,1.1,1.2l0.2,1.1
		L251.1,27.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M255.4,24.9c-0.2-1.8,0.6-2.8,2.7-3.1c2-0.3,3.2,0.5,3.4,2.3l0.1,0.4c0,0.2,0,0.3-0.1,0.5
		c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.2-0.4
		c0-0.2,0-0.3,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.1,0.3-0.1c-0.3-0.8-1-1.1-2.1-1c-1.4,0.2-2,0.8-1.8,2
		c0.1,0.8,1.1,1.5,2.9,2l2.7,0.8l0.3,1.9c0.2,1.4-0.3,2.1-1.4,2.3c-0.6,0.1-1.2-0.1-1.7-0.6s-1.2-0.7-1.8-0.6l0.2,1.7l-1,0.1
		l-0.6-4.1l1-0.1l0.2,1.4c0.8-0.1,1.5,0.1,2.1,0.6c0.6,0.5,1.1,0.7,1.5,0.7c0.5-0.1,0.7-0.4,0.6-1.1l-0.2-1.3l-2.1-0.6
		C256.7,27.1,255.5,26.1,255.4,24.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M262.6,32.9l0.4,3.1l-1,0.1l-0.3-2.4c-0.4,0-0.6-0.2-0.6-0.6c-0.1-0.5,0.2-0.7,0.7-0.8
		C262.2,32.2,262.5,32.4,262.6,32.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M266.7,20.7c0.1,0.9,0,1.4-0.3,1.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.5,0-0.8-0.2l-0.2,0.8
		c0.7,0.2,1.1,0.6,1.1,1.2l0.7,6.6l-1.2,0.1c-0.7-1-1.1-1.7-1.1-2.2c-0.1-0.6,0.1-1,0.6-1l0.3,0l-0.4-3.4c-0.1-0.5-0.5-0.7-1.4-0.7
		c0.5-1,0.8-1.9,0.8-2.8l0.9,0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.2,0.2-0.6c0-0.4-0.2-0.7-0.4-0.9s-0.7-0.3-1.3-0.2
		c0.2-0.5,0.5-0.8,0.9-0.8c0.4,0,0.8,0.1,1.2,0.3C266.4,19.4,266.6,19.9,266.7,20.7z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M268.7,22c0.6-0.5,1-0.9,1.3-1.2c0.3-0.3,0.5-0.5,0.6-0.5c0.1,0,0.3,0,0.6,0.2l0.4,0.2l0.8,0.4l0.6-0.5
		l0.3-0.3c0.2-0.2,0.4-0.3,0.5-0.3c0.1,0,0.3,0.1,0.5,0.2l0.3,0.2c0.4,0.3,0.9,0.5,1.6,0.8c-0.3,0.5-0.5,0.7-0.8,0.7
		c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.8-0.4-1.4-0.8l-1.4,1.1l-1.7-0.9l-0.8,0.7l0.3,0.5l-0.6,0.4l-1-0.7L268.7,22z M270.9,27.2
		c0.1,0,0.2,0,0.3-0.1c0.9-0.1,1.4,0.3,1.5,1.1c0,0.5-0.1,1-0.4,1.5c-0.3,0.5-0.7,0.8-1.1,0.8l-1,0.1l-0.4-4.8
		c-0.2-1.8,0.8-2.8,2.8-3s3.1,0.7,3.3,2.5l0.4,4.8l-1,0.1l-0.4-4.8c-0.1-1.1-0.8-1.6-2.2-1.5c-1.4,0.1-2,0.7-1.9,1.9L270.9,27.2z
		 M271.1,29.5c0.2,0,0.3-0.2,0.4-0.5c0.1-0.3,0.2-0.5,0.1-0.8c0-0.2-0.1-0.3-0.4-0.2s-0.3,0.2-0.3,0.4L271.1,29.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M271.6,33l0.2,0c0.6,0,1,0.2,1,0.8c0,0.7-0.3,1-1.1,1.1l-1,0.1l-0.1-1.9c-0.1-1.2,0.8-1.9,2.6-2
		c1.8-0.1,2.8,0.4,2.8,1.7l0.1,1.9l-1,0.1l-0.1-1.9c0-0.5-0.6-0.8-1.8-0.7C272.1,32.1,271.6,32.5,271.6,33z M271.6,33.7l0,0.5
		c0.3,0,0.5-0.1,0.5-0.4c0-0.1-0.1-0.2-0.3-0.2L271.6,33.7z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M284.6,27.3l-2.7,2.5l-1.7-1c-0.3-0.2-0.5-0.4-0.5-0.6c0-0.2,0.1-0.4,0.4-0.7l3.5-3.2c0.6-0.6,0.8-1.3,0.8-2.2
		c0-0.5-0.3-0.9-1-1.3l-1.1,0.9l-1.2-0.8c-0.6,0.5-0.9,1-0.9,1.4c0,0.7,0.4,1,1,1c0.4,0,0.6-0.1,0.6-0.4c0-0.4,0.1-0.6,0.5-0.6
		c0.3,0,0.5,0.2,0.5,0.5c0,0.9-0.5,1.4-1.6,1.4c-1.3,0.1-2-0.6-2-2c0-0.5,0.1-1,0.4-1.4l1.2-1.5l1.3,1l1.3-1.2l1.4,1.3
		c0.3,0.4,0.5,0.8,0.5,1.3c0.1,1.2-0.3,2.2-1,2.9l-3.3,3.1l0.7,0.4l2.1-1.9c0.5-0.4,0.7-0.8,0.7-1l1,0l0.2,4.1l-1,0L284.6,27.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M281.1,17.5c-1.1,0-1.7-0.4-1.7-1.3c0-1.1,0.7-1.7,2.1-1.8c0.9,0,1.8,0.3,2.6,1c0.1,0,0.1,0.1,0.2,0.1
		l-0.1-1.9l1,0l0.1,3.8L281.1,17.5z M281,16.5l2.7-0.1c-0.6-0.6-1.3-0.9-2.2-0.8c-0.7,0-1,0.2-1,0.6C280.5,16.4,280.7,16.5,281,16.5
		z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M292.4,21.3c-0.6,0-1.2-0.2-1.8-0.6l-0.6-0.4l-0.7,0.5c0,0.2,0.2,0.4,0.7,0.7l-1,0.3c-0.5-0.2-0.7-0.5-0.7-0.7
		l0-0.4c0-0.2,0.1-0.4,0.4-0.6l0.4-0.3c0.5-0.4,0.8-0.6,1-0.6c0.1,0,0.4,0.2,1,0.5c0.6,0.3,1,0.5,1.3,0.5c1.1,0,1.6-0.4,1.6-1.3
		c0-0.7-0.7-1-2-1c0-0.5,0.3-0.8,0.9-0.8c1.4,0,2.1,0.6,2.1,1.8C295,20.5,294.2,21.3,292.4,21.3z M294,22.3l1,0l0.1,7.2l-1,0l-2.1-2
		l-2,2l-1,0l-0.1-5.4c-0.3,0-0.5-0.2-0.5-0.7c0-0.9,0.3-1.3,1.1-1.3c0.3,0,0.4,0.2,0.4,0.7l0.1,5.4l2-2l2.1,2L294,22.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M291,17.2c-1.1,0-1.7-0.5-1.7-1.4c0-1.1,0.7-1.7,2.2-1.7c0.9,0,1.8,0.4,2.5,1c0.1,0,0.1,0.1,0.2,0.2l0-1.9l1,0
		l0,3.8L291,17.2z M291,16.1l2.7,0c-0.5-0.6-1.3-0.9-2.2-0.9c-0.7,0-1,0.2-1,0.5C290.4,16,290.6,16.1,291,16.1z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M302.1,21.4c-0.6,0-1.2-0.2-1.8-0.7l-0.5-0.4l-0.8,0.5c0,0.1,0.2,0.4,0.7,0.7l-1,0.2c-0.4-0.2-0.7-0.5-0.7-0.8
		l0-0.4c0-0.2,0.2-0.3,0.5-0.5l0.5-0.3c0.5-0.4,0.8-0.6,1-0.6c0.1,0,0.4,0.2,1,0.5c0.6,0.4,1,0.5,1.3,0.5c1.1,0,1.6-0.4,1.7-1.2
		c0-0.7-0.6-1.1-2-1.1c0-0.5,0.3-0.7,1-0.7c1.4,0,2,0.7,2,1.9C304.8,20.7,303.9,21.4,302.1,21.4z M304.7,26.9c0,1.8-1.1,2.7-3.1,2.7
		c-2,0-3-1-3-2.8l0.1-2.7c-0.3,0-0.5-0.3-0.5-0.8c0-0.9,0.4-1.3,1.1-1.3c0.3,0,0.4,0.2,0.4,0.7l-0.1,4c0,1.1,0.6,1.7,2,1.8
		c1.4,0,2.1-0.5,2.1-1.7l0.1-2.4c-0.5,0-0.7-0.3-0.7-1c0-0.7,0.4-1.1,1-1.1c0.5,0,0.7,0.2,0.7,0.7L304.7,26.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M309.2,26.4c0.1,0,0.2,0,0.3,0c0.9,0.1,1.3,0.5,1.3,1.3c0,0.5-0.2,0.9-0.6,1.4c-0.4,0.5-0.8,0.7-1.2,0.7
		l-1-0.1l0.5-7.5c0.1-1.8,1.1-2.7,3.1-2.5s2.8,1.1,2.7,2.9l-0.3,4.8c-0.1,1.1,0.5,1.7,1.6,1.8c1.1,0.1,1.7-0.5,1.8-1.6l0.3-3.9
		c0-0.5-0.4-0.8-1.3-1c0.8-0.9,1.3-1.8,1.6-2.6l0.7,0.5c0.3,0.2,0.6,0.4,0.9,0.4c0.1,0,0.3,0,0.4-0.1c0,0.6-0.2,0.9-0.5,1
		c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5-0.1-0.9-0.4l-0.4,0.7c0.6,0.3,0.9,0.8,0.8,1.4l-0.3,3.9c-0.1,1.8-1.1,2.7-2.9,2.5
		c-1.8-0.1-2.7-1.1-2.5-2.9l0.3-4.8c0.1-1.1-0.5-1.7-1.8-1.8c-1.2-0.1-1.9,0.4-2,1.6L309.2,26.4z M309.1,27.8l-0.1,1
		c0.2,0,0.4-0.1,0.5-0.4c0.2-0.3,0.2-0.5,0.3-0.7c0-0.2-0.1-0.3-0.3-0.3C309.2,27.4,309.1,27.5,309.1,27.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M328.3,24.5l-0.8,6.9l-1-0.1l-1.8-2.2l-2.3,1.7l-1-0.1l0.6-5.4c-0.3,0-0.4-0.3-0.4-0.8
		c0.1-0.9,0.5-1.2,1.2-1.2c0.3,0,0.4,0.3,0.3,0.7l-0.6,5.3l2.3-1.7l1.8,2.2l0.7-5.9l3-2.5l2.2,1.8c0.3,0.2,0.4,0.5,0.3,0.9l-0.9,7.8
		l-1-0.1l0.9-7.8l-1.5-1.2L328.3,24.5z M325.8,23c-0.6-0.1-1.2-0.4-1.7-0.9l-0.5-0.4l-0.8,0.4c0,0.1,0.2,0.4,0.6,0.8l-1,0.1
		c-0.4-0.3-0.6-0.6-0.6-0.8l0-0.4c0-0.2,0.2-0.3,0.5-0.5l0.5-0.2c0.5-0.3,0.9-0.5,1-0.5c0.1,0,0.4,0.2,0.9,0.6
		c0.5,0.4,1,0.6,1.2,0.7c1.1,0.1,1.7-0.2,1.8-1.1c0.1-0.7-0.5-1.1-1.8-1.3c0.1-0.5,0.4-0.7,1-0.6c1.4,0.2,2,0.8,1.8,2
		C328.5,22.6,327.6,23.2,325.8,23z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M335.8,34.7c-0.1,0.9,0.3,1.4,1.5,1.6c1.1,0.2,1.8-0.2,1.9-1.1l0.2-1.1l1,0.2l-0.2,1.1
		c-0.3,1.6-1.3,2.2-3.1,1.9s-2.6-1.2-2.3-2.8l1.4-8.6c0.1-0.5-0.3-0.8-1.2-1.1c0.8-0.8,1.4-1.6,1.8-2.5l0.6,0.6
		c0.3,0.3,0.6,0.4,0.8,0.5c0.1,0,0.3,0,0.4,0c-0.1,0.6-0.3,0.9-0.6,1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5-0.2-0.8-0.5l-0.5,0.7
		c0.6,0.4,0.8,0.9,0.7,1.5L335.8,34.7z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M345.7,27.5c0.1-0.5-0.3-0.8-1.2-1.1c0.8-0.8,1.5-1.6,1.9-2.4l0.6,0.6c0.3,0.3,0.6,0.4,0.8,0.5
		c0.1,0,0.3,0,0.4,0c-0.1,0.6-0.3,0.9-0.6,0.9c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5-0.2-0.8-0.5l-0.5,0.7c0.6,0.4,0.8,0.9,0.7,1.5
		l-0.7,3.9c-0.3,1.8-1.5,2.5-3.5,2.2c-2-0.4-2.9-1.4-2.5-3.2l0.7-3.9c0.1-0.5-0.3-0.8-1.2-1.1c0.8-0.8,1.5-1.6,1.9-2.4l0.6,0.6
		c0.3,0.3,0.5,0.4,0.8,0.5c0.1,0,0.3,0,0.4,0c-0.1,0.6-0.3,0.9-0.6,0.9c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5-0.2-0.8-0.5l-0.5,0.7
		c0.6,0.4,0.8,0.9,0.7,1.5l-0.7,3.9c-0.2,1.1,0.4,1.8,1.7,2c1.3,0.2,2.1-0.2,2.3-1.3L345.7,27.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M355.3,33.5c-0.4,1.8-1.6,2.4-3.6,2c-2-0.4-2.8-1.6-2.4-3.3l0.6-2.6c-0.3-0.1-0.4-0.3-0.3-0.8
		c0.2-0.8,0.6-1.2,1.3-1c0.3,0.1,0.3,0.3,0.2,0.8l-0.9,3.9c-0.2,1.1,0.3,1.8,1.6,2.1c1.3,0.3,2.1-0.1,2.4-1.2l0.5-2.3
		c-0.4-0.1-0.6-0.5-0.5-1.1c0.2-0.7,0.6-1,1.2-0.8c0.4,0.1,0.6,0.4,0.5,0.8L355.3,33.5z M350,26.3l1.5-0.5l0.7-0.3
		c0.5-0.2,0.9-0.2,1-0.2c0.2,0,0.5,0.2,0.8,0.4l0.5,0.4l1,0.7l1-0.2l0.5-0.1c0.3-0.1,0.6-0.1,0.8-0.1c0.2,0,0.4,0.2,0.7,0.4l0.4,0.3
		l1.1,0.9c0.5,0.5,0.7,1,0.6,1.8l-1.6,7.3l-1-0.2l1.6-7.3c0.1-0.3,0-0.6-0.2-0.7l-1.8-1.5l-2.4,0.5l-2.3-1.6l-1.8,0.6l0.1,0.6l-1,0
		l-0.5-1L350,26.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M360.9,23.4c-0.1,0.5-0.3,0.8-0.7,1s-0.7,0.2-1.2,0.1c-0.5-0.1-0.8-0.3-1-0.7c-0.2-0.3-0.2-0.7-0.1-1.2
		c0.1-0.5,0.3-0.8,0.7-1c0.3-0.2,0.7-0.2,1.2-0.1c0.5,0.1,0.8,0.3,1,0.7S361,22.9,360.9,23.4z M358.9,22.9c0,0.2,0,0.3,0,0.4
		s0.2,0.2,0.3,0.2c0.2,0,0.3,0,0.4,0c0.1-0.1,0.2-0.2,0.2-0.3c0-0.2,0-0.3,0-0.4c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2,0-0.3,0-0.4,0
		C359,22.6,358.9,22.7,358.9,22.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M536.8,170l0.9-0.5c0.4-0.2,0.5-0.8,0.1-1.6c1.1,0.2,2.2,0.2,3.1,0l-0.1,0.9c0,0.4,0,0.7,0.1,0.9
		c0.1,0.1,0.2,0.2,0.3,0.3c-0.5,0.3-0.9,0.3-1.1,0.1c-0.1,0-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.5-0.1-1l-0.9,0c0.1,0.7-0.2,1.1-0.7,1.4
		l-5.9,3.2l-0.5-1c0.6-1,1.2-1.6,1.6-1.9c0.6-0.3,1-0.3,1.2,0.1l0.2,0.3l1.1-0.6l-1.9-3.6l-4,2.2l-0.5-1c0.6-1,1.2-1.6,1.6-1.9
		c0.6-0.3,1-0.3,1.2,0.1l0.2,0.3l3-1.6c0.4-0.2,0.5-0.8,0.1-1.6c1.1,0.2,2.2,0.2,3.1,0l-0.1,0.9c0,0.4,0,0.7,0.1,0.9
		c0.1,0.1,0.2,0.2,0.3,0.3c-0.5,0.3-0.9,0.3-1.1,0.1c-0.1,0-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.5-0.1-1l-0.9,0c0.1,0.7-0.2,1.1-0.7,1.4
		l-0.9,0.5L536.8,170z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M527,171.3c-0.5-1-0.4-1.7,0.4-2.1c0.8-0.4,1.5-0.1,2,0.9l1,1.9l0.6-0.3l0.5,0.9l-0.6,0.3l1.1,2.1l-0.9,0.5
		l-1.1-2.1l-0.6,0.3c0.1,0.2,0.1,0.4,0,0.6c-0.1,0.2-0.2,0.3-0.5,0.4c-0.3,0.1-0.5,0.2-0.7,0.1c-0.2-0.1-0.4-0.2-0.5-0.5
		c-0.1-0.2-0.1-0.5-0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.4C527.7,172.6,527.4,172,527,171.3z M527.9,170c-0.2,0.1-0.2,0.3,0,0.7l1,1.9
		l0.6-0.3l-1-1.9C528.3,170.1,528.1,169.9,527.9,170z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M536.6,182l-0.5-0.9l4.3-2.1c1-0.5,1.2-1.4,0.6-2.6c-0.6-1.2-1.4-1.6-2.4-1.1l-4.3,2.1l-0.5-0.9l4.3-2.1
		c1.6-0.8,2.9-0.3,3.8,1.5c0.9,1.8,0.5,3.2-1.1,4L536.6,182z M541.5,172c0.7,0.3,1.2,0.6,1.6,0.7c0.4,0.2,0.6,0.3,0.7,0.4
		s0.1,0.3,0.1,0.6l0,0.5l-0.1,0.9l0.7,0.4l0.4,0.2c0.2,0.1,0.4,0.2,0.4,0.4c0.1,0.1,0.1,0.3,0,0.5L545,177c-0.1,0.5-0.2,1.1-0.1,1.8
		c-0.5-0.1-0.9-0.2-1-0.5c0-0.1,0-0.1-0.1-0.2c0-0.4,0.1-0.9,0.2-1.5l-1.5-0.8l0.2-1.9l-0.9-0.5l-0.4,0.5l-0.6-0.4l0.3-1.2
		L541.5,172z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M544.9,181.9c1.7-0.7,2.9-0.2,3.8,1.7c0.8,1.9,0.4,3.2-1.2,3.9l-0.4,0.2c-0.1,0.1-0.3,0.1-0.5,0.1
		c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.2-0.2,0.4-0.3
		c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.1,0.2,0.2c0.7-0.5,0.8-1.3,0.3-2.3c-0.6-1.2-1.4-1.6-2.4-1.2
		c-0.8,0.3-1.2,1.5-1.1,3.3l0,2.8l-1.8,0.8c-1.2,0.6-2.1,0.3-2.6-0.7c-0.2-0.5-0.2-1.2,0.1-1.8c0.3-0.7,0.3-1.3,0.1-1.9l-1.6,0.7
		L538,185l3.7-1.7l0.4,0.9l-1.2,0.6c0.3,0.7,0.3,1.5,0,2.2c-0.3,0.7-0.4,1.3-0.2,1.6c0.2,0.4,0.6,0.5,1.2,0.2l1.2-0.5l0-2.1
		C543.1,183.9,543.7,182.4,544.9,181.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M550.7,191.9c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.2-0.1-0.5-0.1-0.8l-0.8,0.1
		c0,0.7-0.3,1.2-0.9,1.4l-6.2,2.5l-0.4-1.1c0.7-0.9,1.4-1.5,1.8-1.7c0.6-0.2,1-0.2,1.1,0.3l0.1,0.3l3.1-1.3c0.4-0.2,0.5-0.7,0.3-1.6
		c1.1,0.2,2.1,0.2,2.9,0l-0.1,1c0,0.1,0,0.1,0,0.2c0.1,0.1,0.3,0.1,0.6,0c0.4-0.2,0.6-0.4,0.8-0.7c0.1-0.3,0.1-0.7-0.2-1.3
		c0.6,0.1,0.9,0.3,1.1,0.6c0.1,0.3,0.1,0.7,0,1.2c-0.1,0.5-0.6,0.8-1.3,1.1l0,0l0.1,0l-0.3,3.3c0,0.3-0.2,0.6-0.6,0.7l-7.3,3
		l-0.4-0.9l7.3-3l0.2-2.6L550.7,191.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M552.2,199.2c1.7-0.6,2.9,0,3.6,1.9c0.7,1.9,0.2,3.2-1.5,3.8l-0.4,0.2c-0.1,0.1-0.3,0.1-0.5,0
		c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.1-0.3,0-0.5s0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.4-0.3
		c0.1-0.1,0.3-0.1,0.5,0s0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.2,0.2,0.2c0.7-0.4,0.9-1.2,0.5-2.3c-0.5-1.3-1.2-1.7-2.3-1.3
		c-0.8,0.3-1.3,1.4-1.4,3.3l-0.2,2.8l-1.8,0.7c-1.3,0.5-2.1,0.2-2.5-0.9c-0.2-0.6-0.1-1.2,0.2-1.8c0.4-0.7,0.4-1.3,0.2-1.9l-1.6,0.6
		l-0.4-1l3.8-1.4l0.4,1l-1.3,0.5c0.3,0.7,0.2,1.5-0.1,2.2c-0.3,0.7-0.5,1.2-0.3,1.6c0.2,0.4,0.6,0.6,1.2,0.3l1.2-0.4l0.1-2.1
		C550.3,201,551,199.6,552.2,199.2z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M545.9,208l-2.9,1l-0.3-1l2.3-0.8c-0.1-0.3,0-0.6,0.5-0.7c0.4-0.2,0.7,0,0.9,0.5
		C546.5,207.5,546.3,207.8,545.9,208z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M558.7,209.4c-0.8,0.3-1.4,0.3-1.7,0c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.2-0.1-0.5,0-0.8l-0.8,0
		c0,0.7-0.4,1.2-0.9,1.4l-6.3,2.1l-0.4-1.1c0.8-0.9,1.4-1.4,1.9-1.6c0.6-0.2,1-0.1,1.1,0.3l0.1,0.3l3.2-1.1c0.5-0.2,0.6-0.7,0.4-1.6
		c1.1,0.3,2.1,0.3,2.9,0.2l-0.2,1c0,0.1,0,0.1,0,0.2c0,0.1,0.2,0.2,0.6,0c0.4-0.1,0.7-0.3,0.8-0.6c0.1-0.3,0.1-0.7-0.1-1.3
		c0.6,0.1,0.9,0.3,1,0.7c0.1,0.4,0.1,0.8-0.1,1.2C559.9,208.8,559.4,209.1,558.7,209.4z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M553.3,214.8c0,0.1,0.1,0.2,0.1,0.3c0.3,0.9,0,1.4-0.8,1.7c-0.5,0.1-1,0.1-1.5-0.1c-0.6-0.2-0.9-0.5-1.1-0.9
		l-0.3-1l4.6-1.4c1.7-0.5,2.9,0.2,3.5,2.1c0.6,2,0,3.2-1.7,3.7l-4.6,1.4l-0.3-1l4.6-1.4c1.1-0.3,1.4-1.2,1-2.5
		c-0.4-1.3-1.2-1.8-2.2-1.4L553.3,214.8z M551,215.5c0.1,0.2,0.2,0.3,0.5,0.3c0.3,0,0.6,0,0.8,0c0.2-0.1,0.2-0.2,0.2-0.4
		c-0.1-0.2-0.2-0.3-0.5-0.2L551,215.5z M557.9,211.6c0.6,0.4,1.1,0.8,1.4,1c0.4,0.2,0.5,0.4,0.6,0.5c0,0.1,0,0.3,0,0.6l-0.1,0.4
		l-0.2,0.9l0.6,0.5l0.3,0.2c0.2,0.2,0.3,0.3,0.4,0.4c0,0.1,0,0.3-0.1,0.5l-0.1,0.4c-0.2,0.5-0.3,1-0.4,1.7c-0.5-0.2-0.8-0.4-0.9-0.6
		c0-0.1,0-0.1,0-0.2c0-0.4,0.2-0.9,0.5-1.5l-1.4-1.1l0.5-1.9l-0.8-0.6l-0.4,0.4l-0.6-0.5l0.5-1.1L557.9,211.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M547.7,216.8l0.1,0.2c0.2,0.6,0,1-0.6,1.2c-0.7,0.2-1.1-0.1-1.3-0.8l-0.3-1l1.8-0.5c1.2-0.3,2,0.4,2.5,2.1
		c0.5,1.7,0.2,2.8-1,3.1l-1.8,0.5l-0.3-1l1.8-0.5c0.5-0.2,0.6-0.8,0.3-1.9S548.3,216.6,547.7,216.8z M547.1,217l-0.5,0.2
		c0.1,0.3,0.2,0.4,0.5,0.4c0.1,0,0.2-0.1,0.1-0.3L547.1,217z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M559.7,221.9c1.8-0.5,2.9,0.3,3.4,2.2c0.5,2-0.1,3.2-1.8,3.7l-0.4,0.1c-0.2,0-0.3,0-0.5,0
		c-0.2,0-0.3-0.1-0.4-0.2s-0.2-0.3-0.2-0.4c0-0.2,0-0.3,0-0.5c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0,0.5,0
		c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.8-0.4,1-1.1,0.7-2.3c-0.4-1.3-1.1-1.8-2.2-1.5c-0.8,0.2-1.4,1.3-1.6,3.1
		l-0.4,2.7l-1.9,0.5c-1.3,0.4-2.1,0-2.4-1.1c-0.2-0.6,0-1.2,0.4-1.8c0.4-0.6,0.5-1.3,0.4-1.9l-1.6,0.4l-0.3-1l4-1.1l0.3,1l-1.3,0.4
		c0.2,0.8,0.1,1.5-0.3,2.2s-0.6,1.2-0.5,1.5c0.1,0.5,0.5,0.6,1.2,0.4l1.2-0.3l0.3-2.1C557.7,223.6,558.5,222.3,559.7,221.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M566.6,223.8c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.2,0.1,0.3,0.2,0.3c0,0,0.1,0.1,0.2,0.4
		s0,0.5-0.1,0.5c-0.3,0.1-0.5,0-0.7-0.1c-0.2-0.2-0.3-0.5-0.4-0.9c-0.1-0.6-0.1-1,0-1.2c0.1-0.2,0.4-0.4,0.9-0.5
		c0.5-0.1,0.9-0.1,1.2,0.1c0.3,0.2,0.6,0.5,0.7,0.9c0.1,0.6,0.1,1-0.1,1.3c0.2,0.3,0.4,0.6,0.7,0.8c0.3,0.2,0.6,0.4,0.9,0.5l0,0.1
		c0,0.1-0.1,0.2-0.3,0.3c-0.2,0.1-0.3,0.2-0.4,0.2s-0.1,0-0.2,0c-0.3-0.1-0.6-0.3-0.9-0.5c-0.3-0.2-0.6-0.5-0.8-0.8
		c-0.1-0.1-0.2-0.3-0.2-0.4c0.2-0.4,0.3-0.7,0.2-1c-0.1-0.2-0.2-0.3-0.3-0.4C566.8,223.8,566.7,223.8,566.6,223.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M558.4,237.5l-3-2.2l0.6-1.8c0.1-0.3,0.3-0.5,0.5-0.6c0.2,0,0.4,0,0.7,0.2l3.8,2.8c0.7,0.5,1.4,0.6,2.3,0.4
		c0.4-0.1,0.8-0.5,1.1-1.2l-1.1-0.9l0.6-1.3c-0.6-0.5-1.1-0.7-1.5-0.6c-0.7,0.2-0.9,0.5-0.8,1.1c0.1,0.4,0.3,0.6,0.5,0.6
		c0.4-0.1,0.6,0,0.6,0.4c0.1,0.3-0.1,0.5-0.4,0.6c-0.9,0.2-1.5-0.2-1.7-1.3c-0.3-1.2,0.2-2,1.6-2.3c0.5-0.1,1-0.1,1.4,0.1l1.7,1
		l-0.8,1.5l1.4,1l-1.1,1.6c-0.3,0.4-0.7,0.6-1.2,0.7c-1.2,0.3-2.2,0.1-3-0.5l-3.7-2.7l-0.3,0.8l2.2,1.7c0.5,0.4,0.9,0.5,1.1,0.5
		l0.2,1l-4,0.9l-0.2-1L558.4,237.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M567.4,232.3c-0.2-1.1,0.1-1.8,1-2c1.1-0.2,1.8,0.3,2.1,1.8c0.2,0.9,0,1.8-0.5,2.7c0,0.1-0.1,0.1-0.1,0.2
		l1.8-0.4l0.2,1l-3.7,0.8L567.4,232.3z M568.4,232l0.6,2.6c0.5-0.7,0.6-1.4,0.4-2.3c-0.1-0.7-0.4-1-0.8-0.9
		C568.4,231.5,568.3,231.7,568.4,232z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M565,245.9l0.2,1l-7,1.4l-0.2-1l1.6-2.4l-2.4-1.6l-0.2-1l5.3-1c-0.1-0.3,0.2-0.5,0.6-0.6
		c0.8-0.2,1.3,0.1,1.5,0.8c0.1,0.3-0.1,0.4-0.6,0.5l-5.3,1l2.4,1.6l-1.6,2.4L565,245.9z M565.7,244.1c-0.1-0.6,0-1.2,0.3-1.9
		l0.3-0.6l-0.7-0.6c-0.1,0-0.3,0.3-0.6,0.8l-0.4-1c0.1-0.5,0.3-0.8,0.6-0.8l0.4-0.1c0.2,0,0.4,0.1,0.6,0.3l0.4,0.4
		c0.5,0.4,0.8,0.7,0.8,0.8c0,0.1-0.1,0.5-0.3,1.1c-0.2,0.6-0.3,1.1-0.2,1.4c0.2,1.1,0.7,1.5,1.6,1.4c0.7-0.1,0.9-0.9,0.6-2.1
		c0.5-0.1,0.8,0.2,0.9,0.8c0.3,1.3-0.2,2.1-1.4,2.4C567,246.5,566.1,245.8,565.7,244.1z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M569.5,241.9c-0.2-1.1,0.1-1.8,1-1.9c1.1-0.2,1.8,0.4,2.1,1.8c0.2,0.9,0,1.8-0.6,2.7c0,0.1-0.1,0.1-0.1,0.2
		l1.8-0.3l0.2,1l-3.7,0.7L569.5,241.9z M570.5,241.7l0.5,2.6c0.5-0.6,0.7-1.4,0.5-2.3c-0.1-0.7-0.4-1-0.7-0.9
		C570.6,241.2,570.5,241.4,570.5,241.7z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M562.5,257.2c-1.8,0.3-2.9-0.6-3.2-2.6s0.4-3.2,2.2-3.5l2.6-0.4c-0.1-0.3,0.2-0.5,0.7-0.6
		c0.9-0.1,1.3,0.2,1.5,0.9c0,0.3-0.2,0.4-0.6,0.5l-4,0.6c-1.1,0.2-1.6,0.9-1.4,2.3c0.2,1.3,0.9,1.9,2,1.7l2.4-0.4
		c-0.1-0.4,0.2-0.7,0.8-0.8c0.7-0.1,1.1,0.2,1.2,0.8c0.1,0.4-0.1,0.7-0.6,0.8L562.5,257.2z M567.4,253.7c-0.1-0.6,0-1.2,0.3-1.9
		l0.3-0.6l-0.6-0.7c-0.1,0-0.4,0.3-0.6,0.8l-0.4-1c0.2-0.5,0.4-0.8,0.6-0.8l0.4-0.1c0.2,0,0.4,0.1,0.6,0.4l0.4,0.4
		c0.5,0.4,0.7,0.7,0.7,0.9c0,0.1-0.1,0.5-0.4,1.1c-0.2,0.6-0.3,1.1-0.3,1.4c0.2,1.1,0.7,1.5,1.5,1.4c0.7-0.1,0.9-0.8,0.7-2.1
		c0.5-0.1,0.8,0.2,0.9,0.8c0.2,1.3-0.3,2.1-1.5,2.3C568.6,256.2,567.7,255.4,567.4,253.7z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M563.7,261.5c0,0.1,0.1,0.2,0.1,0.3c0.1,0.9-0.2,1.4-1.1,1.5c-0.5,0.1-1-0.1-1.5-0.4c-0.5-0.3-0.8-0.7-0.9-1.1
		l-0.1-1l7.5-0.9c1.8-0.2,2.8,0.6,3.1,2.6s-0.6,3-2.4,3.2l-4.8,0.6c-1.1,0.1-1.6,0.8-1.5,1.9c0.1,1.1,0.8,1.6,1.9,1.5l3.9-0.5
		c0.5-0.1,0.7-0.5,0.7-1.5c1,0.6,2,0.9,2.9,1.1l-0.4,0.8c-0.2,0.3-0.3,0.7-0.2,0.9c0,0.1,0.1,0.3,0.1,0.4c-0.6,0.1-1,0-1.1-0.3
		c0-0.1-0.1-0.1-0.1-0.2c0-0.2,0-0.6,0.2-0.9l-0.8-0.3c-0.2,0.6-0.6,1-1.2,1.1l-3.9,0.5c-1.8,0.2-2.8-0.6-3-2.4s0.6-2.8,2.4-3
		l4.8-0.6c1.1-0.1,1.6-0.8,1.5-2.1c-0.1-1.2-0.8-1.8-1.9-1.7L563.7,261.5z M562.4,261.7l-1,0.1c0,0.2,0.2,0.3,0.5,0.4
		c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.3-0.1,0.2-0.4C562.8,261.7,562.7,261.6,562.4,261.7z"/>
</g>
  );

  const russianLevels = (
    <g className="meter-lvls-eng-uz">
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M20.1,324.4l3.8-0.3l-0.4-4.3l-3.8,0.3l-0.1-1.2l9-0.8l0.1,1.2l-4.2,0.4l0.4,4.3l4.2-0.4l0.1,1.2l-9,0.8
L20.1,324.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M24.8,310.5c2.4-0.1,3.5,1.5,3.6,3c0.1,1.7-1.1,3.2-3.1,3.3c-2.2,0.1-3.5-1.2-3.6-3
C21.6,312,22.8,310.6,24.8,310.5z M25.2,315.6c1.4-0.1,2.4-1,2.4-2.1c-0.1-1.1-1.2-1.9-2.6-1.8c-1.1,0.1-2.5,0.7-2.4,2.1
C22.6,315.2,24,315.7,25.2,315.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M21.7,309.1c-0.1-0.5-0.2-1.3-0.2-2.1c0-1.1,0.1-2.9,1.5-2.9c0.8,0,1.3,0.6,1.5,1.3l0,0c0.1-1,0.6-1.7,1.6-1.7
c1.7-0.1,2,2.1,2,3.3c0,0.7,0,1.5,0,1.8L21.7,309.1z M24.3,307.9l0-0.9c0-0.9-0.3-1.8-1.1-1.7c-0.6,0-0.9,0.6-0.9,1.8
c0,0.4,0,0.6,0.1,0.9L24.3,307.9z M27.2,307.8c0-0.3,0-0.6,0-0.9c0-0.8-0.2-2-1.2-1.9c-0.9,0-1.1,1-1.1,2.1l0,0.9L27.2,307.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M21.4,301.3l2.7,0c1,0,1.7,0,2.6,0l0,0c-0.8-0.4-1.3-0.6-2-1l-3.4-2l0-1.4l6.5-0.1l0,1.1l-2.7,0
c-1.1,0-1.6,0-2.7,0l0,0c0.8,0.4,1.4,0.7,2,1c1,0.6,2.3,1.3,3.4,2l0,1.3l-6.5,0.1L21.4,301.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M21.4,293.9l2.1,0c0.8,0,1.4-0.3,1.4-1.3c0-0.5-0.2-1-0.4-1.4l-3.1-0.1l0-1.2l6.5,0.1l0,1.2l-2.6,0l0,0
c0.3,0.4,0.5,1.1,0.5,1.8c0,1.2-0.7,2.1-2.2,2.1l-2.3,0L21.4,293.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M25,282.3c2.4,0.1,3.4,1.8,3.3,3.4c-0.1,1.7-1.4,3-3.5,2.9c-2.2-0.1-3.4-1.6-3.3-3.4
C21.6,283.4,23,282.2,25,282.3z M24.8,287.4c1.4,0.1,2.5-0.7,2.6-1.9c0-1.1-1-2-2.4-2.1c-1.1,0-2.5,0.4-2.6,1.8
C22.3,286.7,23.6,287.3,24.8,287.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M22,279.4l2.8,0.2l0-0.3l-2.6-2.6l0.1-1.4l2.7,3c0.2-1,0.9-1.6,2.1-2c0.4-0.1,1.1-0.3,1.6-0.6l-0.1,1.2
c-0.3,0.2-0.8,0.3-1.4,0.5c-1.1,0.4-1.6,0.9-1.7,2l0,0.2l2.8,0.2l-0.1,1.2l-6.5-0.5L22,279.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M47.4,174.8l3.4,1.7c1.3,0.6,2.3,1.2,3.4,1.8l0,0c-0.6-0.8-1.3-1.8-1.9-2.8l-2.8-4.7l0.5-1l8.1,4.1l-0.5,1
l-3.4-1.7c-1.3-0.7-2.3-1.2-3.2-1.7l0,0c0.7,0.8,1.3,1.9,2,2.9l2.7,4.5l-0.6,1.1l-8.1-4.1L47.4,174.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M60.9,167.9c0,0.3-0.1,1-0.5,1.8c-0.9,1.7-2.7,2.2-4.4,1.3c-1.8-0.9-2.4-2.8-1.4-4.7c0.3-0.6,0.8-1.1,1.1-1.3
l0.7,0.7c-0.3,0.2-0.6,0.5-0.9,1.1c-0.7,1.3-0.1,2.5,1.1,3.2c1.3,0.7,2.6,0.3,3.2-0.8c0.3-0.6,0.4-1.1,0.4-1.4L60.9,167.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M63.8,162.8c0,0.3-0.2,1-0.6,1.8c-1,1.7-2.7,2.1-4.5,1.2c-1.7-1-2.3-2.9-1.3-4.7c0.3-0.6,0.8-1.1,1.1-1.3
l0.7,0.7c-0.3,0.2-0.6,0.5-0.9,1c-0.7,1.3-0.2,2.5,1,3.2c1.3,0.7,2.6,0.4,3.2-0.8c0.3-0.6,0.4-1,0.4-1.4L63.8,162.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M61.7,154.1l5.6,3.3l-0.6,1l-4.8-2.9l-1.1,1.9l1.4,0.9c1.6,0.9,2.5,1.7,2.6,2.7c0.1,0.4,0,0.8-0.3,1.3
l-0.9-0.4c0.1-0.2,0.1-0.5,0.1-0.7c-0.1-0.7-0.8-1.3-2.1-2l-2.2-1.3L61.7,154.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M66.1,153.6c1.4,0.8,2.5,0.3,3.1-0.7c0.5-0.7,0.6-1.2,0.7-1.7l0.8,0.3c-0.1,0.5-0.3,1.2-0.8,2
c-1.1,1.7-2.8,2-4.5,0.9c-1.7-1-2.3-2.8-1.3-4.4c1.1-1.8,3-1.3,4-0.6c0.2,0.1,0.3,0.3,0.4,0.3L66.1,153.6z M67.2,150.3
c-0.6-0.4-1.8-0.8-2.5,0.3c-0.6,1,0,2,0.7,2.6L67.2,150.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M69.3,142.4l4.6,3.1l0.4-0.5l2.4,1.7l-0.5,0.8l-1.7-1.1L72,150l1.7,1.2l-0.5,0.8l-2.5-1.6L71,150
c-0.2-0.5-0.4-0.9-0.7-1.3c-0.5-0.7-1.2-1.2-1.9-1.8l-1.4-0.9L69.3,142.4z M69.1,146.2c0.7,0.5,1.3,1,1.8,1.6
c0.3,0.4,0.5,0.7,0.7,1.1l1.7-2.5l-3.9-2.6l-1.2,1.8L69.1,146.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M76.5,137.7c2,1.4,1.8,3.3,0.9,4.6c-1,1.4-2.8,1.8-4.5,0.6c-1.8-1.3-2-3.1-1-4.6
C73,136.8,74.8,136.6,76.5,137.7z M73.5,142c1.2,0.8,2.5,0.8,3.2-0.2c0.6-0.9,0.3-2.2-0.9-3.1c-0.9-0.6-2.3-1-3.2,0.1
C71.8,140,72.5,141.3,73.5,142z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M74.9,134.7c0.2-0.4,0.7-1.1,1.1-1.7c0.6-0.9,1.9-2.2,3-1.3c0.6,0.5,0.7,1.3,0.4,2l0,0
c0.7-0.7,1.5-0.9,2.3-0.3c1.4,1,0.2,2.9-0.5,3.9c-0.4,0.6-0.9,1.1-1.2,1.4L74.9,134.7z M77.6,135.4l0.5-0.7c0.5-0.7,0.9-1.6,0.2-2
c-0.5-0.4-1.1-0.1-1.8,0.8c-0.2,0.3-0.4,0.5-0.5,0.8L77.6,135.4z M80,137.2c0.2-0.2,0.4-0.4,0.6-0.7c0.5-0.6,1-1.7,0.3-2.2
c-0.8-0.6-1.5,0.1-2.1,1l-0.5,0.7L80,137.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M86.2,130.4l-0.7-0.4l0,0c0.2,0.6,0.1,1.4-0.5,2.1c-0.8,1-1.9,1-2.7,0.4c-1.2-1-1-2.6,0.5-4.5l-0.1-0.1
c-0.4-0.3-1.3-0.8-2.1,0.2c-0.4,0.5-0.6,1.1-0.7,1.6l-0.8-0.3c0.1-0.6,0.4-1.4,0.9-2c1.2-1.6,2.6-1.1,3.6-0.3l1.9,1.5
c0.4,0.3,0.9,0.7,1.3,0.9L86.2,130.4z M83.5,128.5c-0.8,1-1.5,2.3-0.5,3.1c0.6,0.5,1.2,0.3,1.6-0.2c0.5-0.7,0.4-1.4,0.1-1.9
c-0.1-0.1-0.2-0.2-0.3-0.3L83.5,128.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M85.7,120.8l0.7,0.6l-1.3,1.6l4.3,3.5l-0.7,0.9l-4.3-3.5l-1.3,1.6l-0.7-0.6L85.7,120.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M89.4,121.8c1.2,1,2.4,0.7,3.2-0.2c0.5-0.6,0.8-1.1,0.9-1.6l0.8,0.4c-0.1,0.4-0.4,1.1-1.1,1.9
c-1.3,1.5-3.1,1.6-4.5,0.3c-1.5-1.3-1.9-3.2-0.7-4.6c1.4-1.6,3.2-0.8,4.1,0c0.2,0.2,0.3,0.3,0.4,0.4L89.4,121.8z M91,118.7
c-0.6-0.5-1.7-1-2.5,0c-0.8,0.9-0.3,2,0.3,2.6L91,118.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M94.1,111.3l4.8,4.3l-0.8,0.9l-4.1-3.7l-1.5,1.6l1.3,1.1c1.4,1.2,2.1,2.2,2,3.2c0,0.4-0.2,0.8-0.6,1.2
l-0.8-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0.1-0.7-0.6-1.4-1.6-2.4l-1.9-1.8L94.1,111.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M96.2,109l1.6,1.5c0.1-0.2,0.4-0.6,0.7-0.8c1-1.1,2.4-1.9,3.6-0.7c0.5,0.5,0.6,1,0.6,1.5
c-0.1,0.9-0.7,1.9-1.4,2.5c-0.5,0.5-0.9,0.9-1.3,1.2l-4.7-4.4L96.2,109z M100.3,112.9c0.2-0.1,0.4-0.3,0.6-0.6
c0.6-0.6,1.2-1.7,0.4-2.4c-0.8-0.8-1.8-0.1-2.4,0.5c-0.2,0.2-0.4,0.4-0.5,0.7L100.3,112.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M178,46.6l1.6,3.5c0.6,1.3,1.1,2.4,1.5,3.5l0,0c0-1,0.1-2.2,0.3-3.4l0.7-5.4l1.1-0.5l3.8,8.2l-1,0.5l-1.6-3.5
c-0.6-1.3-1-2.3-1.4-3.4l0,0c0,1.1-0.1,2.3-0.2,3.5l-0.7,5.3l-1.1,0.5L177,47L178,46.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M187.2,45.2l1,2.4l2.8-1.2l-1-2.4l1.1-0.5l2.5,6l-1.1,0.5l-1.1-2.7l-2.8,1.2l1.1,2.7l-1.1,0.5l-2.5-6
L187.2,45.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M197,41.2l0.3,0.9l-1.9,0.7l2,5.2l-1.1,0.4l-2-5.2l-1.9,0.7l-0.3-0.9L197,41.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M199.7,43.9c0.6,1.5,1.8,1.7,2.9,1.3c0.8-0.3,1.2-0.6,1.6-0.9l0.5,0.7c-0.3,0.3-0.9,0.8-1.9,1.1
c-1.9,0.7-3.4-0.1-4.1-2s-0.1-3.7,1.6-4.3c2-0.7,3.2,0.8,3.6,1.9c0.1,0.2,0.1,0.4,0.2,0.5L199.7,43.9z M202.7,41.9
c-0.2-0.7-1-1.7-2.2-1.2c-1.1,0.4-1.2,1.6-1,2.4L202.7,41.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M208,37.2l0.3,0.9l-2.6,0.9l1.8,5.2l-1.1,0.4l-2.1-6.1L208,37.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M209.8,38.9c-0.3-0.8-0.5-1.4-0.7-2l1-0.3l0.4,1l0,0c0.2-0.9,0.8-1.6,1.8-1.9c1.5-0.5,3,0.4,3.6,2.3
c0.7,2.2-0.3,3.7-1.7,4.2c-0.8,0.3-1.6,0.1-2.2-0.4l0,0l1.1,3.4l-1.1,0.4L209.8,38.9z M211.4,40.2c0.1,0.2,0.1,0.3,0.2,0.4
c0.5,0.7,1.3,1,2.1,0.8c1.2-0.4,1.6-1.6,1.1-3c-0.4-1.2-1.4-2.1-2.6-1.7c-0.8,0.2-1.3,1-1.2,1.9c0,0.2,0,0.3,0.1,0.5L211.4,40.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M221.8,39.8l-0.3-0.8l0,0c-0.2,0.6-0.7,1.2-1.6,1.5c-1.3,0.4-2.2-0.3-2.4-1.2c-0.4-1.5,0.7-2.7,3.1-3.4l0-0.1
c-0.2-0.5-0.6-1.4-1.8-1c-0.6,0.2-1.1,0.5-1.5,0.9l-0.5-0.7c0.4-0.5,1.1-0.9,1.9-1.1c1.9-0.6,2.7,0.6,3.1,1.9l0.7,2.3
c0.2,0.5,0.3,1.1,0.5,1.5L221.8,39.8z M220.7,36.6c-1.2,0.3-2.6,1-2.2,2.2c0.2,0.7,0.8,0.9,1.4,0.8c0.8-0.2,1.2-0.9,1.2-1.5
c0-0.1,0-0.3,0-0.4L220.7,36.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M226.9,31.6l0.2,0.9l-1.9,0.5l1.4,5.4l-1.1,0.3l-1.4-5.4l-1.9,0.5l-0.2-0.9L226.9,31.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M234.3,33.1c0.6,2.3-0.8,3.7-2.3,4.1c-1.7,0.4-3.3-0.5-3.8-2.5c-0.5-2.1,0.6-3.7,2.3-4.1
C232.3,30.2,233.8,31.2,234.3,33.1z M229.3,34.4c0.3,1.4,1.4,2.2,2.5,2c1.1-0.3,1.7-1.5,1.3-2.9c-0.3-1.1-1.1-2.3-2.5-2
C229.3,31.8,229,33.2,229.3,34.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M235.5,31.7c-0.2-0.8-0.3-1.5-0.5-2.1l1-0.2l0.3,1.1l0,0c0.3-0.9,1-1.5,2-1.7c1.5-0.3,3,0.7,3.4,2.6
c0.5,2.3-0.7,3.7-2.1,4c-0.8,0.2-1.6,0-2.2-0.6l0,0l0.7,3.4l-1.1,0.2L235.5,31.7z M237,33.2c0,0.2,0.1,0.3,0.2,0.5
c0.4,0.8,1.2,1.2,2,1c1.2-0.3,1.7-1.4,1.4-2.9c-0.3-1.3-1.2-2.2-2.4-2c-0.8,0.2-1.4,0.9-1.4,1.8c0,0.2,0,0.3,0,0.5L237,33.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M361.5,32.6l4.1,1.1c0.3-1.7-0.4-3.3-2.2-3.8c-0.7-0.2-1.4-0.1-2,0l0-0.9c0.7-0.1,1.5-0.1,2.3,0.1
c2.7,0.7,3.6,3.1,3,5.6c-0.7,2.9-3.1,4-5.4,3.4c-0.9-0.2-1.6-0.6-2.2-1l0.5-0.8c0.4,0.4,1.1,0.7,1.8,0.9c1.9,0.5,3.4-0.6,4-2.4
l-4.1-1.1L361.5,32.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M369.8,33.3L369,36l0.3,0.1l3.1-2l1.4,0.4l-3.5,2c1,0.4,1.4,1.2,1.5,2.5c0,0.5,0.1,1.1,0.2,1.7l-1.2-0.3
c-0.1-0.3-0.2-0.9-0.2-1.4c-0.1-1.1-0.6-1.8-1.6-2.1l-0.2-0.1l-0.8,2.7l-1.1-0.3l1.8-6.2L369.8,33.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M377.3,42.1c-0.3,0.1-1.1,0.1-1.9-0.2c-1.9-0.6-2.7-2.2-2.1-4.1c0.6-1.9,2.3-2.9,4.3-2.3
c0.7,0.2,1.2,0.6,1.5,0.8l-0.5,0.8c-0.2-0.2-0.6-0.5-1.2-0.7c-1.4-0.4-2.5,0.4-2.9,1.7c-0.4,1.4,0.2,2.6,1.4,3
c0.6,0.2,1.1,0.2,1.5,0.1L377.3,42.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M385.7,38.3l-2.1,6.1l-1.1-0.4l1.8-5.2l-2.8-1l-1.8,5.2l-1.1-0.4l2.1-6.1L385.7,38.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M387,42.5c-0.5,1.5,0.2,2.5,1.3,2.9c0.8,0.3,1.3,0.3,1.8,0.3l-0.1,0.9c-0.5,0-1.2,0-2.2-0.4
c-1.9-0.7-2.5-2.3-1.8-4.2c0.7-1.8,2.3-2.9,4.1-2.2c2,0.7,1.9,2.7,1.4,3.8c-0.1,0.2-0.2,0.4-0.2,0.5L387,42.5z M390.5,42.9
c0.3-0.7,0.4-1.9-0.9-2.4c-1.1-0.4-2,0.4-2.4,1.2L390.5,42.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M393.2,43.4c0.3-0.8,0.5-1.4,0.7-2l1,0.4l-0.4,1.1l0,0c0.7-0.6,1.6-0.7,2.6-0.3c1.5,0.6,2.1,2.2,1.3,4.1
c-0.9,2.2-2.6,2.7-4,2.1c-0.8-0.3-1.3-0.9-1.5-1.7l0,0l-1.3,3.3l-1.1-0.4L393.2,43.4z M393.6,45.4c-0.1,0.2-0.1,0.3-0.1,0.5
c-0.1,0.8,0.3,1.6,1.1,1.9c1.2,0.5,2.2-0.2,2.8-1.6c0.5-1.2,0.3-2.5-0.9-3c-0.7-0.3-1.7,0-2.2,0.7c-0.1,0.1-0.2,0.3-0.3,0.4
L393.6,45.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M405,46l-0.4,0.9l-1.9-0.8l-2.2,5.1l-1.1-0.5l2.2-5.1l-1.9-0.8l0.4-0.9L405,46z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M512,125.7l-7,5.7l-0.7-0.9l6.3-5.1l-1.9-2.3l-2.1,1.7c-1.5,1.2-3.3,2.5-4.7,2.1c-0.4-0.1-0.9-0.4-1.2-0.8
l0.6-0.7c0.3,0.2,0.7,0.4,1,0.4c1,0.1,2.4-0.9,3.5-1.8l3-2.4L512,125.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M512,129.8l-2.2,1.7c-0.8,0.6-1.3,1-2.1,1.5l0,0c0.9-0.2,1.4-0.3,2.2-0.4l3.9-0.4l0.8,1.1l-5.2,3.9l-0.7-0.9
l2.2-1.7c0.8-0.6,1.3-1,2.2-1.5l0,0c-0.9,0.2-1.5,0.3-2.2,0.4c-1.2,0.1-2.6,0.3-3.9,0.5l-0.8-1.1l5.2-3.9L512,129.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M518.8,139l-4.5,3.3l0.4,0.5l-2.4,1.7l-0.5-0.7l1.6-1.2l-2.6-3.6L509,140l-0.5-0.7l2.3-1.8l0.3,0.4
c0.5,0,1-0.1,1.5-0.3c0.8-0.3,1.6-0.7,2.3-1.2l1.4-1L518.8,139z M515.3,137.5c-0.7,0.5-1.4,0.9-2.2,1.1c-0.4,0.2-0.9,0.2-1.3,0.3
l1.7,2.4l3.8-2.7l-1.2-1.7L515.3,137.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M517.5,143.2c-1.3,0.9-1.3,2.1-0.6,3.1c0.5,0.7,0.9,1,1.3,1.3l-0.6,0.6c-0.4-0.2-1-0.7-1.5-1.5
c-1.1-1.6-0.7-3.4,0.9-4.5c1.6-1.1,3.5-1,4.6,0.5c1.2,1.7,0,3.3-1,3.9c-0.2,0.1-0.4,0.2-0.5,0.3L517.5,143.2z M520.2,145.6
c0.6-0.4,1.4-1.3,0.7-2.4c-0.7-1-1.9-0.8-2.6-0.4L520.2,145.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M522.1,147.5c0.7-0.5,1.2-0.8,1.8-1.2l0.6,0.9l-0.9,0.6l0,0c0.9,0,1.7,0.4,2.3,1.2c0.8,1.3,0.4,3-1.3,4.1
c-2,1.3-3.7,0.7-4.5-0.6c-0.5-0.7-0.6-1.6-0.2-2.2l0,0l-3,1.9l-0.6-1L522.1,147.5z M521.2,149.4c-0.1,0.1-0.3,0.2-0.4,0.3
c-0.6,0.6-0.7,1.5-0.2,2.2c0.7,1,1.9,1.1,3.2,0.3c1.1-0.7,1.7-1.9,1-2.9c-0.4-0.7-1.3-1-2.2-0.7c-0.1,0-0.3,0.1-0.4,0.2
L521.2,149.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M570.8,276l-3.8,0.3l0.3,4.3l3.8-0.3l0.1,1.2l-9,0.6l-0.1-1.2l4.2-0.3l-0.3-4.3l-4.2,0.3l-0.1-1.2l9-0.6
L570.8,276z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M565.8,289.8c-2.4,0.1-3.5-1.5-3.6-3.1c-0.1-1.7,1.2-3.1,3.2-3.2c2.2-0.1,3.5,1.3,3.6,3.1
C569.1,288.4,567.8,289.7,565.8,289.8z M565.6,284.7c-1.4,0.1-2.5,0.9-2.4,2.1c0,1.1,1.1,1.9,2.6,1.9c1.1,0,2.5-0.6,2.4-2
C568.1,285.2,566.8,284.6,565.6,284.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M569,291.2c0.1,0.5,0.2,1.3,0.2,2.1c0,1.1-0.1,2.9-1.6,2.9c-0.8,0-1.3-0.6-1.5-1.3l0,0c-0.1,1-0.6,1.7-1.6,1.7
c-1.7,0-1.9-2.1-2-3.4c0-0.7,0-1.5,0.1-1.8L569,291.2z M563.4,292.4c0,0.3,0,0.6,0,0.9c0,0.8,0.2,2,1.2,1.9c0.9,0,1.1-1,1.1-2.1
l0-0.9L563.4,292.4z M566.3,292.4l0,0.9c0,0.9,0.3,1.8,1,1.7c0.6,0,0.9-0.6,0.9-1.8c0-0.4,0-0.6-0.1-0.9L566.3,292.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M562.6,301.6l0.8-0.1l0,0c-0.5-0.4-0.9-1.1-0.9-2c0-1.3,1-2,1.9-1.9c1.6,0,2.4,1.4,2.3,3.9l0.1,0
c0.5,0,1.5-0.1,1.5-1.4c0-0.6-0.2-1.2-0.5-1.7l0.8-0.3c0.3,0.5,0.6,1.3,0.5,2.1c0,2-1.4,2.4-2.7,2.4l-2.4,0c-0.6,0-1.1,0-1.6,0.1
L562.6,301.6z M565.9,301.4c0-1.3-0.2-2.7-1.4-2.8c-0.8,0-1.1,0.5-1.1,1.1c0,0.8,0.5,1.4,1.1,1.6c0.1,0,0.3,0.1,0.4,0.1
L565.9,301.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M568.9,308.9l-0.9,0l0.1-2l-5.5-0.2l0-1.2l5.5,0.2l0.1-2l0.9,0L568.9,308.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M565.4,315.5c-2.4-0.1-3.4-1.8-3.3-3.4c0.1-1.7,1.4-3,3.5-2.9c2.2,0.1,3.4,1.6,3.3,3.4
C568.8,314.4,567.3,315.6,565.4,315.5z M565.6,310.4c-1.4-0.1-2.5,0.7-2.6,1.8c-0.1,1.1,1,2,2.4,2.1c1.1,0.1,2.5-0.4,2.6-1.8
C568.1,311.1,566.8,310.4,565.6,310.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M566.3,317.1c0.8,0.1,1.5,0.1,2.1,0.1l-0.1,1.1l-1.1,0l0,0c0.7,0.5,1.2,1.3,1.1,2.4c-0.1,1.6-1.5,2.6-3.5,2.5
c-2.3-0.2-3.4-1.7-3.2-3.2c0.1-0.9,0.5-1.6,1.2-1.9l0,0l-3.5-0.3l0.1-1.2L566.3,317.1z M564.5,318.1c-0.2,0-0.3,0-0.5,0
c-0.8,0.1-1.4,0.8-1.5,1.6c-0.1,1.2,0.9,2,2.3,2.2c1.3,0.1,2.5-0.5,2.6-1.7c0.1-0.8-0.5-1.6-1.3-1.9c-0.1-0.1-0.3-0.1-0.5-0.1
L564.5,318.1z"
      />
    </g>
  );

  const uzbekLevels = (
    <g className="meter-lvls-eng-uz">
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M20.9,331.3c-0.2-0.5-0.3-1.3-0.4-2.1c-0.1-1.2,0-1.9,0.4-2.5c0.3-0.5,0.8-0.8,1.5-0.9
c0.9-0.1,1.7,0.4,2.1,1.3l0,0c0.1-0.9,0.7-1.9,2-2.1c0.8-0.1,1.4,0.2,1.9,0.6c0.6,0.6,1,1.5,1.2,3c0.1,0.8,0.1,1.4,0.1,1.8
L20.9,331.3z M24.5,329.7l-0.1-1c-0.1-1.2-0.9-1.9-1.7-1.8c-1.1,0.1-1.4,1-1.2,2.1c0.1,0.5,0.1,0.8,0.2,1L24.5,329.7z M28.8,329.2
c0-0.2,0-0.6-0.1-1c-0.1-1.2-0.7-2.2-2-2.1c-1.2,0.1-1.6,1.2-1.5,2.5l0.1,1L28.8,329.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M25.2,317.6c2.4-0.2,3.6,1.4,3.7,2.9c0.1,1.7-1,3.2-3.1,3.4c-2.2,0.2-3.5-1.1-3.7-2.9
C22,319.1,23.3,317.8,25.2,317.6z M25.7,322.7c1.4-0.1,2.4-1,2.3-2.2c-0.1-1.1-1.2-1.9-2.7-1.7c-1.1,0.1-2.4,0.8-2.3,2.1
S24.5,322.8,25.7,322.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M27.3,316.1c0.2-0.4,0.4-1,0.4-1.6c-0.1-0.9-0.5-1.2-1-1.2c-0.6,0-0.8,0.4-1.1,1.3c-0.3,1.2-1,1.8-1.7,1.8
c-1,0.1-1.9-0.7-2-2.1c0-0.7,0.1-1.2,0.3-1.6l0.9,0.2c-0.1,0.3-0.3,0.7-0.3,1.3c0,0.7,0.5,1.1,0.9,1c0.5,0,0.8-0.4,1-1.3
c0.4-1.1,0.9-1.8,1.8-1.8c1.1-0.1,2,0.8,2.1,2.3c0,0.7-0.1,1.4-0.3,1.8L27.3,316.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M18.6,311l0-1.2l4-0.2l0,0c-0.3-0.2-0.6-0.5-0.9-0.8c-0.2-0.3-0.4-0.7-0.4-1.2c0-0.9,0.5-2.3,2.7-2.4l3.9-0.1
l0,1.2l-3.7,0.1c-1,0-1.9,0.5-1.9,1.6c0,0.8,0.6,1.3,1.2,1.5c0.2,0.1,0.3,0.1,0.6,0.1l3.9-0.1l0,1.2L18.6,311z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M18.4,303.5l0-1.2l9.5-0.2l0,1.2L18.4,303.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M24.6,294.3c2.4,0,3.4,1.7,3.4,3.3c0,1.7-1.3,3.1-3.4,3c-2.2,0-3.4-1.5-3.4-3.3
C21.2,295.5,22.6,294.3,24.6,294.3z M24.6,299.4c1.4,0,2.5-0.8,2.5-1.9c0-1.1-1-2-2.5-2c-1.1,0-2.5,0.5-2.5,1.9
C22.1,298.8,23.3,299.4,24.6,299.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M21.4,292.4l3.7-1.2c0.6-0.2,1.1-0.4,1.7-0.5l0,0c-0.5-0.2-1.1-0.4-1.6-0.6l-3.6-1.3l0-1.2l6.4,2.7l0,1.1
l-6.5,2.3L21.4,292.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M28,282.2c0.1,0.3,0.3,1,0.3,1.9c-0.1,1.9-1.5,3.2-3.5,3.1c-2-0.1-3.4-1.5-3.3-3.6c0-0.7,0.2-1.3,0.4-1.6
l0.9,0.3c-0.2,0.3-0.3,0.7-0.4,1.3c-0.1,1.5,1,2.3,2.3,2.4c1.5,0.1,2.5-0.8,2.5-2.1c0-0.7-0.1-1.1-0.3-1.5L28,282.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M18.9,280.2l0.1-1.2l4,0.3l0,0c-0.3-0.2-0.6-0.5-0.8-0.9c-0.2-0.4-0.3-0.8-0.2-1.2c0.1-0.9,0.7-2.2,2.9-2.1
l3.8,0.3l-0.1,1.2l-3.7-0.3c-1-0.1-2,0.2-2,1.4c-0.1,0.8,0.4,1.4,1.1,1.7c0.2,0.1,0.3,0.1,0.6,0.1l3.9,0.3l-0.1,1.2L18.9,280.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M20.8,271.4c0.4,0,0.7,0.3,0.7,0.8c0,0.4-0.4,0.7-0.8,0.6c-0.4,0-0.7-0.4-0.7-0.8
C20,271.7,20.3,271.4,20.8,271.4z M28.9,273.5l-6.5-0.6l0.1-1.2l6.5,0.6L28.9,273.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M56.4,157.9l7.8,4.5l-0.6,1l-7.8-4.5L56.4,157.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M64.4,160.9l-1.8-4.5c-0.2-0.4-0.3-0.8-0.4-1.2l0,0l-1.8,3l-0.8-0.5l2.5-4.2l0.6,0.4l1.7,4.4
c0.2,0.4,0.3,0.8,0.4,1.2l0,0l2-3.2l0.8,0.5l-2.7,4.5L64.4,160.9z"
      />
      <path style={{ fill: "#FFFFFF" }} className="st6" d="M60.2,150.8l0.6-1l8.1,5l-0.6,1L60.2,150.8z" />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M71.9,150.2l-0.7-0.4l0,0c0.2,0.6,0.2,1.4-0.3,2.2c-0.7,1.1-1.9,1.2-2.6,0.6c-1.3-0.9-1.3-2.5,0.1-4.6
l-0.1-0.1c-0.4-0.3-1.3-0.7-2.1,0.4c-0.3,0.5-0.5,1.1-0.5,1.7l-0.8-0.2c0-0.6,0.2-1.4,0.7-2.1c1.1-1.7,2.5-1.3,3.6-0.6l2,1.3
c0.5,0.3,0.9,0.6,1.4,0.8L71.9,150.2z M69,148.5c-0.7,1.1-1.3,2.4-0.3,3.1c0.6,0.4,1.2,0.2,1.5-0.3c0.5-0.7,0.3-1.4-0.1-1.9
c-0.1-0.1-0.2-0.2-0.3-0.3L69,148.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M69.5,145.2c-0.6-0.4-1-0.7-1.5-0.9l0.6-0.9l0.9,0.6l0,0c-0.3-0.6-0.4-1.6,0.2-2.5c0.5-0.7,1.7-1.6,3.6-0.3
l3.2,2.2l-0.7,1l-3.1-2.1c-0.9-0.6-1.8-0.8-2.4,0.1c-0.4,0.6-0.3,1.4,0.1,2c0.1,0.1,0.2,0.3,0.4,0.4l3.2,2.2l-0.7,1L69.5,145.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M79.4,136.4c0.5,0.4,1,0.7,1.5,1l-0.6,0.8l-0.9-0.6l0,0c0.2,0.6,0.4,1.5-0.3,2.4c-0.6,0.8-1.8,1.5-3.6,0.1
l-3.1-2.2l0.7-0.9l2.9,2.1c1,0.7,1.9,0.9,2.5,0c0.5-0.6,0.3-1.4,0-1.9c-0.1-0.2-0.3-0.3-0.4-0.4l-3.2-2.3l0.7-0.9L79.4,136.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M77.1,131.6l3.7,1.2c0.6,0.2,1.1,0.4,1.6,0.6l0,0c-0.3-0.4-0.6-0.9-1-1.4l-2.1-3.2l0.7-1l3.6,6l-0.7,0.9
l-6.6-2L77.1,131.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M88.5,127.2c-0.1,0.3-0.3,1-0.9,1.7c-1.2,1.5-3.1,1.7-4.6,0.4c-1.6-1.3-1.8-3.2-0.5-4.9c0.4-0.5,1-0.9,1.3-1.1
l0.5,0.8c-0.3,0.1-0.7,0.4-1.1,0.9c-0.9,1.2-0.6,2.5,0.5,3.3c1.2,0.9,2.5,0.8,3.3-0.2c0.4-0.5,0.6-1,0.7-1.3L88.5,127.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M82.2,120.2l0.8-0.9l3.1,2.6l0,0c-0.1-0.4-0.2-0.8-0.1-1.2c0.1-0.4,0.2-0.8,0.5-1.1c0.6-0.7,1.9-1.4,3.6,0.1
l2.9,2.5l-0.8,0.9l-2.8-2.4c-0.8-0.7-1.7-1-2.4-0.1c-0.5,0.6-0.5,1.4-0.1,2c0.1,0.2,0.2,0.3,0.4,0.4l3,2.5l-0.8,0.9L82.2,120.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M88.9,114.3c0.3,0.3,0.4,0.7,0,1c-0.3,0.3-0.7,0.3-1,0.1c-0.3-0.3-0.4-0.7-0.1-1C88.2,114,88.6,114,88.9,114.3
z M94.3,120.8l-4.9-4.3l0.8-0.9l4.9,4.3L94.3,120.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M178,46.6l3.9,8.2l-1,0.5l-3.9-8.2L178,46.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M181.8,49.5c-0.3-0.6-0.5-1.1-0.8-1.6l1-0.4l0.5,1l0,0c0-0.7,0.5-1.5,1.5-2c0.8-0.4,2.3-0.4,3.2,1.6l1.6,3.5
l-1.1,0.5l-1.5-3.4c-0.4-1-1.1-1.6-2.1-1.1c-0.7,0.3-1,1.1-0.9,1.7c0,0.2,0.1,0.4,0.2,0.5l1.6,3.6l-1.1,0.5L181.8,49.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M188.5,42.7l0.7,1.7l1.5-0.7l0.3,0.8l-1.5,0.7l1.4,3.2c0.3,0.7,0.7,1.1,1.3,0.8c0.3-0.1,0.5-0.2,0.6-0.3
l0.4,0.8c-0.2,0.2-0.5,0.4-0.9,0.6c-0.5,0.2-1,0.2-1.4,0c-0.4-0.2-0.8-0.7-1.1-1.4l-1.4-3.3l-0.9,0.4l-0.3-0.8l0.9-0.4l-0.6-1.4
L188.5,42.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M193.9,46.2c0.6,1.5,1.8,1.7,2.9,1.3c0.8-0.3,1.2-0.6,1.5-1l0.5,0.7c-0.3,0.3-0.9,0.8-1.8,1.2
c-1.8,0.7-3.4,0-4.2-1.9s-0.2-3.7,1.5-4.4c2-0.8,3.2,0.7,3.6,1.9c0.1,0.2,0.1,0.4,0.2,0.5L193.9,46.2z M196.8,44.1
c-0.3-0.7-1-1.7-2.2-1.2c-1.1,0.4-1.2,1.7-1,2.4L196.8,44.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M203.6,38.8c0.1,0.4,0.3,0.9,0.6,1.7l1.3,3.5c0.5,1.4,0.6,2.4,0.2,3.1c-0.4,0.8-1.2,1.3-1.9,1.5
c-0.7,0.3-1.6,0.4-2.2,0.2l0-0.9c0.5,0.1,1.2,0.1,2-0.2c1.1-0.4,1.7-1.3,1.2-2.8l-0.2-0.7l0,0c-0.1,0.7-0.6,1.4-1.6,1.7
c-1.5,0.6-3.1-0.3-3.7-2c-0.8-2.1,0.2-3.7,1.5-4.2c1.1-0.4,1.8,0,2.3,0.4l0,0l-0.3-0.9L203.6,38.8z M203.3,41.6
c-0.1-0.2-0.1-0.3-0.2-0.5c-0.4-0.6-1.2-0.9-2-0.6c-1.1,0.4-1.5,1.6-1,3c0.4,1.2,1.4,2,2.6,1.5c0.7-0.2,1.1-0.9,1.1-1.7
c0-0.2-0.1-0.4-0.1-0.6L203.3,41.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M206,40.1c-0.2-0.7-0.5-1.3-0.7-1.9l1-0.3l0.5,1.2l0.1,0c0-0.9,0.5-1.7,1.2-1.9c0.1,0,0.2-0.1,0.3-0.1l0.4,1.1
c-0.1,0-0.2,0-0.4,0.1c-0.8,0.3-1.1,1.1-1,1.9c0,0.2,0.1,0.3,0.1,0.5l1.1,3.3l-1.1,0.4L206,40.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M214.9,41.8l-0.3-0.7l0,0c-0.2,0.6-0.7,1.2-1.6,1.5c-1.2,0.4-2.2-0.3-2.4-1.2c-0.5-1.5,0.6-2.7,3-3.5l0-0.1
c-0.2-0.5-0.6-1.4-1.9-1c-0.6,0.2-1.1,0.6-1.5,1l-0.5-0.7c0.4-0.5,1.1-0.9,1.8-1.2c1.9-0.6,2.8,0.5,3.1,1.8l0.7,2.3
c0.2,0.5,0.4,1.1,0.6,1.4L214.9,41.8z M213.7,38.7c-1.2,0.4-2.5,1-2.2,2.2c0.2,0.7,0.8,0.9,1.4,0.7c0.8-0.3,1.1-0.9,1.2-1.5
c0-0.1,0-0.3-0.1-0.4L213.7,38.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M216.5,32.6l0.5,1.8l1.6-0.5l0.3,0.9l-1.6,0.5l1,3.3c0.2,0.8,0.6,1.1,1.2,1c0.3-0.1,0.5-0.2,0.6-0.3l0.3,0.8
c-0.2,0.2-0.5,0.3-1,0.5c-0.5,0.2-1,0.1-1.4-0.1c-0.4-0.2-0.7-0.8-0.9-1.5l-1-3.4l-1,0.3L215,35l1-0.3l-0.4-1.5L216.5,32.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M226.4,35.1c0.6,2.3-0.7,3.8-2.2,4.2c-1.7,0.5-3.3-0.4-3.9-2.4c-0.6-2.1,0.5-3.7,2.2-4.2
C224.3,32.2,225.9,33.1,226.4,35.1z M221.5,36.5c0.4,1.4,1.4,2.2,2.6,1.9c1.1-0.3,1.6-1.5,1.2-2.9c-0.3-1.1-1.2-2.3-2.5-1.9
S221.2,35.3,221.5,36.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M227.6,33.6c-0.2-0.7-0.4-1.4-0.5-1.9l1-0.3l0.4,1.2l0.1,0c0.1-0.9,0.6-1.6,1.4-1.8c0.1,0,0.2,0,0.3,0l0.3,1.1
c-0.1,0-0.2,0-0.4,0.1c-0.8,0.2-1.2,1-1.2,1.9c0,0.2,0,0.4,0.1,0.5l0.8,3.4l-1.1,0.3L227.6,33.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M355.3,32.2c0.2-1.2,0.4-2.7,0.7-3.8l0,0c-0.5,1-1.1,2-1.8,3.1l-2.5,3.9l-0.9-0.2l-0.5-4.5
c-0.2-1.3-0.3-2.5-0.3-3.6l0,0c-0.3,1.1-0.6,2.6-1,3.9l-1,3.7l-1.1-0.2l2.5-8.7l1.4,0.3l0.6,4.6c0.1,1.2,0.2,2.2,0.3,3.2l0,0
c0.4-0.8,0.9-1.7,1.6-2.8l2.5-3.9l1.4,0.3l-1.3,8.9l-1.1-0.2L355.3,32.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M363.1,36.4c-0.2,0.7-0.3,1.2-0.4,1.7l-1-0.3l0.2-1l0,0c-0.4,0.4-1.3,0.9-2.4,0.7c-1-0.2-2-1.1-1.5-3.3
l0.9-3.7l1.1,0.3l-0.9,3.5c-0.3,1.2-0.1,2.1,0.9,2.4c0.8,0.2,1.4-0.2,1.8-0.7c0.1-0.2,0.2-0.4,0.2-0.6l1-3.9l1.1,0.3L363.1,36.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M368.1,30.9l-0.5,1.8l1.6,0.4L369,34l-1.6-0.4l-0.9,3.4c-0.2,0.8-0.1,1.3,0.5,1.4c0.3,0.1,0.5,0.1,0.7,0.1
l-0.2,0.9c-0.2,0-0.6,0-1-0.1c-0.5-0.1-0.9-0.4-1.1-0.8c-0.2-0.4-0.2-1,0-1.7l0.9-3.4l-1-0.3l0.2-0.9l1,0.3l0.4-1.5L368.1,30.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M372.2,40.8l0.1-0.8l0,0c-0.5,0.4-1.3,0.6-2.2,0.4c-1.3-0.4-1.6-1.4-1.4-2.3c0.4-1.5,2-1.9,4.4-1.2l0-0.1
c0.2-0.5,0.3-1.5-1-1.9c-0.6-0.2-1.2-0.2-1.8,0l0-0.8c0.6-0.2,1.4-0.2,2.2,0c1.9,0.6,2,2,1.6,3.2l-0.7,2.3
c-0.2,0.5-0.3,1.1-0.3,1.5L372.2,40.8z M373,37.6c-1.2-0.4-2.7-0.6-3,0.6c-0.2,0.7,0.2,1.2,0.7,1.4c0.8,0.2,1.5-0.1,1.8-0.6
c0.1-0.1,0.1-0.2,0.2-0.3L373,37.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M377.4,35.6l0.5,1.6c0.1,0.4,0.2,0.8,0.3,1.2l0,0c0.3-0.3,0.6-0.6,0.9-0.8l1.3-1l1.2,0.4l-3.1,2.3l1.1,3.9
l-1.3-0.4l-0.5-1.7c-0.1-0.4-0.2-0.8-0.3-1.3l0,0c-0.3,0.3-0.6,0.6-1,0.9l-1.3,1.1l-1.2-0.4l3.2-2.4l-1.1-3.7L377.4,35.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M384.1,44.7l0.2-0.8l0,0c-0.5,0.4-1.3,0.6-2.2,0.3c-1.2-0.4-1.6-1.5-1.3-2.4c0.5-1.5,2.1-1.8,4.5-1l0-0.1
c0.2-0.5,0.4-1.5-0.9-1.9c-0.6-0.2-1.2-0.2-1.7-0.1l0-0.8c0.6-0.2,1.4-0.1,2.2,0.2c1.9,0.6,1.9,2.1,1.5,3.3l-0.8,2.3
c-0.2,0.5-0.3,1.1-0.4,1.5L384.1,44.7z M385,41.5c-1.2-0.4-2.7-0.7-3.1,0.5c-0.3,0.7,0.1,1.2,0.7,1.4c0.8,0.3,1.5-0.1,1.8-0.5
c0.1-0.1,0.1-0.2,0.2-0.3L385,41.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M387,44.4c0.2,0.3,0.7,0.8,1.3,1c0.8,0.3,1.3,0,1.5-0.5c0.2-0.5,0-0.9-0.7-1.5c-0.9-0.8-1.2-1.6-1-2.3
c0.4-1,1.5-1.5,2.8-1c0.6,0.2,1.1,0.6,1.3,0.9l-0.6,0.7c-0.2-0.2-0.5-0.6-1.1-0.8c-0.7-0.2-1.2,0-1.3,0.5c-0.2,0.5,0.1,0.9,0.8,1.5
c0.9,0.8,1.2,1.5,0.9,2.4c-0.4,1.1-1.5,1.5-2.9,1c-0.7-0.2-1.2-0.6-1.5-1L387,44.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M391.9,46.3c0.2,0.3,0.7,0.8,1.3,1c0.8,0.3,1.3,0.1,1.5-0.4c0.2-0.5,0-0.9-0.7-1.6c-0.9-0.8-1.2-1.6-0.9-2.3
c0.4-1,1.5-1.5,2.8-0.9c0.6,0.2,1.1,0.6,1.3,1l-0.6,0.7c-0.2-0.2-0.5-0.6-1.1-0.8c-0.6-0.3-1.2,0-1.3,0.4c-0.2,0.5,0.1,0.9,0.7,1.5
c0.9,0.8,1.2,1.5,0.9,2.4c-0.4,1.1-1.5,1.5-3,0.9c-0.7-0.3-1.2-0.7-1.5-1.1L391.9,46.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M396.5,49.4l2.5-6l1.1,0.4l-2.5,6L396.5,49.4z M400.9,42.2c-0.1,0.4-0.5,0.6-1,0.4c-0.4-0.2-0.5-0.6-0.4-0.9
c0.2-0.4,0.6-0.6,1-0.4C400.9,41.5,401.1,41.9,400.9,42.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M399.7,49.4c0.2,0.3,0.7,0.8,1.2,1c0.8,0.3,1.3,0.1,1.5-0.4c0.2-0.5,0-0.9-0.6-1.6c-0.9-0.8-1.2-1.6-0.8-2.4
c0.4-1,1.5-1.4,2.8-0.9c0.6,0.3,1.1,0.7,1.3,1l-0.6,0.7c-0.2-0.2-0.5-0.6-1.1-0.9c-0.6-0.3-1.2-0.1-1.3,0.4c-0.2,0.5,0,0.9,0.7,1.5
c0.9,0.8,1.2,1.6,0.8,2.5c-0.5,1-1.6,1.4-3,0.8c-0.7-0.3-1.2-0.7-1.5-1.1L399.7,49.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M499,124l2.9-2.5l2.1-5.5l0.9,1l-1.1,2.6c-0.3,0.7-0.5,1.3-0.8,1.9l0,0c0.6-0.2,1.3-0.3,2-0.5l2.7-0.6l0.9,1
l-5.9,1l-2.9,2.5L499,124z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M507.8,129.6c-1.9,1.5-3.7,0.9-4.7-0.3c-1.1-1.4-0.9-3.2,0.7-4.5c1.7-1.4,3.6-1.1,4.7,0.3
C509.6,126.5,509.4,128.4,507.8,129.6z M504.6,125.7c-1.1,0.9-1.4,2.2-0.7,3.1c0.7,0.9,2.1,0.9,3.2-0.1c0.9-0.7,1.6-2,0.7-3.1
C506.9,124.5,505.5,124.9,504.6,125.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M510.5,128.8c1.1-0.4,2.6-0.9,3.3-1l0.5,0.5c-0.8,0.3-2.1,0.8-3,1.3L510.5,128.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M515.5,129.3l0.7,0.9l-7.6,5.7l-0.7-0.9L515.5,129.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M509.7,137.5c0.4-0.2,0.9-0.6,1.4-0.9l6.3-4.6l0.7,0.9l-3.3,2.4l0,0c0.8-0.1,1.6,0.2,2.3,1.1
c0.9,1.3,0.5,3-1.1,4.1c-1.9,1.4-3.7,0.9-4.5-0.3c-0.5-0.8-0.7-1.6-0.3-2.5l0,0l-0.9,0.6L509.7,137.5z M512.5,136.9
c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.7-0.6,1.5-0.1,2.2c0.7,1,2,1,3.2,0.1c1.1-0.8,1.6-2,0.8-3c-0.5-0.6-1.4-0.9-2.2-0.6
c-0.1,0.1-0.3,0.1-0.4,0.2L512.5,136.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M520.2,146.6c-2,1.4-3.8,0.6-4.7-0.7c-1-1.4-0.7-3.3,1-4.4c1.8-1.2,3.6-0.8,4.7,0.7
C522.2,143.7,521.8,145.5,520.2,146.6z M517.2,142.4c-1.2,0.8-1.6,2.1-0.9,3c0.6,0.9,2,1,3.2,0.2c0.9-0.6,1.7-1.9,1-3
C519.6,141.5,518.2,141.7,517.2,142.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M519.2,148.9c0,0.4,0.1,1.1,0.5,1.6c0.5,0.7,1,0.8,1.5,0.5c0.5-0.3,0.5-0.8,0.3-1.7c-0.3-1.2,0-2,0.6-2.4
c0.9-0.6,2.1-0.3,2.8,0.8c0.4,0.5,0.5,1.1,0.5,1.6l-0.9,0.2c0-0.3-0.1-0.8-0.4-1.3c-0.4-0.6-0.9-0.7-1.3-0.4
c-0.4,0.3-0.4,0.7-0.2,1.6c0.3,1.2,0.1,2-0.7,2.5c-1,0.6-2.1,0.3-2.9-1c-0.4-0.6-0.6-1.2-0.6-1.8L519.2,148.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M529.2,149.1l0.6,1l-3.4,2.1l0,0c0.4,0,0.8,0.1,1.1,0.3c0.4,0.2,0.7,0.5,0.9,0.8c0.5,0.7,0.7,2.2-1.2,3.4
l-3.3,2l-0.6-1l3.2-2c0.9-0.5,1.4-1.3,0.9-2.3c-0.4-0.6-1.2-0.9-1.8-0.7c-0.2,0-0.3,0.1-0.5,0.2l-3.3,2.1l-0.6-1L529.2,149.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M527.5,164.2c-0.3-0.2-0.8-0.7-1.3-1.4c-1-1.7-0.5-3.4,1.2-4.4c1.7-1,3.7-0.6,4.7,1.3c0.4,0.6,0.5,1.2,0.5,1.6
l-0.9,0.2c0-0.3-0.1-0.8-0.4-1.3c-0.7-1.3-2.1-1.4-3.3-0.7c-1.3,0.8-1.6,2.1-1,3.2c0.3,0.6,0.7,0.9,1,1.1L527.5,164.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M536.3,160.9l0.6,1l-3.5,2l0,0c0.4,0,0.8,0.1,1.1,0.3c0.3,0.2,0.7,0.5,0.9,0.9c0.4,0.8,0.6,2.2-1.3,3.3
l-3.4,1.9l-0.6-1l3.3-1.8c0.9-0.5,1.5-1.3,1-2.2c-0.4-0.7-1.1-0.9-1.8-0.8c-0.2,0-0.3,0.1-0.5,0.2l-3.4,1.9l-0.6-1L536.3,160.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M531.5,171.9l5.7-3l0.5,1l-5.7,3L531.5,171.9z M539.4,169.2c-0.3,0.2-0.8,0.1-1-0.3c-0.2-0.4,0-0.8,0.3-1
c0.4-0.2,0.8-0.1,1,0.3C539.9,168.6,539.8,169,539.4,169.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M561.6,274.4l9-0.7l0.1,1.3l-4.3,3.2c-1,0.7-1.9,1.3-2.8,1.8l0,0c1.2-0.2,2.3-0.3,3.7-0.4l3.8-0.3l0.1,1.1
l-9,0.7l-0.1-1.2l4.4-3.2c1-0.7,1.9-1.4,2.9-1.9l0,0c-1.1,0.1-2.2,0.3-3.7,0.4l-3.8,0.3L561.6,274.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M565.8,288.7c-2.4,0.1-3.5-1.5-3.6-3.1c-0.1-1.7,1.2-3.2,3.2-3.2c2.2-0.1,3.5,1.3,3.6,3.1
C569.1,287.3,567.8,288.6,565.8,288.7z M565.5,283.6c-1.4,0.1-2.5,0.9-2.4,2.1c0,1.1,1.1,1.9,2.6,1.9c1.1,0,2.5-0.7,2.4-2
C568,284.1,566.7,283.6,565.5,283.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M569,290.5l-3.6,1.3c-0.6,0.2-1.1,0.4-1.7,0.6l0,0c0.5,0.1,1.1,0.3,1.7,0.5l3.7,1.2l0,1.2l-6.5-2.4l0-1.1
l6.4-2.6L569,290.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M562.6,300.1l0.8-0.1l0,0c-0.5-0.4-0.9-1.1-0.9-2c0-1.3,1-2,1.9-1.9c1.6,0,2.4,1.4,2.3,3.9l0.1,0
c0.5,0,1.5-0.1,1.5-1.4c0-0.6-0.2-1.2-0.5-1.7l0.8-0.3c0.3,0.5,0.6,1.3,0.5,2.1c0,2-1.4,2.4-2.7,2.4l-2.4,0c-0.6,0-1.1,0-1.6,0.1
L562.6,300.1z M565.9,300c0-1.3-0.2-2.7-1.4-2.8c-0.8,0-1.1,0.5-1.1,1.1c0,0.8,0.5,1.4,1.1,1.6c0.1,0,0.3,0.1,0.4,0.1L565.9,300z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M570.9,304.5l-1.9,0l0,1.7l-0.9,0l0-1.7l-3.5-0.1c-0.8,0-1.3,0.2-1.3,0.9c0,0.3,0,0.5,0.1,0.7l-0.9,0
c-0.1-0.2-0.1-0.6-0.1-1c0-0.5,0.2-1,0.5-1.3c0.4-0.3,0.9-0.4,1.7-0.4l3.5,0.1l0-1l0.9,0l0,1l1.6,0L570.9,304.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M565.5,313.2c-2.4-0.1-3.4-1.8-3.3-3.4c0.1-1.7,1.4-3,3.5-2.9c2.2,0.1,3.4,1.6,3.3,3.4
C568.9,312.1,567.5,313.2,565.5,313.2z M565.7,308c-1.4-0.1-2.5,0.7-2.6,1.9c0,1.1,1,2,2.4,2.1c1.1,0,2.5-0.4,2.6-1.8
C568.2,308.7,566.9,308.1,565.7,308z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M566.6,314.7c0.8,0.1,1.4,0.1,2,0.1l-0.1,1l-1.3,0l0,0.1c0.8,0.4,1.4,1.1,1.3,1.9c0,0.1,0,0.2-0.1,0.3
l-1.1-0.1c0-0.1,0.1-0.2,0.1-0.4c0.1-0.8-0.5-1.5-1.4-1.7c-0.2,0-0.3-0.1-0.5-0.1l-3.4-0.2l0.1-1.2L566.6,314.7z"
      />
    </g>
  );

  const englishLevels_kh = (
    <g id="Levels">
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M20.4,268.9c0-0.7,0-1.6,0.1-2.5c0.2-1.7,0.7-2.8,1.5-3.5c0.8-0.7,1.9-1,3.4-0.9c1.5,0.2,2.6,0.8,3.3,1.7
		c0.7,0.9,1,2.4,0.8,4.1c-0.1,0.8-0.2,1.5-0.4,2.1L20.4,268.9z M28.4,268.6c0.1-0.3,0.2-0.7,0.2-1.2c0.3-2.5-0.9-4-3.4-4.3
		c-2.1-0.3-3.6,0.8-3.9,3.2c-0.1,0.6-0.1,1.1,0,1.4L28.4,268.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M22.3,258.7c0.4,0,0.7,0.4,0.6,0.8c-0.1,0.4-0.4,0.7-0.8,0.6c-0.4-0.1-0.7-0.4-0.6-0.8
		C21.5,258.9,21.9,258.7,22.3,258.7z M30.3,261.2l-6.4-0.9l0.2-1.2l6.4,0.9L30.3,261.2z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M25.2,251.6c0.5,0.1,1,0.2,1.8,0.3l3.7,0.6c1.5,0.2,2.3,0.7,2.8,1.4c0.5,0.7,0.5,1.6,0.4,2.4
		c-0.1,0.8-0.4,1.6-0.9,2l-0.8-0.4c0.3-0.4,0.7-1,0.8-1.8c0.2-1.2-0.3-2.2-1.9-2.4l-0.7-0.1l0,0c0.5,0.5,0.9,1.2,0.7,2.2
		c-0.3,1.6-1.8,2.5-3.6,2.2c-2.2-0.4-3.2-2-2.9-3.4c0.2-1.1,0.9-1.6,1.4-1.8l0,0l-1-0.2L25.2,251.6z M27.6,253.2c-0.2,0-0.4,0-0.5,0
		c-0.7,0.1-1.4,0.6-1.5,1.4c-0.2,1.1,0.6,2,2.1,2.3c1.3,0.2,2.4-0.3,2.6-1.5c0.1-0.7-0.2-1.4-0.9-1.8c-0.2-0.1-0.4-0.2-0.6-0.2
		L27.6,253.2z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M24,248.1c0.4,0.1,0.7,0.4,0.6,0.9c-0.1,0.4-0.4,0.6-0.8,0.6c-0.4-0.1-0.7-0.4-0.6-0.9
		C23.2,248.3,23.6,248,24,248.1z M32,250.9l-6.4-1.2l0.2-1.2l6.4,1.2L32,250.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M24.6,244.8l1.8,0.4l0.3-1.7l0.9,0.2l-0.3,1.7l3.4,0.7c0.8,0.2,1.3,0,1.4-0.6c0.1-0.3,0.1-0.5,0.1-0.7l0.9,0.1
		c0,0.2,0,0.6,0,1.1c-0.1,0.5-0.4,0.9-0.7,1.2c-0.4,0.3-1,0.3-1.7,0.1l-3.5-0.7l-0.2,1l-0.9-0.2l0.2-1l-1.5-0.3L24.6,244.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M34.1,240.1l-0.8-0.1l0,0c0.4,0.5,0.7,1.2,0.5,2.1c-0.3,1.3-1.3,1.7-2.2,1.5c-1.5-0.3-2.1-1.9-1.5-4.3l-0.1,0
		c-0.5-0.1-1.5-0.2-1.8,1.1c-0.1,0.6-0.1,1.2,0.1,1.7l-0.8,0.1c-0.2-0.6-0.3-1.4-0.1-2.2c0.4-1.9,1.8-2.1,3.1-1.8l2.4,0.5
		c0.6,0.1,1.1,0.2,1.5,0.2L34.1,240.1z M30.8,239.5c-0.3,1.2-0.4,2.7,0.9,3c0.7,0.2,1.2-0.3,1.3-0.8c0.2-0.8-0.2-1.5-0.7-1.8
		c-0.1-0.1-0.2-0.1-0.4-0.1L30.8,239.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M25.5,235l0.3-1.1l9.2,2.3l-0.3,1.1L25.5,235z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M36.1,231.5l-8.7-2.3l0.3-1.2l5.2-1.6c1.2-0.4,2.2-0.6,3.3-0.8l0,0c-1.2-0.2-2.3-0.5-3.6-0.8l-3.6-1l0.3-1.1
		l8.7,2.3l-0.3,1.1l-5.2,1.6c-1.1,0.3-2.3,0.7-3.3,0.8l0,0c1.1,0.2,2.2,0.5,3.6,0.9l3.7,1L36.1,231.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M36.9,216.6c2.3,0.7,2.8,2.6,2.4,4.1c-0.5,1.7-2.1,2.6-4.1,2c-2.1-0.6-2.9-2.3-2.4-4.1
		C33.4,216.8,35,216,36.9,216.6z M35.5,221.5c1.4,0.4,2.6-0.1,3-1.2c0.3-1.1-0.4-2.2-1.8-2.6c-1.1-0.3-2.5-0.2-2.9,1.1
		C33.3,220.2,34.4,221.1,35.5,221.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M34.5,213.8l3.9-0.1c0.6,0,1.2,0,1.7,0l0,0c-0.5-0.3-0.9-0.7-1.4-1l-3.1-2.3l0.4-1.2l5.4,4.4l-0.3,1.1
		l-6.9,0.3L34.5,213.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M35.1,206.2c0.4,0.1,0.6,0.5,0.4,0.9c-0.1,0.4-0.5,0.6-0.9,0.4c-0.4-0.1-0.6-0.5-0.5-0.9
		C34.3,206.3,34.7,206.1,35.1,206.2z M42.5,210.2l-6.1-2.1l0.4-1.1l6.1,2.1L42.5,210.2z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M44.9,202.9c0,0.3,0,1.1-0.3,1.9c-0.7,1.8-2.3,2.6-4.2,1.9c-1.9-0.7-2.8-2.5-2-4.4c0.2-0.7,0.6-1.2,0.9-1.4
		l0.8,0.6c-0.2,0.2-0.5,0.6-0.8,1.2c-0.5,1.4,0.2,2.5,1.5,3c1.4,0.5,2.6-0.1,3-1.3c0.2-0.6,0.2-1.1,0.2-1.5L44.9,202.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M43,200.1c1.5,0.6,2.5-0.1,2.9-1.2c0.3-0.8,0.4-1.3,0.3-1.8l0.9,0.1c0,0.5,0,1.2-0.4,2.1
		c-0.7,1.9-2.4,2.5-4.2,1.8c-1.8-0.7-2.8-2.3-2.1-4.1c0.8-2,2.7-1.8,3.8-1.4c0.2,0.1,0.4,0.2,0.5,0.2L43,200.1z M43.4,196.6
		c-0.7-0.3-1.9-0.4-2.4,0.8c-0.4,1.1,0.4,2,1.1,2.4L43.4,196.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M236.3,27c0.7-0.2,1.5-0.5,2.4-0.7c1.6-0.3,2.9-0.2,3.8,0.4c0.9,0.6,1.6,1.5,1.9,2.9c0.3,1.4,0.1,2.7-0.6,3.7
		c-0.7,1-1.9,1.7-3.6,2.1c-0.8,0.2-1.5,0.3-2.1,0.3L236.3,27z M239.1,34.6c0.3,0,0.7-0.1,1.2-0.2c2.4-0.5,3.5-2.1,3-4.5
		c-0.4-2.1-1.9-3.2-4.3-2.7c-0.6,0.1-1,0.3-1.3,0.4L239.1,34.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M246.5,25.6c0.1,0.4-0.1,0.8-0.6,0.8c-0.4,0.1-0.8-0.2-0.8-0.6c-0.1-0.4,0.2-0.8,0.6-0.9
		C246.1,24.9,246.5,25.2,246.5,25.6z M246.8,34l-1.2-6.4l1.2-0.2l1.2,6.4L246.8,34z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M254.2,26.1c0,0.5,0.1,1,0.2,1.8l0.6,3.7c0.2,1.5,0.1,2.4-0.4,3.1c-0.5,0.7-1.4,1-2.2,1.1
		c-0.8,0.1-1.6,0.1-2.2-0.2l0.1-0.9c0.5,0.2,1.2,0.3,2,0.2c1.2-0.2,2-1,1.7-2.6l-0.1-0.7l0,0c-0.3,0.7-0.9,1.2-1.9,1.4
		c-1.6,0.3-2.9-0.9-3.2-2.7c-0.4-2.2,0.9-3.6,2.3-3.9c1.1-0.2,1.8,0.3,2.2,0.8l0,0l-0.1-1L254.2,26.1z M253.5,28.8
		c0-0.2-0.1-0.4-0.2-0.5c-0.3-0.6-1-1.1-1.8-1c-1.1,0.2-1.7,1.2-1.5,2.7c0.2,1.3,1,2.2,2.3,2c0.7-0.1,1.3-0.7,1.4-1.5
		c0-0.2,0-0.4,0-0.6L253.5,28.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M257.2,23.9c0.1,0.4-0.2,0.8-0.6,0.8c-0.4,0.1-0.7-0.2-0.8-0.6c-0.1-0.4,0.2-0.8,0.6-0.8
		C256.8,23.2,257.1,23.5,257.2,23.9z M257,32.3l-0.9-6.4l1.2-0.2l0.9,6.4L257,32.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M260.4,23.4l0.2,1.8l1.7-0.2l0.1,0.9l-1.7,0.2l0.4,3.5c0.1,0.8,0.4,1.2,1,1.1c0.3,0,0.5-0.1,0.7-0.2l0.2,0.9
		c-0.2,0.1-0.6,0.2-1,0.3c-0.5,0.1-1,0-1.3-0.3c-0.4-0.3-0.6-0.9-0.7-1.6l-0.5-3.5l-1,0.1l-0.1-0.9l1-0.1l-0.2-1.5L260.4,23.4z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M268,30.9l-0.2-0.8l0,0c-0.3,0.5-0.9,1.1-1.9,1.2c-1.3,0.1-2.1-0.7-2.2-1.6c-0.2-1.6,1.1-2.6,3.6-2.8l0-0.1
		c-0.1-0.5-0.3-1.5-1.6-1.3c-0.6,0.1-1.2,0.3-1.6,0.7l-0.3-0.7c0.5-0.4,1.2-0.7,2-0.8c2-0.2,2.6,1.1,2.7,2.4l0.3,2.4
		c0.1,0.6,0.1,1.1,0.3,1.5L268,30.9z M267.5,27.6c-1.3,0.1-2.7,0.5-2.6,1.7c0.1,0.8,0.6,1.1,1.2,1c0.8-0.1,1.3-0.7,1.4-1.2
		c0-0.1,0-0.3,0-0.4L267.5,27.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M269.9,21.2l1.2-0.1l0.9,9.5l-1.2,0.1L269.9,21.2z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M276.2,21.2c0.6-0.1,1.3-0.3,2.2-0.3c1.1-0.1,2,0.1,2.6,0.6c0.5,0.4,0.9,1,0.9,1.8c0,0.8-0.2,1.5-0.6,2
		c-0.6,0.7-1.6,1.1-2.7,1.2c-0.3,0-0.7,0-0.9,0l0.2,3.6l-1.2,0.1L276.2,21.2z M277.6,25.5c0.3,0.1,0.6,0.1,1,0
		c1.4-0.1,2.2-0.8,2.1-2.1c-0.1-1.2-0.9-1.7-2.2-1.6c-0.5,0-0.9,0.1-1.1,0.2L277.6,25.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M283.4,25.3c0-0.8-0.1-1.4-0.1-2l1,0l0.1,1.3l0.1,0c0.3-0.9,0.9-1.5,1.7-1.5c0.1,0,0.2,0,0.3,0l0,1.1
		c-0.1,0-0.2,0-0.4,0c-0.8,0-1.4,0.7-1.5,1.6c0,0.2,0,0.3,0,0.6l0.1,3.5l-1.2,0L283.4,25.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M291.4,29.5l-0.1-0.8l0,0c-0.4,0.5-1,1-2,1c-1.3,0-2-0.9-2-1.8c0-1.6,1.3-2.5,3.8-2.5l0-0.1
		c0-0.5-0.2-1.5-1.5-1.5c-0.6,0-1.2,0.2-1.7,0.5l-0.3-0.8c0.5-0.4,1.3-0.6,2.1-0.6c2,0,2.5,1.3,2.5,2.6l0,2.4c0,0.6,0,1.1,0.1,1.6
		L291.4,29.5z M291.1,26.2c-1.3,0-2.7,0.3-2.7,1.5c0,0.8,0.5,1.1,1.1,1.1c0.8,0,1.4-0.6,1.5-1.1c0-0.1,0.1-0.3,0.1-0.4L291.1,26.2z"
		/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M298.8,29.3c-0.3,0.2-1,0.4-1.9,0.4c-2,0-3.2-1.3-3.2-3.3c0-2,1.4-3.4,3.5-3.4c0.7,0,1.3,0.2,1.6,0.3l-0.3,0.9
		c-0.3-0.2-0.7-0.3-1.4-0.3c-1.5,0-2.3,1.1-2.3,2.4c0,1.5,1,2.4,2.2,2.4c0.7,0,1.1-0.2,1.4-0.3L298.8,29.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M301.9,21.2l0,1.9l1.7,0l0,0.9l-1.7,0l-0.1,3.5c0,0.8,0.2,1.3,0.9,1.3c0.3,0,0.5,0,0.7-0.1l0,0.9
		c-0.2,0.1-0.6,0.1-1,0.1c-0.5,0-1-0.2-1.3-0.5c-0.3-0.4-0.4-0.9-0.4-1.7l0.1-3.5l-1,0l0-0.9l1,0l0-1.6L301.9,21.2z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M304.7,29.7l0.2-6.5l1.2,0l-0.2,6.5L304.7,29.7z M306.3,21.4c0,0.4-0.3,0.7-0.8,0.7c-0.4,0-0.7-0.3-0.7-0.8
		c0-0.4,0.3-0.7,0.8-0.7C306,20.7,306.3,21,306.3,21.4z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M309.6,21.5l-0.1,1.9l1.7,0.1l0,0.9l-1.7-0.1l-0.2,3.5c0,0.8,0.2,1.3,0.8,1.3c0.3,0,0.5,0,0.7,0l0,0.9
		c-0.2,0.1-0.6,0.1-1,0.1c-0.5,0-1-0.2-1.2-0.6c-0.3-0.4-0.4-0.9-0.4-1.7l0.2-3.5l-1-0.1l0-0.9l1,0.1l0.1-1.6L309.6,21.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M312.2,30l0.4-6.5l1.2,0.1l-0.4,6.5L312.2,30z M314,21.8c0,0.4-0.3,0.7-0.8,0.7c-0.4,0-0.7-0.4-0.7-0.8
		c0-0.4,0.4-0.7,0.8-0.7C313.8,21.1,314,21.4,314,21.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M321.3,27.4c-0.2,2.4-1.9,3.3-3.5,3.2c-1.7-0.1-3-1.5-2.8-3.6c0.2-2.2,1.7-3.3,3.5-3.2
		C320.4,24,321.5,25.5,321.3,27.4z M316.2,27.1c-0.1,1.4,0.6,2.6,1.7,2.6c1.1,0.1,2-0.9,2.2-2.3c0.1-1.1-0.3-2.5-1.7-2.6
		C317,24.6,316.3,25.8,316.2,27.1z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M323,26.2c0.1-0.7,0.1-1.2,0.1-1.7l1,0.1l-0.1,1.1l0,0c0.4-0.6,1.2-1.1,2.3-1c0.9,0.1,2.2,0.8,2,3l-0.4,3.8
		l-1.2-0.1l0.4-3.7c0.1-1-0.2-1.9-1.3-2.1c-0.8-0.1-1.4,0.4-1.7,1c-0.1,0.1-0.1,0.3-0.1,0.5l-0.4,3.9l-1.2-0.1L323,26.2z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M330.8,28.8c-0.2,1.6,0.7,2.4,1.9,2.5c0.8,0.1,1.4,0,1.8-0.1l0.1,0.9c-0.4,0.1-1.2,0.2-2.2,0.1
		c-2-0.3-3-1.7-2.7-3.7c0.3-1.9,1.6-3.3,3.5-3c2.1,0.3,2.4,2.2,2.2,3.4c0,0.2-0.1,0.4-0.1,0.5L330.8,28.8z M334.4,28.5
		c0.1-0.7,0-1.9-1.3-2.1c-1.2-0.2-1.8,0.9-2.1,1.6L334.4,28.5z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M337.1,28.3c0.1-0.8,0.2-1.4,0.3-2l1,0.2l-0.2,1.3l0.1,0c0.4-0.8,1.2-1.2,2-1.1c0.1,0,0.2,0,0.3,0.1l-0.2,1.1
		c-0.1,0-0.2-0.1-0.4-0.1c-0.8-0.1-1.5,0.4-1.8,1.2c-0.1,0.2-0.1,0.3-0.1,0.5l-0.5,3.4l-1.1-0.2L337.1,28.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M545.7,180.2c0.4,0.6,0.8,1.3,1.2,2.2c0.7,1.5,0.8,2.8,0.5,3.8c-0.3,1-1.1,1.9-2.4,2.5
		c-1.3,0.6-2.6,0.7-3.7,0.3c-1.1-0.4-2.1-1.5-2.8-3.1c-0.3-0.8-0.6-1.4-0.8-2L545.7,180.2z M538.9,184.6c0.1,0.3,0.2,0.7,0.4,1.1
		c1,2.3,2.8,2.9,5.1,1.9c1.9-0.9,2.7-2.5,1.7-4.8c-0.2-0.5-0.5-0.9-0.7-1.2L538.9,184.6z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M541.1,191.9l6-2.5l0.5,1.1l-6,2.5L541.1,191.9z M549.3,189.9c-0.4,0.2-0.8,0-1-0.4c-0.2-0.4,0-0.8,0.4-0.9
		c0.4-0.2,0.8,0,1,0.4C549.9,189.3,549.7,189.7,549.3,189.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M550.4,197.5c-0.4,0.2-0.9,0.3-1.7,0.6l-3.5,1.4c-1.4,0.6-2.3,0.6-3.1,0.2c-0.8-0.4-1.3-1.1-1.6-1.9
		c-0.3-0.7-0.4-1.6-0.3-2.2l0.9-0.1c-0.1,0.5-0.1,1.2,0.2,2c0.4,1.1,1.4,1.7,2.9,1.1l0.7-0.3l0,0c-0.7-0.1-1.4-0.6-1.8-1.5
		c-0.6-1.5,0.2-3.1,1.9-3.7c2-0.8,3.7,0,4.3,1.4c0.4,1,0.1,1.8-0.3,2.3l0,0l0.9-0.3L550.4,197.5z M547.6,197.3
		c0.2-0.1,0.3-0.2,0.5-0.3c0.6-0.5,0.9-1.2,0.5-2c-0.4-1-1.6-1.4-3-0.9c-1.2,0.5-1.9,1.5-1.4,2.6c0.3,0.7,0.9,1.1,1.7,1.1
		c0.2,0,0.4-0.1,0.6-0.1L547.6,197.3z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M545.1,201.6l6.1-2.3l0.4,1.1l-6.1,2.3L545.1,201.6z M553.3,199.9c-0.4,0.2-0.8,0-0.9-0.4
		c-0.1-0.4,0-0.8,0.4-0.9c0.4-0.1,0.8,0,1,0.4C553.9,199.3,553.7,199.7,553.3,199.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M554.5,202.9l-1.7,0.6l0.6,1.6l-0.8,0.3l-0.6-1.6l-3.3,1.2c-0.8,0.3-1.1,0.6-0.9,1.3c0.1,0.3,0.2,0.5,0.3,0.6
		l-0.8,0.4c-0.2-0.2-0.4-0.5-0.5-0.9c-0.2-0.5-0.2-1,0-1.4c0.2-0.4,0.7-0.7,1.4-1l3.3-1.2l-0.3-0.9l0.8-0.3l0.3,0.9l1.5-0.5
		L554.5,202.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M548.8,212l0.7-0.4l0,0c-0.6-0.2-1.3-0.7-1.6-1.6c-0.4-1.2,0.2-2.2,1.1-2.5c1.5-0.5,2.7,0.5,3.5,2.9l0.1,0
		c0.5-0.2,1.4-0.6,0.9-1.9c-0.2-0.6-0.6-1.1-1-1.4l0.6-0.5c0.5,0.4,1,1.1,1.2,1.8c0.6,1.9-0.5,2.8-1.7,3.2l-2.3,0.8
		c-0.5,0.2-1,0.4-1.4,0.6L548.8,212z M551.9,210.8c-0.4-1.2-1.1-2.5-2.3-2.1c-0.7,0.2-0.9,0.8-0.7,1.4c0.3,0.8,1,1.1,1.5,1.1
		c0.1,0,0.3,0,0.4-0.1L551.9,210.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M558.7,211.7l0.4,1.1l-9.1,2.9l-0.4-1.1L558.7,211.7z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M560.4,218.9l-8.7,2.6l-0.3-1.1l8.7-2.6L560.4,218.9z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M556.9,222.2c0.6-0.2,1.2-0.3,1.7-0.5l0.3,1l-1,0.3l0,0c0.7,0.1,1.5,0.7,1.7,1.7c0.2,0.9,0.1,2.3-2.1,2.9
		l-3.7,1l-0.3-1.1l3.6-1c1-0.3,1.7-0.9,1.4-2c-0.2-0.7-0.9-1.2-1.6-1.2c-0.2,0-0.4,0-0.6,0.1l-3.8,1l-0.3-1.1L556.9,222.2z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M558.9,229.4c0.6-0.2,1.2-0.3,1.7-0.5l0.2,1l-1,0.3l0,0c0.7,0.2,1.4,0.7,1.7,1.8c0.2,0.9,0,2.3-2.1,2.9
		l-3.8,0.9l-0.3-1.1l3.6-0.9c1-0.2,1.8-0.8,1.5-1.9c-0.2-0.8-0.9-1.2-1.5-1.2c-0.2,0-0.4,0-0.6,0.1l-3.8,0.9l-0.3-1.1L558.9,229.4z"
		/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M560.5,242.7c-2.3,0.5-3.7-0.9-4-2.4c-0.4-1.7,0.6-3.3,2.6-3.7c2.1-0.5,3.7,0.7,4,2.4
		C563.5,240.8,562.4,242.3,560.5,242.7z M559.3,237.7c-1.4,0.3-2.3,1.3-2,2.4c0.2,1.1,1.5,1.7,2.9,1.4c1.1-0.2,2.3-1.1,2-2.4
		C561.9,237.8,560.5,237.5,559.3,237.7z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M564,244l-3.3,1.9c-0.5,0.3-1,0.6-1.5,0.8l0,0c0.6,0,1.1,0.1,1.7,0.2l3.8,0.5l0.2,1.2l-6.8-1.3l-0.2-1.1
		l5.9-3.6L564,244z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M559.3,254.5l0.8-0.2l0,0c-0.6-0.3-1.1-0.9-1.3-1.8c-0.2-1.3,0.6-2.1,1.5-2.3c1.5-0.3,2.6,1,3,3.4l0.1,0
		c0.5-0.1,1.5-0.4,1.2-1.7c-0.1-0.6-0.4-1.2-0.8-1.6l0.7-0.4c0.4,0.5,0.8,1.2,0.9,2c0.3,2-0.9,2.6-2.2,2.9l-2.4,0.4
		c-0.6,0.1-1.1,0.2-1.5,0.4L559.3,254.5z M562.5,253.8c-0.2-1.3-0.6-2.7-1.9-2.5c-0.8,0.1-1,0.7-0.9,1.3c0.1,0.8,0.8,1.3,1.3,1.4
		c0.1,0,0.3,0,0.4,0L562.5,253.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M568.2,257.4l-1.8,0.3l0.2,1.7l-0.9,0.1l-0.2-1.7l-3.5,0.5c-0.8,0.1-1.2,0.4-1.1,1.1c0,0.3,0.1,0.5,0.2,0.7
		l-0.9,0.2c-0.1-0.2-0.2-0.6-0.3-1c-0.1-0.5,0-1,0.3-1.3c0.3-0.4,0.8-0.6,1.6-0.7l3.5-0.5l-0.1-1l0.9-0.1l0.1,1l1.5-0.2L568.2,257.4
		z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M564.3,266.9c-2.4,0.3-3.6-1.2-3.8-2.8c-0.2-1.7,0.9-3.2,2.9-3.5c2.2-0.3,3.6,1,3.8,2.8
		C567.5,265.2,566.3,266.6,564.3,266.9z M563.6,261.8c-1.4,0.2-2.4,1.1-2.2,2.3c0.1,1.1,1.3,1.8,2.7,1.6c1.1-0.1,2.4-0.9,2.2-2.2
		C566.2,262.1,564.9,261.6,563.6,261.8z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M565.6,268.2c0.8-0.1,1.4-0.2,2-0.3l0.1,1l-1.3,0.2l0,0.1c0.9,0.2,1.5,0.9,1.6,1.6c0,0.1,0,0.2,0,0.3l-1.1,0.1
		c0-0.1,0-0.2,0-0.4c-0.1-0.8-0.8-1.3-1.7-1.4c-0.2,0-0.4,0-0.6,0l-3.4,0.4l-0.1-1.2L565.6,268.2z"/>
</g>
  );

  const englishLevels_uz = (
    <g className="meter-lvls-eng-uz">
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M29.4,329.8l-8.9,1l-0.1-1.3l4.2-3.4c1-0.8,1.9-1.4,2.7-1.9l0,0c-1.2,0.2-2.3,0.4-3.7,0.5l-3.7,0.4l-0.1-1.1
l8.9-1l0.1,1.2l-4.2,3.3c-0.9,0.7-1.9,1.4-2.8,2l0,0c1.1-0.2,2.2-0.3,3.7-0.5l3.8-0.4L29.4,329.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M25.5,320.7c1.6-0.2,2.2-1.2,2.1-2.4c-0.1-0.8-0.3-1.3-0.5-1.8l0.8-0.3c0.2,0.4,0.5,1.1,0.6,2.1
c0.2,2-1.1,3.3-3,3.4c-1.9,0.2-3.6-0.9-3.7-2.7c-0.2-2.1,1.6-2.8,2.8-2.9c0.2,0,0.4,0,0.5,0L25.5,320.7z M24.4,317.4
c-0.7,0-1.9,0.5-1.8,1.8c0.1,1.2,1.2,1.6,2,1.6L24.4,317.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M21.5,314.4l3.2-1c0.7-0.2,1.4-0.4,2-0.6l0,0c-0.7-0.1-1.4-0.3-2.1-0.5l-3.3-0.9l0-1l3.2-1.2
c0.8-0.3,1.4-0.5,2.1-0.7l0,0c-0.7-0.1-1.3-0.2-2.1-0.4l-3.3-0.8l-0.1-1.2l6.6,1.8l0.1,1.1l-3,1.1c-0.7,0.3-1.3,0.5-2.1,0.7l0,0
c0.8,0.1,1.5,0.3,2.2,0.5l3.1,0.9l0.1,1.1l-6.4,2.3L21.5,314.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M27.3,300.3c0.2,0.3,0.4,1,0.4,1.8c0,1.9-1.3,3.2-3.2,3.3c-2,0-3.5-1.3-3.5-3.4c0-0.7,0.1-1.3,0.3-1.6l0.9,0.2
c-0.2,0.3-0.3,0.7-0.3,1.4c0,1.5,1.1,2.3,2.5,2.2c1.5,0,2.4-1,2.4-2.3c0-0.7-0.2-1.1-0.4-1.4L27.3,300.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M24.3,293.2c2.4,0,3.4,1.7,3.4,3.3c0,1.7-1.3,3.1-3.4,3c-2.2,0-3.4-1.5-3.4-3.3
C20.9,294.4,22.3,293.2,24.3,293.2z M24.2,298.3c1.4,0,2.5-0.8,2.5-1.9c0-1.1-1-2-2.5-2c-1.1,0-2.5,0.5-2.5,1.9
C21.7,297.7,23,298.3,24.2,298.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M22.8,291.6c-0.7,0-1.2,0-1.7,0l0-1l1,0l0,0c-0.6-0.4-1.2-1-1.1-2.1c0-0.9,0.6-1.5,1.4-1.8l0,0
c-0.4-0.2-0.6-0.5-0.8-0.8c-0.3-0.4-0.4-0.8-0.4-1.4c0-0.9,0.6-2.1,2.9-2l3.8,0.1l0,1.1l-3.7-0.1c-1.2,0-2,0.4-2,1.3
c0,0.7,0.5,1.2,1,1.4c0.2,0.1,0.4,0.1,0.6,0.1l4,0.1l0,1.1l-3.9-0.1c-1,0-1.8,0.4-1.8,1.3c0,0.7,0.5,1.3,1.1,1.5
c0.2,0.1,0.4,0.1,0.6,0.1l3.9,0.1l0,1.1L22.8,291.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M25,279.9c1.6,0.1,2.3-0.9,2.4-2.1c0.1-0.8-0.1-1.4-0.2-1.8l0.9-0.1c0.2,0.4,0.3,1.1,0.3,2.2
c-0.1,2-1.5,3.1-3.5,2.9c-1.9-0.1-3.4-1.4-3.3-3.3c0.1-2.1,2-2.5,3.2-2.5c0.2,0,0.4,0.1,0.5,0.1L25,279.9z M24.4,276.4
c-0.7-0.1-1.9,0.2-2,1.5c-0.1,1.2,1,1.8,1.8,1.9L24.4,276.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M24,273.7c-0.8-0.1-1.4-0.1-2-0.1l0.1-1l1.3,0.1l0-0.1c-0.8-0.4-1.3-1.1-1.2-1.9c0-0.1,0-0.2,0.1-0.3l1.1,0.1
c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.8,0.5,1.5,1.4,1.7c0.2,0,0.3,0.1,0.5,0.1l3.4,0.3l-0.1,1.2L24,273.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M66.2,150.7l-1.9,3l2.7,1.7l2.1-3.3l0.8,0.5l-2.7,4.3l-7.6-4.8l2.6-4.1l0.8,0.5l-2,3.1l2.4,1.5l1.9-3
L66.2,150.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M65.6,147.4h1.7c0.4,0,0.8,0,1.2,0l0,0c-0.2-0.4-0.4-0.8-0.5-1.1l-0.6-1.5l0.7-1.1l1.4,3.6l4,0l-0.7,1.1
l-1.7,0c-0.5,0-0.9,0-1.3,0l0,0c0.2,0.4,0.4,0.8,0.6,1.2l0.7,1.6l-0.7,1.1l-1.5-3.7l-3.8,0.1L65.6,147.4z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M70.6,143.8c-0.7-0.5-1.2-0.8-1.8-1.2l0.6-0.9l0.9,0.6l0,0c-0.4-0.8-0.3-1.7,0.3-2.6c0.9-1.3,2.7-1.5,4.3-0.4
c1.9,1.3,2,3.2,1.2,4.4c-0.5,0.7-1.2,1.1-2,1l0,0l2.9,2l-0.7,1L70.6,143.8z M72.6,143.8c0.1,0.1,0.3,0.2,0.4,0.2
c0.8,0.3,1.7,0,2.1-0.7c0.7-1,0.3-2.2-0.9-3c-1.1-0.7-2.4-0.8-3.1,0.2c-0.5,0.7-0.4,1.6,0.2,2.3c0.1,0.1,0.2,0.2,0.3,0.3
L72.6,143.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M70.8,134.6l0.7-0.9l7.7,5.6l-0.7,0.9L70.8,134.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M81.2,131c1.9,1.4,1.7,3.4,0.8,4.6c-1.1,1.4-2.9,1.7-4.5,0.5c-1.7-1.3-1.9-3.2-0.8-4.6
C77.8,130,79.7,129.8,81.2,131z M78.2,135.1c1.1,0.9,2.5,0.9,3.2-0.1c0.7-0.9,0.3-2.2-0.8-3.1c-0.9-0.7-2.3-1.1-3.1,0
C76.6,133.1,77.2,134.4,78.2,135.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M81.3,129.1c-0.6-0.5-1.1-0.9-1.6-1.2l0.6-0.8l1,0.8l0,0c-0.5-0.8-0.5-1.7,0-2.3c0.1-0.1,0.2-0.2,0.2-0.2
l0.9,0.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.6-0.4,1.5,0.2,2.2c0.1,0.1,0.2,0.3,0.4,0.4l2.7,2.1l-0.7,0.9L81.3,129.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M85.5,126.2c1.2,1,2.4,0.6,3.1-0.3c0.5-0.6,0.7-1.1,0.9-1.6l0.8,0.4c-0.1,0.4-0.4,1.1-1.1,1.9
c-1.3,1.5-3,1.6-4.5,0.4c-1.5-1.2-2-3.1-0.7-4.6c1.3-1.6,3.1-0.9,4-0.1c0.2,0.2,0.3,0.3,0.4,0.4L85.5,126.2z M87,123
c-0.6-0.5-1.7-1-2.5,0c-0.8,0.9-0.2,2,0.3,2.6L87,123z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M88.3,120.6c-0.6-0.5-1.1-0.9-1.6-1.3l0.7-0.8l1,0.8l0,0c-0.5-0.8-0.4-1.7,0.1-2.3c0.1-0.1,0.2-0.2,0.2-0.2
l0.8,0.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.6-0.5,1.5,0.1,2.2c0.1,0.1,0.2,0.3,0.4,0.4l2.6,2.3l-0.8,0.9L88.3,120.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M178.2,46.7l3.8,8.2l-1.1,0.5l-3.8-8.1L178.2,46.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M182,49.6c-0.3-0.6-0.5-1.1-0.8-1.6l1-0.4l0.5,0.9l0,0c0-0.7,0.5-1.5,1.5-2c0.8-0.4,2.3-0.4,3.2,1.6l1.6,3.5
l-1.1,0.5l-1.5-3.4c-0.4-1-1.1-1.6-2.1-1.1c-0.7,0.3-1,1.1-1,1.7c0,0.2,0.1,0.3,0.1,0.5l1.6,3.6l-1.1,0.5L182,49.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M188.7,42.8l0.7,1.7l1.6-0.6l0.3,0.8l-1.6,0.6l1.3,3.2c0.3,0.7,0.7,1.1,1.3,0.8c0.3-0.1,0.5-0.2,0.6-0.3
l0.4,0.8c-0.2,0.2-0.5,0.4-0.9,0.5c-0.5,0.2-1,0.2-1.4,0c-0.4-0.2-0.8-0.7-1.1-1.4l-1.4-3.3l-0.9,0.4l-0.3-0.8l0.9-0.4l-0.6-1.4
L188.7,42.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M194.1,46.3c0.6,1.5,1.8,1.7,2.9,1.3c0.8-0.3,1.2-0.6,1.5-1l0.5,0.7c-0.3,0.3-0.9,0.8-1.9,1.2
c-1.9,0.7-3.4-0.1-4.2-1.9c-0.7-1.8-0.2-3.7,1.5-4.4c2-0.8,3.2,0.7,3.6,1.9c0.1,0.2,0.1,0.4,0.2,0.5L194.1,46.3z M197,44.2
c-0.3-0.7-1-1.7-2.2-1.2c-1.1,0.4-1.2,1.6-1,2.4L197,44.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M203.8,38.9c0.1,0.4,0.3,0.9,0.6,1.7l1.3,3.5c0.5,1.4,0.5,2.3,0.1,3.1c-0.4,0.8-1.2,1.3-1.9,1.5
c-0.7,0.3-1.6,0.4-2.2,0.2l0-0.9c0.5,0.1,1.2,0.1,2-0.2c1.1-0.4,1.7-1.3,1.2-2.8l-0.2-0.7l0,0c-0.1,0.7-0.6,1.4-1.6,1.7
c-1.5,0.5-3.1-0.3-3.7-2c-0.7-2.1,0.2-3.7,1.6-4.2c1.1-0.4,1.8,0,2.3,0.4l0,0l-0.3-0.9L203.8,38.9z M203.5,41.8
c-0.1-0.2-0.1-0.3-0.2-0.5c-0.4-0.6-1.2-0.9-2-0.6c-1.1,0.4-1.5,1.5-1,3c0.4,1.2,1.4,2,2.6,1.5c0.7-0.2,1.1-0.9,1.1-1.7
c0-0.2-0.1-0.4-0.1-0.6L203.5,41.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M206.2,40.2c-0.2-0.7-0.5-1.3-0.7-1.9l1-0.3l0.4,1.2l0.1,0c0-0.9,0.5-1.7,1.2-1.9c0.1,0,0.2-0.1,0.3-0.1l0.4,1
c-0.1,0-0.2,0-0.4,0.1c-0.8,0.3-1.1,1-1,1.9c0,0.2,0.1,0.3,0.1,0.5l1.1,3.3l-1.1,0.4L206.2,40.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M215.1,42l-0.3-0.7l0,0c-0.2,0.6-0.7,1.2-1.6,1.5c-1.2,0.4-2.2-0.3-2.4-1.2c-0.5-1.5,0.6-2.7,3-3.5l0-0.1
c-0.2-0.5-0.6-1.4-1.9-1c-0.6,0.2-1.1,0.6-1.5,1l-0.5-0.7c0.4-0.5,1.1-0.9,1.8-1.2c1.9-0.6,2.7,0.5,3.1,1.8l0.7,2.3
c0.2,0.5,0.4,1,0.6,1.4L215.1,42z M213.9,38.9c-1.2,0.4-2.5,1-2.2,2.2c0.2,0.7,0.8,0.9,1.4,0.7c0.8-0.3,1.1-0.9,1.2-1.5
c0-0.1,0-0.3,0-0.4L213.9,38.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M216.7,32.8l0.5,1.8l1.6-0.5l0.3,0.9l-1.6,0.5l1,3.3c0.2,0.8,0.6,1.1,1.2,1c0.3-0.1,0.5-0.2,0.6-0.3l0.3,0.8
c-0.2,0.2-0.5,0.3-1,0.4c-0.5,0.2-1,0.1-1.4-0.1c-0.4-0.2-0.7-0.8-0.9-1.5l-1-3.4l-1,0.3l-0.3-0.9l1-0.3l-0.4-1.5L216.7,32.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M226.6,35.3c0.6,2.3-0.7,3.7-2.2,4.2c-1.7,0.5-3.3-0.4-3.9-2.4c-0.6-2.1,0.5-3.7,2.2-4.2
C224.5,32.4,226.1,33.4,226.6,35.3z M221.7,36.7c0.4,1.4,1.4,2.2,2.5,1.9c1.1-0.3,1.6-1.5,1.2-2.9c-0.3-1.1-1.2-2.3-2.5-1.9
C221.6,34.1,221.4,35.5,221.7,36.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M227.8,33.8c-0.2-0.7-0.4-1.4-0.5-1.9l1-0.2l0.3,1.2l0.1,0c0.1-0.9,0.6-1.6,1.4-1.8c0.1,0,0.2,0,0.3,0l0.3,1.1
c-0.1,0-0.2,0-0.4,0.1c-0.8,0.2-1.2,1-1.2,1.8c0,0.2,0,0.3,0.1,0.5l0.8,3.3l-1.1,0.3L227.8,33.8z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M368.1,35.7l-3.4-0.9l-0.8,3.1l3.8,1l-0.3,0.9l-4.9-1.3l2.3-8.7l4.7,1.3l-0.3,0.9l-3.6-1l-0.7,2.7l3.4,0.9
L368.1,35.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M371.1,34.2l0.5,1.6c0.1,0.4,0.2,0.8,0.3,1.2l0,0c0.3-0.3,0.6-0.6,0.9-0.8l1.3-1.1l1.2,0.4l-3,2.4l1.2,3.8
l-1.3-0.4l-0.5-1.7c-0.1-0.4-0.2-0.8-0.3-1.3l0,0c-0.3,0.3-0.6,0.6-1,0.9l-1.3,1.1l-1.2-0.4l3.1-2.5l-1.2-3.7L371.1,34.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M375.9,37.9c0.3-0.8,0.4-1.4,0.6-2l1,0.3l-0.3,1.1l0,0c0.7-0.6,1.6-0.8,2.6-0.5c1.5,0.5,2.2,2.1,1.6,4
c-0.7,2.2-2.4,2.9-3.9,2.4c-0.8-0.3-1.4-0.8-1.6-1.6l0,0l-1.1,3.3l-1.1-0.4L375.9,37.9z M376.5,39.9c-0.1,0.2-0.1,0.3-0.1,0.5
c0,0.8,0.5,1.6,1.3,1.9c1.2,0.4,2.2-0.4,2.6-1.8c0.4-1.2,0.1-2.5-1.1-2.9c-0.8-0.2-1.7,0.1-2.1,0.8c-0.1,0.1-0.2,0.3-0.2,0.4
L376.5,39.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M383.4,41.8c-0.5,1.5,0.2,2.5,1.3,2.9c0.8,0.3,1.3,0.3,1.8,0.3l-0.1,0.9c-0.5,0-1.2,0-2.2-0.3
c-1.9-0.7-2.6-2.3-1.9-4.1c0.7-1.8,2.2-2.9,4-2.3c2,0.7,1.9,2.6,1.5,3.8c-0.1,0.2-0.2,0.4-0.2,0.5L383.4,41.8z M386.9,42.1
c0.3-0.7,0.3-1.9-0.9-2.3c-1.1-0.4-2,0.5-2.3,1.2L386.9,42.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M389.6,42.5c0.3-0.7,0.5-1.3,0.7-1.9l1,0.4l-0.4,1.2l0.1,0c0.6-0.7,1.4-1,2.2-0.7c0.1,0,0.2,0.1,0.3,0.2
l-0.4,1c-0.1-0.1-0.2-0.1-0.4-0.2c-0.8-0.3-1.5,0.1-2,0.9c-0.1,0.1-0.2,0.3-0.2,0.5l-1.2,3.2l-1.1-0.4L389.6,42.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M396.7,41.1l-0.7,1.7l1.6,0.6l-0.3,0.8l-1.6-0.6l-1.3,3.2c-0.3,0.7-0.3,1.2,0.4,1.5c0.3,0.1,0.5,0.2,0.7,0.2
l-0.3,0.8c-0.2,0-0.6-0.1-1-0.2c-0.5-0.2-0.9-0.5-1-0.9c-0.2-0.4-0.1-1,0.2-1.7l1.3-3.3l-0.9-0.4L394,42l0.9,0.4l0.6-1.4
L396.7,41.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M504.5,117.3l0.7,0.9l-6.1,5.2l2.5,2.9l-0.7,0.6l-3.2-3.8L504.5,117.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M504.2,126.4c-1.2,1-1.1,2.2-0.4,3.1c0.5,0.7,1,1,1.4,1.2l-0.5,0.7c-0.4-0.2-1-0.6-1.7-1.4
c-1.2-1.5-1-3.3,0.5-4.5c1.5-1.2,3.4-1.3,4.6,0.2c1.3,1.6,0.2,3.2-0.7,4c-0.2,0.2-0.3,0.2-0.5,0.3L504.2,126.4z M507.1,128.5
c0.6-0.5,1.3-1.4,0.5-2.5c-0.7-0.9-1.9-0.6-2.6-0.2L507.1,128.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M507.8,135.8l0.6-0.6l0,0c-0.6,0-1.4-0.3-2-1c-0.8-1-0.5-2.1,0.3-2.7c1.2-1,2.8-0.4,4.3,1.6l0.1-0.1
c0.4-0.3,1.1-1,0.3-2.1c-0.4-0.5-0.9-0.9-1.4-1l0.5-0.7c0.6,0.2,1.3,0.7,1.7,1.3c1.2,1.6,0.4,2.8-0.6,3.6l-1.9,1.5
c-0.4,0.3-0.9,0.7-1.2,1L507.8,135.8z M510.3,133.6c-0.8-1-1.8-2-2.8-1.3c-0.6,0.5-0.6,1.1-0.2,1.6c0.5,0.7,1.3,0.8,1.8,0.6
c0.1,0,0.2-0.1,0.3-0.2L510.3,133.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M520.4,136.9l-6.3,4.6c-0.5,0.3-1,0.7-1.3,1l-0.6-0.9l0.9-0.7l0,0c-0.8,0.1-1.7-0.2-2.3-1
c-0.9-1.3-0.6-3,1-4.2c1.7-1.3,3.6-1,4.5,0.3c0.6,0.8,0.6,1.6,0.3,2.2l0,0l3.1-2.3L520.4,136.9z M515.2,139.3
c0.1-0.1,0.3-0.2,0.4-0.3c0.5-0.6,0.6-1.5,0.1-2.2c-0.7-1-2-0.9-3.2-0.1c-1.1,0.8-1.6,1.9-0.8,2.9c0.5,0.6,1.3,0.9,2.1,0.6
c0.2-0.1,0.3-0.1,0.4-0.3L515.2,139.3z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M516.7,142.9c-1.3,0.9-1.3,2.1-0.6,3.1c0.5,0.7,0.9,1,1.3,1.3l-0.6,0.6c-0.4-0.2-1-0.7-1.5-1.5
c-1.1-1.6-0.7-3.4,0.9-4.5s3.5-1,4.6,0.5c1.2,1.7,0,3.3-1,3.9c-0.2,0.1-0.4,0.2-0.5,0.3L516.7,142.9z M519.4,145.2
c0.6-0.4,1.4-1.3,0.7-2.4c-0.7-1-1.9-0.8-2.6-0.4L519.4,145.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M521.3,147.1c0.6-0.4,1.2-0.8,1.7-1.2l0.6,0.9l-1,0.7l0,0c0.9-0.2,1.7,0.1,2.2,0.7c0.1,0.1,0.1,0.2,0.1,0.3
l-0.9,0.6c0-0.1-0.1-0.2-0.2-0.4c-0.5-0.7-1.3-0.8-2.1-0.5c-0.1,0.1-0.3,0.1-0.5,0.3l-2.9,1.9l-0.6-1L521.3,147.1z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M570,274.5c0.1,0.6,0.3,1.3,0.3,2.2c0.1,1.1-0.1,2-0.6,2.6c-0.4,0.5-1,0.9-1.8,0.9c-0.8,0.1-1.5-0.1-2-0.6
c-0.7-0.6-1.1-1.5-1.2-2.7c0-0.3,0-0.7,0-0.9l-3.6,0.3l-0.1-1.2L570,274.5z M565.8,275.9c0,0.3-0.1,0.6,0,1
c0.1,1.4,0.8,2.2,2.1,2.1c1.2-0.1,1.7-1,1.6-2.2c0-0.5-0.1-0.9-0.2-1.1L565.8,275.9z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M561.6,281.9l6.5-0.4l0.1,1.2l-6.5,0.4L561.6,281.9z M570,282.7c-0.4,0-0.7-0.2-0.8-0.7c0-0.4,0.3-0.7,0.7-0.7
c0.4,0,0.7,0.3,0.8,0.7C570.7,282.4,570.4,282.7,570,282.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M565.3,290.7c-2.4,0.1-3.5-1.5-3.5-3.1c-0.1-1.7,1.2-3.1,3.2-3.2c2.2-0.1,3.5,1.3,3.5,3.1
C568.6,289.3,567.3,290.6,565.3,290.7z M565,285.6c-1.4,0-2.5,0.9-2.4,2c0,1.1,1.1,1.9,2.6,1.9c1.1,0,2.5-0.6,2.4-2
C567.6,286.1,566.3,285.5,565,285.6z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M566.7,292.2c0.7,0,1.2,0,1.7-0.1l0,1l-1.1,0.1l0,0c0.6,0.3,1.2,1,1.2,2.1c0,0.9-0.5,2.3-2.7,2.3l-3.9,0.1
l0-1.2l3.7-0.1c1,0,1.9-0.4,1.9-1.5c0-0.8-0.6-1.4-1.2-1.6c-0.1-0.1-0.3-0.1-0.5-0.1l-3.9,0.1l0-1.2L566.7,292.2z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M565.1,300.3c-1.6,0-2.3,1-2.3,2.2c0,0.8,0.1,1.4,0.3,1.8l-0.8,0.2c-0.2-0.4-0.4-1.1-0.4-2.2
c0-2,1.4-3.2,3.3-3.1c1.9,0,3.5,1.2,3.4,3.1c0,2.1-1.9,2.6-3.1,2.6c-0.2,0-0.4,0-0.5,0L565.1,300.3z M565.8,303.7
c0.7,0,1.9-0.3,1.9-1.6c0-1.2-1.1-1.7-1.9-1.8L565.8,303.7z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M564.9,307c-1.6,0-2.3,0.9-2.3,2.1c0,0.8,0.1,1.4,0.3,1.8l-0.8,0.2c-0.2-0.4-0.4-1.1-0.3-2.2
c0.1-2,1.4-3.1,3.4-3c1.9,0.1,3.4,1.3,3.4,3.2c-0.1,2.1-2,2.6-3.2,2.5c-0.2,0-0.4,0-0.5-0.1L564.9,307z M565.6,310.5
c0.7,0,1.9-0.2,2-1.5c0-1.2-1-1.8-1.8-1.9L565.6,310.5z"
      />
      <path
        style={{ fill: "#FFFFFF" }}
        className="st6"
        d="M566,313.1c0.8,0,1.4,0.1,2,0.1l-0.1,1l-1.3,0l0,0.1c0.8,0.3,1.4,1.1,1.3,1.9c0,0.1,0,0.2-0.1,0.3l-1.1-0.1
c0-0.1,0.1-0.2,0.1-0.4c0.1-0.8-0.5-1.5-1.4-1.7c-0.2,0-0.3-0.1-0.5-0.1l-3.4-0.2l0.1-1.2L566,313.1z"
      />
    </g>
  );
const sixPointsMeter = <>
<div className="report-meter">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 587.8 411.4"
          style={{ width: "590px", height: "450px", margin: "0 auto", display: "block" }}
        >
          <g>
            <path
              style={
                level != null && level.toLowerCase() === "newcomer"
                  ? { fill: "#D1D1D1", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#D1D1D1" }
              }
              className="st0"
              d="M58.4,223.6l-40.7-13.2c-8.3,27-12.8,55.8-12.8,85.5c0,31.9,5.2,62.5,14.7,91.2l40.6-13.7
		C52,349,47.6,323,47.6,295.9C47.6,270.7,51.4,246.5,58.4,223.6z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "newcomer"
                  ? { fill: "#D1D1D1", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#D1D1D1" }
              }
              className="st0"
              d="M82,365.9l156.2-52.8c-1.7-5.4-2.6-11.2-2.6-17.2c0-4.9,0.6-9.6,1.7-14.1l-156.9-51
		c-6.3,20.6-9.6,42.5-9.6,65.1C70.8,320.4,74.8,343.9,82,365.9z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "explorer"
                  ? { fill: "#BEBEBE", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#BEBEBE" }
              }
              className="st1"
              d="M142.8,101.3l-26.2-33.8c-44.1,34.3-77.9,81.1-96.3,135l0.6,0.5l39.9,13.4C76.4,170.4,105.2,130.5,142.8,101.3z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "explorer"
                  ? { fill: "#BEBEBE", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#BEBEBE" }
              }
              className="st1"
              d="M82.7,223.7l156.4,52.5c3.7-10.4,10.3-19.5,18.9-26.3L157,119.6C123,146.1,96.9,182.2,82.7,223.7z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "pioneer"
                  ? { fill: "#777777", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#777777" }
              }
              className="st2"
              d="M583.6,295.9c0-29.9-4.5-58.7-12.9-85.8l-40.9,12.7c7.2,23.1,11,47.7,11,73.1c0,27.1-4.4,53.1-12.4,77.4
		L569,387C578.5,358.3,583.6,327.7,583.6,295.9z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "pioneer"
                  ? { fill: "#777777", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#777777" }
              }
              className="st2"
              d="M352.7,295.9c0,6.1-0.9,12-2.7,17.6L506.4,366c7.3-22,11.2-45.6,11.2-70.1c0-23.1-3.5-45.3-10-66.3
		l-157.5,48.8C351.8,283.9,352.7,289.8,352.7,295.9z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "leader"
                  ? { fill: "#888888", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#888888" }
              }
              className="st3"
              d="M527.8,216.8l40.6-13.5c-18.5-54.7-52.9-102.1-97.6-136.7l-26.4,33.7C482.7,129.7,512.1,170.1,527.8,216.8z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "leader"
                  ? { fill: "#888888", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#888888" }
              }
              className="st3"
              d="M430.1,118.5L328.9,249.2c9.6,6.9,16.3,15.6,20.4,27l156.5-52C491.5,181.8,464.8,145.2,430.1,118.5z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "expert"
                  ? { fill: "#9A9A9A", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#9A9A9A" }
              }
              className="st4"
              d="M465,62.2c-47-34.4-104.9-55-167.5-55.7l-0.3,42.8c53.1,0.6,102.2,18.1,142.2,47.3L465,62.2z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "expert"
                  ? { fill: "#9A9A9A", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#9A9A9A" }
              }
              className="st4"
              d="M296,237.4c11.6,0.4,22.3,4.1,31.3,10.2l98.3-132.4c-36.2-26.3-80.5-42.1-128.5-42.7L296,237.4z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "integrator"
                  ? { fill: "#ACACAC", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#ACACAC" }
              }
              className="st5"
              d="M289.4,6.5c-62.2,1-119.7,21.7-166.4,56l25.6,34.3c39.7-29.1,88.4-46.6,141.1-47.5L289.4,6.5z"
            />
            <path
              style={
                level != null && level.toLowerCase() === "integrator"
                  ? { fill: "#ACACAC", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#ACACAC" }
              }
              className="st5"
              d="M261.2,247.6c8.6-5.9,18.9-9.6,30.1-10.1L290,72.5c-47.6,0.9-91.6,16.7-127.5,42.9L261.2,247.6z"
            />
          </g>
          <g>
            <g>
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M417.8,220.3c0.4,0.2,0.8-0.1,1.2,0.3c3.4,2.7,6.1,5.8,6.2,10.4c0.1,2.8,0,5.6,0,8.5c0,1-0.3,1.4-1.3,1.4
			c-9.7,0-19.5,0-29.2,0c-1.2,0-1.4-0.4-1.4-1.5c0.1-2.9,0-5.9,0-8.8c0.1-3.9,3.8-9.2,7.2-10.2l0,0c0.5,1,0.4,1.7-0.6,2.5
			c-3.1,2.5-5,5.6-4.6,9.8c0.2,1.5,0.1,3.1,0,4.7c-0.1,1.1,0.3,1.6,1.5,1.6c3.5-0.1,7.1-0.1,10.6,0c1.5,0,1.7-0.4,0.9-1.6
			c-2.2-3.6-4.4-7.2-6.6-10.7c-0.4-0.6-1-1.2,0.1-1.8c0.9-0.5,1.2,0.2,1.5,0.7c1.6,2.6,3.2,5.2,4.8,7.8c1.1,1.8,1.1,1.8,2.2-0.1
			c1.4-2.6,2.8-5.1,4.3-7.7c0.3-0.6,0.5-1.3,1.4-0.7c0.9,0.5,0.6,1,0.3,1.6c-0.6,1.1-1.2,2.2-1.8,3.3c-1.6,3-3.3,6-5.1,9.2
			c4.6,0,8.8,0,13,0c0.9,0,0.9-0.6,0.9-1.2c0-1.5-0.1-3,0-4.5c0.5-4.5-1.5-7.8-4.8-10.4c-0.7-0.6-0.9-1.2-1.1-2l0,0
			C417.9,220.8,418,220.6,417.8,220.3L417.8,220.3z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M409.3,199c-1.6,0-3.1-0.1-4.7,0c-1.1,0.1-1.5-0.3-1.5-1.4c0.1-0.9,0.3-1.9-0.6-2.7c-0.1-0.1-0.2-0.5-0.1-0.7
			c1.3-1.7-0.3-2.7-1-4c-2-3.9-0.9-8.8,2.6-11.3c3.6-2.6,8.4-2.3,11.5,0.8c3.2,3.2,3.5,8.1,0.8,11.7c-0.5,0.7-1.4,1.2-0.4,2.2
			c0.3,0.3,0.3,1.1-0.2,1.5c-0.4,0.3-0.4,0.7-0.4,1.1c-0.2,2.7-0.2,2.7-2.8,2.7c-0.5,0-1.1,0-1.6,0C410.3,199,409.8,199,409.3,199z
			 M402.3,186.5c-0.3,2.5,1.9,4.3,3,6.5c0.3,0.7,3,0.3,3.1-0.4c0-1.2,0.5-2.6-1.2-3.4c-1.5-0.7-2.1-2.8-1.5-4.4
			c0.6-1.6,1.8-2.5,3.6-2.5c1.7,0,3.3,1.1,3.8,2.8c0.5,1.6-0.1,3.4-1.8,4.3c-1.4,0.7-0.8,1.8-0.9,2.8c-0.1,0.4-0.1,0.9,0.5,1
			c1.3,0.1,2.7,0.4,3.2-1.2c0.3-0.8,0.8-1.4,1.2-2.1c1.6-2.6,1.4-5.9-0.5-8.2c-1.8-2.2-4.9-3.1-7.7-2.1
			C404.2,180.5,402.3,183.1,402.3,186.5z M409.3,197.2c1.1,0,2.1,0,3.2,0c0.7,0,1-0.2,1-0.9c0-0.7-0.1-1.1-1-1.1c-2.1,0-4.3,0-6.4,0
			c-0.7,0-1.1,0.2-1.1,1c0,0.8,0.3,1.1,1.1,1C407.2,197.1,408.3,197.2,409.3,197.2z M411.3,186.1c-0.2-1.1-0.8-1.9-2-1.9
			c-1.2,0-1.9,0.7-1.9,1.9c0,1.2,0.8,1.9,1.9,1.9C410.5,188.1,411.1,187.3,411.3,186.1z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M400.5,220.3c-0.9-2-2.2-3.7-2.7-5.9c-1.3-6.3,2.8-12.3,9.4-13.7c5.9-1.2,12.1,3,13.4,8.9
			c0.9,4.1-0.5,7.5-2.9,10.7c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.4,0.4c0,0,0,0,0,0c-0.5,0.3-1,0.6-1.5,1c-4.5,3.2-10.1,2.9-14.4-0.7
			C401.3,220.6,401.1,220.1,400.5,220.3L400.5,220.3z M419,212.2c0-5.4-4.3-9.8-9.6-9.9c-5.2-0.1-9.8,4.4-9.9,9.6
			c-0.1,5.4,4.3,9.9,9.8,9.9C414.7,221.9,419,217.6,419,212.2z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M433.7,215.6c-0.7-0.2-1,0.5-1.5,0.8c-3.1,2.2-6.5,3-10.2,1.9c-0.5-0.1-1.5,0-1.1-1.2c0.3-1,0.9-0.8,1.7-0.7
			c5.5,1.2,10.1-1.3,11.8-6.2c1.5-4.4-0.3-9.2-4.4-11.6c-3.9-2.3-9.2-1.4-12.1,2c-0.2,0.2-0.4,0.4-0.6,0.7c-0.5,0.7-0.9,0.3-1.4,0
			c-0.7-0.4-0.4-0.8-0.1-1.3c2.5-3.5,7.3-5.3,11.8-4.4c4.4,0.9,8,4.6,8.9,8.9c0.7,3.5-0.1,6.5-2,9.4c-0.2,0.4-0.8,0.6-0.5,1.2l0,0
			C433.7,215.1,433.6,215.3,433.7,215.6L433.7,215.6z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M384.7,215.2c0.1-0.6-0.4-0.8-0.7-1.2c-3.7-5.1-2.8-12.1,2.1-16c5-4,11.9-3.4,16.2,1.5
			c0.4,0.5,1.3,0.9,0.5,1.8c-0.9,0.9-1.3,0.2-1.8-0.4c-2.8-3.2-6.3-4.2-10.2-3.1c-3.9,1.1-6.2,3.9-6.9,8c-1.2,6.6,5.1,12.3,12,10.9
			c0.7-0.1,1.6-0.8,1.9,0.5c0.3,1.4-0.9,1.2-1.6,1.4c-3.6,0.9-6.8,0-9.7-2c-0.4-0.3-0.7-0.9-1.3-0.5l0,0
			C385.4,215.5,385,215.3,384.7,215.2L384.7,215.2z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M385,215.9c0.3,0.9-0.4,1.3-0.9,1.7c-3.2,2.6-5.1,5.8-4.7,10.2c0.2,1.5,0.1,3.1,0,4.7c0,1.1,0.4,1.5,1.5,1.5
			c3.2-0.1,6.4,0,9.5,0c0.7,0,1.5-0.2,1.5,1c0,1.1-0.8,0.9-1.4,0.9c-3.9,0-7.8,0-11.7,0c-1,0-1.4-0.3-1.3-1.3c0.1-3.1,0-6.1,0-9.2
			c0.1-3.7,3.9-9,7.2-10.1c0,0,0,0,0,0C384.5,215.6,384.7,215.8,385,215.9L385,215.9z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M434.1,215.2c3.9,2.4,6.7,5.5,6.9,10.2c0.2,3,0,6,0.1,9c0,1-0.3,1.4-1.3,1.3c-4,0-7.9,0-11.9,0
			c-0.7,0-1.2,0-1.2-0.9c0-0.9,0.5-0.9,1.2-0.9c2.8,0,5.6,0,8.5,0c2.9,0,2.9,0,2.9-3c0-1-0.1-2.1,0-3.1c0.5-4.4-1.5-7.6-4.8-10.3
			c-0.8-0.6-1-1.2-0.7-2l0,0C434,215.6,434.1,215.5,434.1,215.2L434.1,215.2z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M417.5,220.7c0-0.2,0.1-0.4,0.4-0.4C418,220.6,417.9,220.8,417.5,220.7z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M434.1,215.2c0,0.2-0.1,0.4-0.4,0.4C433.6,215.3,433.7,215.1,434.1,215.2z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M385,216c-0.3-0.1-0.5-0.4-0.4-0.8C385,215.3,385.4,215.5,385,216z"
              />
            </g>
            <g>
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M146.1,288.1c0.7-3.9-1.2-6.4-4.8-6.5c-0.7,0-1.8,0.5-2-0.6c-0.2-1.2,1-1.4,1.8-1.7c0.5-0.2,1.1-0.2,1.6-0.2
			c1.7,0,3.4,0,5,0c0.7,0,1.3,0,1.3-1c0-0.9-0.7-0.8-1.3-0.8c-2.2,0-4.4-0.1-6.7,0c-1.7,0.1-3.1,1.1-3.6,2.8
			c-0.3,1.1-0.7,1.7-1.9,1.6c-0.8-0.1-1,0.4-1,1.1c0,0.6,0.2,1.1,0.9,1c1.6-0.2,2.7,0.4,3.8,1.5c0.7,0.7,1.6,0.9,1.8-0.4
			c0.3-1.6,1.2-1.2,2.1-0.8c1.5,0.8,1.7,2.9,0.2,3.7c-0.8,0.5-1.1,1.1-0.7,1.7c0.4,0.8,1.2,0.3,1.8,0c0.5-0.3,0.9-0.7,1.4-1.1
			c0.1,1.7-0.6,2.4-2.4,2.2c-1.4-0.1-2.9,0-4.3,0c-2.5,0-4.1,1.4-4.7,3.9c-0.4,1.7,0.6,3.7,2.5,4.7c0.3,0.2,0.8,0.7,1.1,0.2
			c0.3-0.5,0.7-1,0.2-1.6c-0.3-0.3-0.7-0.5-1-0.8c-0.7-0.6-1.1-1.3-0.7-2.2c0.3-0.8,0.7-2,1.7-1.8c3,0.3,6.4-1.4,9,1.4
			c0.2,0.2,0.6,0.4,1,0.5c0.6,0.2,1.3,0.8,1.8,0.2c0.4-0.7,0.2-1.5-0.8-2.1c1.3,0,2.3,0,3.3,0c0.9,0,1.7,0.1,2.1,1
			c0.5,1,0.4,2-0.4,2.8c-0.3,0.4-0.7,0.7-1,1c-0.5,0.5-0.5,1.1-0.1,1.6c0.4,0.6,0.9,0.2,1.3,0c1.9-0.9,2.9-3.2,2.4-5.5
			c-0.4-1.7-2.1-3.1-4.1-3.1c-1.3,0-2.6,0-4,0c-0.4,0-1.1,0.2-1.2-0.5c-0.1-0.5,0.2-1,0.6-1.2c0.5-0.3,1.1-0.7,1.6-0.7
			c3.8-0.1,7.7,0,11.5-0.1c0.3,0,0.7,0,0.7,0.3c0,0.2-0.2,0.5-0.4,0.7c-0.3,0.2-0.6,0.4-0.9,0.5c-0.7,0.3-0.8,0.9-0.6,1.5
			c0.2,0.7,0.9,0.5,1.4,0.3c1.2-0.5,2.3-1.1,2.7-2.4c0.4-1.3,1.3-1.1,2.2-0.8c1.2,0.4,2.2,1.1,2,2.6c-0.1,1-0.4,2-1.7,1.8
			c-2.1-0.2-4,0.5-6.1,0.4c-1.1,0-1.8,1.2-1.1,1.7c1,0.8,0.7,1.4,0.4,2.2c-0.2,0.5-0.1,1,0.1,1.6c0.4,1.5,1.5,2.5,3,3.5
			c-1.2,0-1.9,0-2.7,0c-0.7,0-0.9,0.4-0.9,1.1c0,0.6,0.1,1.1,0.9,1.1c1.1,0,2.2,0.1,3.2,0c2.9-0.1,6,0.8,8.2-2
			c0.1-0.1,0.3-0.1,0.5-0.1c0.6-0.1,1.3,0.1,1.3-0.8c0.1-0.7,0-1.3-0.9-1.4c-0.4,0-0.4-0.4-0.6-0.6c-0.7-1.4-1.9-2.2-3.5-2.6
			c-0.6-0.2-1.2-0.4-1.4,0.5c-0.3,0.8,0.1,1.2,0.8,1.4c0.3,0.1,0.7,0.2,1,0.3c0.3,0.1,0.8,0.3,0.7,0.7c-0.1,0.5-0.6,0.3-0.9,0.4
			c-1.5,0-3,0-4.5,0c-1.5,0-2.3-0.7-2.3-2.2c-0.1-1.5,0.8-2.5,2.4-2.5c0.7,0,1.5,0.1,2.2,0c1.3-0.2,2.8-0.4,3.9-1
			c0.9-0.5-0.4-1.4-0.2-2.2c0-0.2,0.1-0.4,0.1-0.5c0.8-2.8-1.8-5.3-3.6-5.2c-2.4,0.2-2.5-1.7-3.5-2.9c-0.3-0.4-0.1-0.6,0.1-1
			c1.9-3.2,1.4-4.9-2-6.3c-0.4-0.2-0.9-0.7-1.2,0c-0.2,0.5-0.4,1.2,0.2,1.6c0.3,0.2,0.7,0.4,1.1,0.6c1.3,0.7,1.4,1.7,0.4,2.7
			c-0.7,0.7-1.5,1.1-2.6,1c-2.1-0.1-4.2,0-6.3,0c-0.6,0-1.2,0-1.3,0.9c0,1,0.6,1,1.3,1c2.1,0,4.2,0,6.3,0c0.7,0,1.4,0,2.1,0.5
			c0.4,0.3,0.8,0.6,0.7,1.1c-0.1,0.7-0.8,0.5-1.2,0.5c-3.2,0-6.5,0.1-9.7,0C149.3,286.2,147.6,286.7,146.1,288.1z M174.3,326.7
			c1.4,0,2.9-0.1,4.3,0c1.1,0.1,1.5-0.3,1.5-1.4c-0.1-1.4,0-2.9,0-4.3c0-1,0.3-1.7,1.1-2.2c1.4-0.9,2.3-2.2,2.8-3.8
			c0.5-1.3,0.3-2.7,0.6-4.1c0.2-0.7,0.5-1.8-0.9-1.8c-1.4-0.1-1.2,0.9-1.1,1.7c0,2.8-0.6,5.4-3.3,7c-0.2,0.1-0.3,0.3-0.5,0.5
			c-1.5,1.4-0.9,3.1-0.9,4.8c0,1.3-0.4,1.7-1.7,1.6c-1.5-0.1-3-0.1-4.5,0c-1.1,0.1-1.5-0.4-1.4-1.5c0.1-0.7,0-1.3,0-2
			c-0.1-1.2-0.6-2.1-1.8-2.5c-3.3-1-5.1-3.3-5.9-6.6c-0.3-1-0.3-1.8,0.8-2.4c1-0.6,1.8-1.4,2.6-2.2c0.6-0.5,1.1-1,0.4-1.8
			c-0.8-0.9-1.3-0.2-1.7,0.3c-1.6,2-3.9,2.9-6.1,3.7c-4,1.5-7.2-0.4-9.9-3.3c-0.8-0.9-1.5-1.5,0.1-2.2c0.5-0.2,0.8-0.6,0.5-1.1
			c-0.2-0.4-0.5-1.1-1-0.7c-1.1,0.8-2.6,0.6-3.7,1.7c-3.3,3-9.5,1.7-11.5-2.4c-0.9-1.9-1.3-4-1.3-6.1c0-0.9-0.3-1.3-1.2-1.3
			c-1,0.1-1,0.7-0.8,1.4c0.1,0.6,0.1,1.2,0.2,1.8c0.6,4,1.6,7.7,5.8,9.5c2.9,1.3,5.8,0.6,8.5-0.5c1.1-0.4,1.7-0.4,2.5,0.6
			c3.2,4,7.2,5.9,12.4,4.5c1.2-0.3,1.5,0,1.7,1.1c0.6,2.7,1.8,5.4,4.4,6.4c3.2,1.2,3.7,3.4,3.3,6.2c-0.2,1.1,0.4,1.5,1.5,1.4
			C171.4,326.7,172.8,326.7,174.3,326.7z M171.3,279c-0.4-1.1-0.8-2-1.2-2.9c-3.1-6.5-8.2-8.2-14.5-4.8c-1,0.5-1.5,0.5-2.4-0.1
			c-3.4-2.2-7-3.5-11.2-3.4c-5.9,0.2-10.2,6.3-11.4,11c-0.1,0.5,0.1,0.8,0.6,0.9c0.6,0.1,1.1,0,1.3-0.6c0.3-0.8,0.7-1.7,1-2.5
			c1.8-4.6,6-7.4,10.3-6.9c2.7,0.3,5.1,1.2,7.4,2.5c1,0.5,1.9,1.1,0.2,2c-0.7,0.4-1,1-0.3,1.8c0.7,0.8,1.2,0.2,1.6-0.3
			c1.5-1.5,3.2-2.7,5.2-3.5c3.1-1.4,6-0.8,8.4,1.6c1.7,1.7,2.4,4,3.1,6.2c0.1,0.4,0,1,0.6,1c0.5,0,1.2-0.1,1.2-0.5
			c0.3-1.8,1.4-1.1,2.3-0.7c2.5,0.9,4.2,2.7,4.9,5.3c0.6,2,0.5,4,0.1,6.1c-0.2,1-0.3,1.3-1.3,0.9c-0.5-0.2-1.3-0.9-1.6,0.3
			c-0.2,0.8,0.3,1.2,1,1.6c1.6,1.2,3.8,1.6,4.8,3.8c1.5,3.3,0.5,6.2-1.5,8.9c-0.4,0.6-0.8,1-0.1,1.6c0.7,0.6,1.1,0.1,1.5-0.3
			c3.6-3.5,3.7-10.1,0.1-13.5c-0.9-0.9-1-1.6-0.9-2.8c0.8-6.2-0.3-11.3-6.6-13.8C172.8,277.4,171.6,276.8,171.3,279z M117.3,293.6
			c0.1-2.2,0.9-4.5,2.7-6.5c0.8-0.9,1.5-1.1,2,0.4c0.2,0.7,0.6,1.3,0.9,1.9c0.3,0.5,0.7,1,1.5,0.6c0.7-0.4,0.6-0.9,0.3-1.5
			c-0.5-1.1-1-2.2-1.3-3.3c-1-3.5,0.2-6.2,3.4-7.8c0.7-0.4,1.5-0.7,2.3-1c0.7-0.3,0.5-0.8,0.3-1.4c-0.1-0.5-0.4-0.7-0.9-0.5
			c-3.5,1.1-7.3,3.6-7.5,8.2c0,0.9-0.3,1.4-1,1.9c-4,3.1-5.6,8.8-3.8,13.3c2,5.1,7.7,7.2,12.1,7.1c0.6,0,1.1-0.1,1.1-0.9
			c0-0.8-0.4-0.9-1.1-1c-1.4-0.2-2.7-0.4-4.1-0.7C119.9,301.4,117.3,298.1,117.3,293.6z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M146.1,288.1c1.5-1.4,3.2-1.9,5.2-1.9c3.2,0.1,6.5,0,9.7,0c0.4,0,1.1,0.2,1.2-0.5c0.1-0.5-0.4-0.9-0.7-1.1
			c-0.6-0.5-1.3-0.5-2.1-0.5c-2.1,0-4.2,0-6.3,0c-0.7,0-1.4,0-1.3-1c0-0.9,0.6-0.9,1.3-0.9c2.1,0,4.2-0.1,6.3,0c1.1,0,1.9-0.4,2.6-1
			c1-1,0.9-2-0.4-2.7c-0.4-0.2-0.8-0.4-1.1-0.6c-0.6-0.4-0.5-1.1-0.2-1.6c0.3-0.7,0.8-0.2,1.2,0c3.4,1.4,3.9,3.1,2,6.3
			c-0.2,0.3-0.4,0.6-0.1,1c0.9,1.2,1,3.1,3.5,2.9c1.9-0.1,4.5,2.4,3.6,5.2c-0.1,0.2-0.1,0.3-0.1,0.5c-0.2,0.8,1,1.8,0.2,2.2
			c-1.2,0.6-2.6,0.8-3.9,1c-0.7,0.1-1.4,0-2.2,0c-1.5,0-2.4,1-2.4,2.5c0.1,1.4,0.9,2.2,2.3,2.2c1.5,0,3,0,4.5,0
			c0.3,0,0.8,0.1,0.9-0.4c0.1-0.4-0.3-0.6-0.7-0.7c-0.3-0.1-0.7-0.3-1-0.3c-0.8-0.2-1.1-0.6-0.8-1.4c0.3-0.9,0.8-0.6,1.4-0.5
			c1.5,0.4,2.7,1.2,3.5,2.6c0.1,0.3,0.2,0.6,0.6,0.6c0.9,0.1,1,0.7,0.9,1.4c-0.1,0.9-0.7,0.8-1.3,0.8c-0.2,0-0.4,0-0.5,0.1
			c-2.2,2.8-5.3,1.9-8.2,2c-1.1,0.1-2.2,0-3.2,0c-0.7,0-0.9-0.5-0.9-1.1c0-0.6,0.2-1.1,0.9-1.1c0.8,0,1.6,0,2.7,0
			c-1.6-1-2.6-1.9-3-3.5c-0.1-0.5-0.3-1-0.1-1.6c0.3-0.8,0.6-1.5-0.4-2.2c-0.7-0.5,0-1.8,1.1-1.7c2.1,0.1,4-0.7,6.1-0.4
			c1.3,0.1,1.6-0.8,1.7-1.8c0.2-1.5-0.8-2.2-2-2.6c-0.8-0.3-1.8-0.4-2.2,0.8c-0.4,1.3-1.5,2-2.7,2.4c-0.5,0.2-1.1,0.5-1.4-0.3
			c-0.2-0.6-0.2-1.2,0.6-1.5c0.3-0.1,0.7-0.3,0.9-0.5c0.2-0.2,0.4-0.5,0.4-0.7c0-0.4-0.4-0.3-0.7-0.3c-3.8,0-7.7,0-11.5,0.1
			c-0.5,0-1.1,0.4-1.6,0.7c-0.4,0.3-0.7,0.7-0.6,1.2c0.1,0.7,0.8,0.5,1.2,0.5c1.3,0,2.6,0,4,0c2,0.1,3.8,1.4,4.1,3.1
			c0.5,2.3-0.5,4.6-2.4,5.5c-0.4,0.2-0.9,0.6-1.3,0c-0.4-0.5-0.4-1.1,0.1-1.6c0.3-0.4,0.7-0.6,1-1c0.7-0.9,0.8-1.8,0.4-2.8
			c-0.4-0.9-1.2-1-2.1-1c-1,0-2,0-3.3,0c1,0.6,1.2,1.4,0.8,2.1c-0.5,0.7-1.2,0-1.8-0.2c-0.3-0.1-0.7-0.2-1-0.5c-2.6-2.7-6-1-9-1.4
			c-1-0.1-1.4,1-1.7,1.8c-0.3,0.9,0.1,1.6,0.7,2.2c0.3,0.3,0.7,0.5,1,0.8c0.5,0.6,0.1,1.2-0.2,1.6c-0.3,0.5-0.8,0-1.1-0.2
			c-1.9-1-2.9-3-2.5-4.7c0.6-2.5,2.2-3.9,4.7-3.9c1.4,0,2.9-0.1,4.3,0c1.7,0.2,2.5-0.5,2.4-2.2c0,0,0,0,0,0
			C145.9,288.4,146,288.2,146.1,288.1C146.2,288.1,146.1,288.1,146.1,288.1z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M174.3,326.7c-1.4,0-2.9,0-4.3,0c-1.1,0-1.6-0.3-1.5-1.4c0.4-2.8,0-5-3.3-6.2c-2.6-1-3.8-3.7-4.4-6.4
			c-0.2-1.1-0.5-1.4-1.7-1.1c-5.1,1.4-9.2-0.5-12.4-4.5c-0.8-1.1-1.4-1.1-2.5-0.6c-2.8,1.1-5.6,1.8-8.5,0.5
			c-4.1-1.8-5.2-5.5-5.8-9.5c-0.1-0.6-0.1-1.2-0.2-1.8c-0.1-0.7-0.2-1.3,0.8-1.4c1-0.1,1.3,0.4,1.2,1.3c0,2.1,0.4,4.2,1.3,6.1
			c2,4,8.2,5.4,11.5,2.4c1.1-1,2.5-0.9,3.7-1.7c0.5-0.3,0.8,0.3,1,0.7c0.3,0.6,0,0.9-0.5,1.1c-1.6,0.6-0.9,1.3-0.1,2.2
			c2.7,2.9,5.9,4.8,9.9,3.3c2.2-0.8,4.5-1.8,6.1-3.7c0.4-0.5,1-1.2,1.7-0.3c0.7,0.8,0.2,1.3-0.4,1.8c-0.9,0.8-1.7,1.6-2.6,2.2
			c-1.1,0.6-1,1.4-0.8,2.4c0.8,3.3,2.6,5.6,5.9,6.6c1.2,0.4,1.8,1.3,1.8,2.5c0,0.7,0.1,1.3,0,2c-0.1,1.1,0.3,1.5,1.4,1.5
			c1.5-0.1,3-0.1,4.5,0c1.2,0.1,1.7-0.3,1.7-1.6c0-1.6-0.6-3.4,0.9-4.8c0.2-0.2,0.3-0.4,0.5-0.5c2.6-1.6,3.3-4.1,3.3-7
			c0-0.8-0.2-1.8,1.1-1.7c1.4,0.1,1.1,1.1,0.9,1.8c-0.3,1.3-0.2,2.7-0.6,4.1c-0.5,1.6-1.4,2.9-2.8,3.8c-0.9,0.5-1.2,1.2-1.1,2.2
			c0.1,1.4,0,2.9,0,4.3c0.1,1.1-0.4,1.5-1.5,1.4C177.2,326.7,175.7,326.7,174.3,326.7z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M171.3,279c0.3-2.2,1.5-1.6,2.7-1.1c6.3,2.5,7.4,7.6,6.6,13.8c-0.2,1.2-0.1,1.9,0.9,2.8
			c3.6,3.4,3.5,10-0.1,13.5c-0.4,0.4-0.8,1-1.5,0.3c-0.7-0.6-0.3-1.1,0.1-1.6c2-2.7,3-5.6,1.5-8.9c-0.9-2.1-3.1-2.6-4.8-3.8
			c-0.7-0.5-1.2-0.8-1-1.6c0.3-1.1,1.1-0.5,1.6-0.3c1,0.4,1.1,0.1,1.3-0.9c0.4-2,0.4-4-0.1-6.1c-0.7-2.6-2.4-4.4-4.9-5.3
			c-0.9-0.3-2-1-2.3,0.7c-0.1,0.5-0.8,0.5-1.2,0.5c-0.6,0-0.4-0.6-0.6-1c-0.8-2.2-1.4-4.5-3.1-6.2c-2.4-2.5-5.2-3-8.4-1.6
			c-1.9,0.9-3.7,2-5.2,3.5c-0.5,0.5-0.9,1-1.6,0.3c-0.7-0.8-0.4-1.4,0.3-1.8c1.6-0.9,0.7-1.5-0.2-2c-2.3-1.3-4.8-2.3-7.4-2.5
			c-4.3-0.5-8.5,2.4-10.3,6.9c-0.3,0.8-0.7,1.7-1,2.5c-0.2,0.6-0.8,0.7-1.3,0.6c-0.5-0.1-0.7-0.5-0.6-0.9c1.2-4.8,5.5-10.9,11.4-11
			c4.1-0.1,7.8,1.2,11.2,3.4c0.9,0.6,1.5,0.6,2.4,0.1c6.3-3.4,11.4-1.6,14.5,4.8C170.5,277,170.8,277.9,171.3,279z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M117.3,293.6c0,4.5,2.6,7.8,6.8,8.9c1.3,0.3,2.7,0.5,4.1,0.7c0.7,0.1,1.2,0.2,1.1,1c0,0.8-0.5,0.9-1.1,0.9
			c-4.4,0-10.1-2-12.1-7.1c-1.7-4.5-0.2-10.2,3.8-13.3c0.7-0.5,1-1,1-1.9c0.2-4.6,3.9-7.1,7.5-8.2c0.5-0.2,0.8,0,0.9,0.5
			c0.2,0.5,0.4,1.1-0.3,1.4c-0.8,0.3-1.6,0.6-2.3,1c-3.2,1.6-4.4,4.3-3.4,7.8c0.3,1.1,0.8,2.2,1.3,3.3c0.3,0.6,0.4,1.1-0.3,1.5
			c-0.7,0.4-1.1-0.1-1.5-0.6c-0.4-0.6-0.7-1.3-0.9-1.9c-0.4-1.5-1.1-1.3-2-0.4C118.2,289.1,117.4,291.5,117.3,293.6z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M145.8,288.5c-0.5,0.4-0.9,0.8-1.4,1.1c-0.5,0.3-1.3,0.8-1.8,0c-0.4-0.7-0.1-1.3,0.7-1.7
			c1.5-0.9,1.3-3-0.2-3.7c-0.9-0.4-1.8-0.9-2.1,0.8c-0.2,1.3-1.1,1.1-1.8,0.4c-1.1-1.1-2.2-1.8-3.8-1.5c-0.7,0.1-0.9-0.4-0.9-1
			c0-0.7,0.2-1.2,1-1.1c1.2,0.1,1.6-0.5,1.9-1.6c0.5-1.7,1.9-2.7,3.6-2.8c2.2-0.1,4.4,0,6.7,0c0.6,0,1.2-0.1,1.3,0.8
			c0,1-0.6,1-1.3,1c-1.7,0-3.4,0-5,0c-0.5,0-1.1,0-1.6,0.2c-0.8,0.3-2,0.5-1.8,1.7c0.2,1.1,1.3,0.6,2,0.6c3.6,0.1,5.5,2.6,4.8,6.5
			c0,0,0,0,0,0C146,288.2,145.9,288.4,145.8,288.5C145.8,288.5,145.8,288.5,145.8,288.5z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M145.8,288.5c0.1-0.1,0.3-0.3,0.4-0.4C146,288.2,145.9,288.4,145.8,288.5z"
              />
            </g>
            <g>
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M426.5,299.2c0-1.3,0-2.5,0-3.8c0-0.9,0.2-1.8-1.2-2.2c-0.9-0.2-0.9-1.4,0-1.7c0.8-0.3,1.2-0.6,1.2-1.5
			c-0.1-0.6,0.3-0.8,0.9-0.8c0.6,0,0.9,0.3,0.9,0.9c-0.1,1.3,0.7,1.3,1.6,1.3c4.7,0.1,4.6,0.1,4.6-4.6c0-1-0.2-1.6-1.3-2
			c-2.4-1-3.6-3.6-3-6.3c0.5-2.2,2.8-4.1,5.1-4.1c2.5,0,4.8,1.8,5.5,4.4c0.6,2.3-0.6,4.9-3,5.9c-1.3,0.5-1.6,1.3-1.5,2.6
			c0.1,4.1,0,4.1,4,4.1c1.1,0,2.4,0.3,2.2-1.6c-0.1-0.7,0.6-0.6,1.1-0.6c0.6,0,0.9,0.3,0.9,0.9c0,0.7,0.2,1.1,1,1.4
			c0.8,0.4,0.9,1.5-0.1,1.9c-1,0.4-0.8,1-0.8,1.7c0,2.7,0.1,5.4,0,8.1c-0.1,1.6,0.6,2.1,2,2.3c4.2,0.5,8.4,1.3,12.4,2.8
			c2,0.7,3.9,1.6,5.4,3.1c2.6,2.5,2.4,5.5-0.5,7.6c-3.3,2.4-7.1,3.6-10.9,4.4c-7.3,1.6-14.7,2.2-22.1,1.8c-8-0.4-15.9-1.2-23.2-4.7
			c-1.2-0.6-2.1-1.3-3-2.2c-2.3-2.4-2.1-5.3,0.6-7.2c3.7-2.7,7.9-3.9,12.3-4.7c2.6-0.5,5.3-1.1,8-1.1c1,0,1.2-0.5,1.2-1.4
			C426.5,302.3,426.6,300.7,426.5,299.2C426.5,299.2,426.5,299.2,426.5,299.2z M434.6,323.5c6-0.2,12-0.6,17.9-1.9
			c3.3-0.8,6.7-1.6,9.5-3.6c3.1-2.1,3.1-4.2-0.1-6.2c-3.4-2.1-7.1-3.1-11-3.8c-2-0.4-4-0.8-6-0.8c-0.3,0-0.8,0-0.9,0.4
			c-0.1,0.6,0.4,0.6,0.8,0.7c0.4,0.1,0.7,0,1.1,0c4.2,0.5,8.4,1.1,12.4,2.9c1.7,0.8,3.6,1.7,3.5,3.9c-0.1,2.2-2.1,2.9-3.8,3.7
			c-5,2.2-10.4,2.9-15.8,3.1c-8.6,0.4-17.2,0.5-25.6-1.4c-2.8-0.6-5.7-1.2-7.9-3.2c-1.9-1.7-1.7-3.6,0.3-5.1c1.8-1.3,3.9-1.8,6-2.4
			c3.6-1.1,7.3-1.3,11-1.8c0.3,0,0.8,0.1,0.8-0.4c0-0.5-0.4-0.7-0.9-0.7c-0.4,0-0.8,0-1.3,0c-2.8,0.5-5.7,0.8-8.5,1.5
			c-3.6,0.9-7.4,1.7-10.3,4.5c-1.4,1.4-1.4,2.7,0,4.2c1.6,1.6,3.6,2.4,5.6,3.1C418.9,322.7,426.7,323.2,434.6,323.5z M434.5,318.8
			c-4,0.1-8.1,0-12.2-0.4c-2.6-0.3-5.1-0.6-7.6-1.4c-1-0.3-2.1-0.8-2.1-1.9c-0.1-1.3,1.1-1.7,2.1-2.1c4.2-1.4,8.6-1.5,12.9-1.7
			c0.5,0,1.6,0.4,1.6-0.5c0-0.8-0.9-1-1.7-0.9c-1.4,0.1-2.9,0.2-4.3,0.4c-3.7,0.5-7.4,1-10.8,2.4c-1.2,0.5-3.1,0.9-3.1,2.4
			c0,1.6,1.8,2,3.2,2.5c5.6,2,11.4,2.7,17.3,2.8c5,0.1,10,0.3,14.9-0.3c4.2-0.5,8.4-1,12.4-2.7c1.1-0.5,2.8-0.9,2.8-2.3
			c0-1.4-1.6-1.8-2.7-2.3c-3.6-1.5-7.4-2-11.2-2.6c-1.1-0.2-2.1-0.3-3.2-0.3c-0.7,0-1.3,0.4-1.3,1c0,0.7,0.7,0.4,1.2,0.5
			c1.8,0.1,3.6,0.1,5.4,0.4c2.2,0.3,4.5,0.5,6.7,1.4c0.8,0.3,1.7,0.7,1.8,1.8c0.1,1.2-0.9,1.5-1.7,1.8c-0.6,0.3-1.2,0.5-1.9,0.6
			C446.9,318.7,440.8,318.9,434.5,318.8z M414.6,315.1c6.8,1.7,13.2,2,19.9,1.9c-1.7-2.5-3-4.6-6.2-4.1c-2.2,0.4-4.6,0.1-6.8,0.5
			C419.4,313.7,417.1,313.7,414.6,315.1z M454.1,315c-0.8-0.6-1.6-0.8-2.4-0.9c-2.5-0.5-5-0.6-7.4-0.9c-2.9-0.5-5.5-0.4-7,2.6
			c-0.2,0.3-0.6,0.5-0.5,0.9c0.2,0.5,0.7,0.3,1.1,0.3c2.9,0.2,5.9-0.2,8.8-0.5C449.1,316.3,451.7,316.1,454.1,315z M436.2,299.5
			c0,1.6,0.1,3.1,0,4.7c-0.1,1.3,0.6,1.6,1.8,1.6c1.1,0,1.9-0.1,1.9-1.5c-0.1-3.2-0.1-6.4,0-9.6c0-1.6-1.1-1.2-2-1.3
			c-1-0.1-1.8,0-1.7,1.4C436.3,296.4,436.2,298,436.2,299.5z M434.5,299.8c0-1.7,0-3.5,0-5.2c0-1.2-0.8-1.1-1.6-1.1
			c-0.8,0-1.8-0.3-1.8,1.1c0,3.3,0,6.7,0,10c0,1.3,0.8,1.2,1.7,1.2c0.8,0,1.7,0.1,1.7-1.2C434.4,303,434.5,301.4,434.5,299.8z
			 M431.9,280c0,2,1.5,3.5,3.6,3.5c1.8,0,3.7-1.8,3.6-3.5c-0.1-1.9-1.9-3.7-3.8-3.7C433.6,276.3,431.9,278.1,431.9,280z
			 M429.6,307.6c1.7,2,3.1,3.7,4.5,5.3c0.4,0.5,0.9,0.7,1.3,0.1c1.2-1.5,2.4-2.9,3.6-4.4c0.4-0.5,0.5-1-0.5-1
			C435.7,307.6,432.9,307.6,429.6,307.6z M429.4,299.5c0-1.6,0-3.2,0-4.9c0-0.4,0.1-1.1-0.6-1.1c-0.6,0-0.5,0.6-0.5,1
			c0,3.4,0,6.7,0,10.1c0,0.4-0.1,1,0.5,1c0.7,0,0.6-0.7,0.6-1.1C429.4,302.9,429.4,301.2,429.4,299.5z M442.1,293.6
			c-0.6,0.4-0.4,0.8-0.4,1.2c0,2.9,0,5.9,0,8.8c0,0.5-0.3,1.3,0.5,1.3c0.7,0,0.7-0.8,0.6-1.3c-0.4-2.7-0.3-5.4-0.3-8.1
			C442.4,294.9,442.6,294.2,442.1,293.6z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M423.2,279.1c0,2.8,1,5.3,2.9,7.4c0.5,0.6,1.2,1.1,0.3,1.9c-0.9,0.8-1.3-0.2-1.7-0.6
			c-1.4-1.6-2.4-3.4-2.9-5.5c-0.2-1-0.6-1.6-1.8-1.4c-0.8,0.1-1.4,0-1.4-1.1c0-1,0.7-0.9,1.4-0.9c0.7,0,1.7,0.1,1.5-1
			c-0.2-1,1.2-2.4-0.7-3c-0.6-0.2-1.7-0.3-1.1-1.5c0.5-1.1,1.2-0.4,1.8-0.2c0.7,0.3,1.3,0.2,1.6-0.5c0.6-1.2,2.2-2.3,0.2-3.7
			c-0.5-0.3-0.1-0.9,0.2-1.2c0.4-0.5,0.8-0.4,1.2,0c0.5,0.4,0.8,1.3,1.6,0.9c0.9-0.4,1.8-1,2.5-1.7c0.5-0.4-0.1-1-0.2-1.5
			c-0.1-0.5-0.5-1.1,0.3-1.4c0.7-0.3,1.2-0.1,1.4,0.7c0.3,1.3,0.9,1.4,2.2,1.2c5.5-1,11.1,2,13.7,6.9c2.6,4.9,1.9,11-1.8,14.9
			c-0.4,0.5-0.8,1.6-1.8,0.8c-1.1-0.9,0-1.4,0.4-1.9c5-5.9,3.2-15.1-4.3-18.2C431.2,265.3,423.2,270.9,423.2,279.1z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M413.9,280.8c-0.8,0-1.6,0-2.3,0c-0.7,0-0.9-0.4-0.9-1c0-0.6,0.2-1,0.9-1c1.5,0,3,0,4.5,0c0.7,0,1,0.2,1,0.9
			c0,0.7-0.2,1.1-1,1.1C415.3,280.8,414.6,280.8,413.9,280.8z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M457.2,280.9c-0.7,0-1.4,0-2.1,0c-0.6,0-1-0.1-1-0.9c0-0.6,0.2-1.1,0.9-1.1c1.5,0,3.1,0,4.6,0
			c0.7,0,0.9,0.5,0.9,1.1c0,0.7-0.4,0.9-1,0.9C458.6,280.8,457.9,280.9,457.2,280.9z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M436.5,264.2c0,0.6,0,1.2-1,1.2c-1.1,0-1.1-0.6-1.1-1.4c0-0.7-0.1-1.5,1-1.4
			C436.5,262.6,436.5,263.3,436.5,264.2z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M451.8,280.8c-1.2,0.1-1.9,0.1-1.9-1c0-1,0.6-1,1.3-1c0.9,0,1.6,0.1,1.5,1.2
			C452.7,281.1,452,280.8,451.8,280.8z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M441.4,266.7c-0.5-0.2-1.2-0.3-1.1-1c0.1-0.7,0.1-1.7,0.9-1.9c0.5-0.2,1.2,0.2,1.1,1
			C442.3,265.6,442.1,266.3,441.4,266.7z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M421.1,284.9c0.7-0.1,1,0.2,1,0.8c0.1,1.2-1,1.1-1.7,1.4c-0.9,0.3-0.9-0.5-0.9-0.9
			C419.3,284.9,420.7,285.4,421.1,284.9z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M449.6,274.9c-0.8,0.1-0.9-0.6-0.9-1c0-1.1,1.1-0.9,1.8-1.2c0.6-0.2,0.9,0.3,0.9,0.8
			C451.4,274.8,450.2,274.5,449.6,274.9z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M451.4,285.9c0,0.7-0.2,1.2-0.8,1c-0.7-0.2-1.8,0-1.9-1.2c0-0.3,0-1.3,0.8-1.1
			C450.3,284.9,451.2,284.9,451.4,285.9z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M447,267.3c0.5,0.3,1.1,0.6,1,1.1c-0.3,0.8-0.8,1.5-1.7,1.6c-0.4,0.1-1-0.5-0.9-1
			C445.6,268.2,446.4,267.7,447,267.3z"
              />
            </g>
            <g>
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M349.4,199.1c-1.1-1-2.2-1.8-3.2-2.8c-1-1-1.6-0.8-2.5,0.1c-0.7,0.8-1.6,1.5-2.8,2.6c0-2.4,0-4.3,0-6.2
			c0-1-0.2-1.4-1.3-1.3c-1,0-1.6,0-1.5,1.3c0.1,1.9,0,3.8,0,6c-1.2-0.6-1.9-1.4-2.6-2.2c-1.1-1.4-2-1.2-3.2,0
			c-0.8,0.9-1.7,1.8-3.2,2.5c0-2.8,0-5.3,0-7.9c0-2,0.2-4-0.9-5.8c-0.4-0.6-0.5-1.4-0.2-2.1c0.6-1.7-0.4-1.7-1.6-1.7
			c-4.9,0-9.9,0-14.8,0c-1.4,0-1.7-0.4-1.7-1.7c0-13.3,0-26.7,0-40c0-1.2,0.3-1.6,1.6-1.6c18.5,0,37,0,55.5,0c1.3,0,1.6,0.4,1.6,1.7
			c0,13.3,0,26.7,0,40c0,1.4-0.4,1.7-1.7,1.7c-4.9-0.1-9.7,0-14.6,0c-1.2,0-2.2,0-1.7,1.7c0.1,0.4,0.2,1,0,1.4
			c-1.9,4-0.7,8.3-1,12.4C349.6,197.8,349.8,198.4,349.4,199.1z M339.5,143.5c-7.3,0-14.5,0-21.8,0c-1,0-1.7,0.1-1.6,1.4
			c0,10.1,0,20.2,0,30.3c0,1.2,0.4,1.4,1.5,1.4c1.9-0.1,3.7-0.1,5.6,0c1.6,0.1,3,0.1,3.5-1.8c0.1-0.4,0.6-0.8,1-1
			c0.7-0.4,0.8-0.9,0.7-1.6c-0.6-3.7,2-6.4,5.7-5.7c0.7,0.1,1.2,0,1.7-0.6c2.2-2.7,5.4-2.7,7.6-0.1c0.7,0.8,1.2,0.9,2.1,0.7
			c2.6-0.5,5.5,1.6,5.4,4.2c0,1.7,0.9,2.7,1.6,4c1.2,2.4,3,2.1,4.9,2.1c1.3,0,2.7-0.1,4,0c1.3,0.1,1.6-0.4,1.6-1.6
			c0-9.9-0.1-19.8,0-29.8c0-1.3-0.3-1.7-1.7-1.7C353.8,143.6,346.7,143.5,339.5,143.5z M339.4,140.3c-8.5,0-17.1,0-25.6,0
			c-1.1,0-1.7,0.2-1.7,1.5c0.1,12.2,0,24.4,0,36.6c0,1.1,0.3,1.4,1.4,1.4c3.7-0.1,7.5,0,11.2,0c0.4,0,1.3,0.4,1.3-0.4
			c0.1-0.8-0.7-1-1.4-1c-2.9,0-5.9,0-8.8,0c-1.3,0-1.6-0.4-1.6-1.7c0-11.2,0-22.4,0-33.5c0-1.4,0.4-1.7,1.7-1.7
			c15.7,0,31.4,0,47.1,0c1.2,0,1.7,0.3,1.7,1.6c0,11.2,0,22.5,0,33.7c0,1.3-0.5,1.6-1.7,1.6c-2.8-0.1-5.5,0-8.3,0
			c-0.6,0-1.3-0.1-1.3,0.8c0,0.9,0.8,0.5,1.2,0.5c3.4,0,6.7-0.1,10.1,0.1c1.5,0.1,2-0.3,2-1.9c-0.1-11.9-0.1-23.8,0-35.7
			c0-1.7-0.5-2-2-2C356.2,140.3,347.8,140.3,339.4,140.3z M342.5,185c2.9,2.2,4.1,2.4,5.3,1.2c2.2-2.2,0.3-3.8-1-5.5
			c3.6-0.4,4.6-1,4.7-2.8c0.2-3.4-2.6-2.9-4.8-3.3c1.5-1.7,3.3-3.3,1.4-5.4c-2-2.1-3.8-0.4-5.5,0.9c-0.5-3.2-1.2-4.2-2.9-4.3
			c-2.9-0.1-2.9,2.2-3.4,4.2c-2.9-2-4.3-2.2-5.5-1c-1.2,1.2-0.9,2.7,1.1,5.4c-2,0.3-4.2,0.5-4.2,3.2c0,2.5,2.1,2.7,4,3.1
			c-1.3,1.6-2.8,3.3-1,5.1c2.1,2.2,3.9,0.3,5.7-1c0.7,3.8,1.3,4.8,3.2,4.7C341.4,189.5,342.2,188.4,342.5,185z M347.8,195.1
			c0-1.3,0-2.3,0-3.2c0-1,0.1-2.1-0.2-3c-0.1-0.2-1.6,0.2-2.3,0c-1.8-0.5-2.1,0.7-2.4,1.8c-0.2,1.1-0.1,2.3-0.1,4.2
			C344.9,191.5,346.1,193.7,347.8,195.1z M336.2,194.3c0-1.1-0.1-1.9,0-2.7c0.1-1.2-0.5-2.3-1.3-2.8c-1-0.6-2.3,0.3-3.5,0
			c-0.2-0.1-0.2,0.5-0.2,0.8c0,1.7,0,3.4,0,5.2C334,192.9,334,192.9,336.2,194.3z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M339.7,154.6c5.8,0,11.7,0,17.5,0c0.7,0,1.7-0.3,1.7,1c0,1.3-1,0.9-1.7,0.9c-11.8,0-23.6,0-35.3,0
			c-0.6,0-1.4,0.4-1.7-0.5c-0.4-1.2,0.3-1.4,1.4-1.4C327.6,154.6,333.7,154.6,339.7,154.6z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M339.6,158.2c5.9,0,11.8,0,17.7,0c0.6,0,1.5-0.3,1.6,0.9c0.1,1.3-0.9,1-1.6,1c-11.8,0-23.7,0-35.5,0
			c-0.6,0-1.5,0.4-1.6-0.9c0-1.3,0.9-1,1.6-1C327.7,158.2,333.6,158.2,339.6,158.2z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M339.5,150.6c5.9,0,11.8,0,17.7,0c0.6,0,1.5-0.3,1.6,0.9c0.1,1.3-0.9,1-1.6,1c-11.8,0-23.7,0-35.5,0
			c-0.6,0-1.5,0.4-1.6-0.9c-0.1-1.3,0.9-1,1.6-1C327.7,150.6,333.6,150.6,339.5,150.6z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M327.1,162.6c1.9,0,3.8,0,5.7,0c0.6,0,1.2-0.1,1.3,0.8c0,0.9-0.5,1.1-1.2,1.1c-3.9,0-7.9,0.1-11.8,0.1
			c-0.8,0-1-0.4-1-1.1c0-0.8,0.5-1,1.1-1C323.1,162.6,325.1,162.6,327.1,162.6z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M339.4,171.8c3.3,0,5.9,2.6,5.9,5.8c0,3.1-2.7,5.8-5.8,5.8c-3.2,0-5.8-2.6-5.8-5.9
			C333.7,174.3,336.2,171.9,339.4,171.8z M339.5,181.4c2.1,0,3.8-1.7,3.9-3.7c0-2.1-1.7-3.9-3.9-3.9c-2,0-3.8,1.7-3.9,3.7
			C335.6,179.6,337.4,181.4,339.5,181.4z"
              />
            </g>
            <g>
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M248.8,144.9c1.3-1.4,2.1-3,3.7-4.1c1.9-1.3,3.8-2,6.1-2c6.5,0,13,0,19.5,0c1.3,0,1.6,0.4,1.6,1.6
			c0.3,7.7-6.6,14.4-13.9,14.2c-4.7-0.2-9.4,0-14.1-0.1c-1.7,0-1.7,0.8-1.8,2.1c0,1.4,0.2,2.2,1.8,2c0.4-0.1,0.8,0,1.3,0
			c1.4-0.2,1.9,0.4,1.7,1.7c0,0.3,0,0.6,0,0.9c-0.1,0.9,0.3,1.4,1.1,1.8c0.9,0.4,1.3,0,1.8-0.6c2-1.9,2-1.9,3.9,0.1
			c1.7,1.7,3.4,3.5,5.1,5.1c0.9,0.9,1,1.5,0,2.3c-0.3,0.2-0.5,0.5-0.8,0.8c-0.7,0.6-0.8,1.2-0.4,2.1c0.4,0.9,0.9,1.1,1.8,1.1
			c2.6,0,2.6,0.1,2.6,2.6c0,2.5-0.1,4.9,0,7.4c0,1.2-0.3,1.7-1.5,1.5c-0.5-0.1-1.1,0-1.6,0c-0.7,0-1,0.4-1.3,1
			c-0.2,0.6-0.3,1.1,0.2,1.6c0.4,0.3,0.7,0.7,1,1c1,0.8,0.9,1.4,0,2.3c-2,1.8-3.9,3.8-5.7,5.7c-1,1.1-1.8,1.3-2.7,0
			c-0.2-0.2-0.4-0.4-0.6-0.6c-0.6-0.6-1.2-0.7-1.9-0.4c-0.8,0.3-1,0.9-1,1.7c-0.1,2.8-0.1,2.8-2.9,2.8c-2.2,0-4.5-0.1-6.7,0
			c-1.5,0.1-2.2-0.3-1.9-1.9c0.1-0.4,0-0.7,0-1.1c0.1-0.8-0.3-1.2-1-1.5c-0.7-0.3-1.3-0.2-2,0.3c-2.2,2-2.2,1.9-4.4-0.2
			c-1.6-1.6-3.1-3.2-4.7-4.7c-1-0.9-1-1.6,0-2.5c0.6-0.6,1.7-1,1.4-2.1c-0.3-1.4-1.3-1.8-2.5-1.6c-1.5,0.2-2.1-0.2-2-1.9
			c0.2-2.6,0.1-5.3,0-7.9c-0.1-1.4,0.4-1.8,1.8-1.7c0.7,0.1,1.5,0.3,2.1-0.3c0.9-1,0.9-2-0.3-2.9c-1.5-1.1-1.4-2.1,0-3.4
			c1.6-1.4,3.1-3,4.6-4.6c1.9-1.9,1.9-1.9,3.8,0c0.5,0.5,1,1,1.8,0.5c0.7-0.4,1.2-0.8,1.1-1.6c0-0.2,0-0.5,0-0.7
			c-0.3-1.7,0.5-2.3,2.1-2c0.2,0,0.4,0,0.5,0c2.3,0,3.1-1.1,2.4-3.4c-0.3-1-1-0.6-1.6-0.6c-5.1,0-10.1,0-15.2,0
			c-6,0-12.2-5.7-12.8-11.6c-0.4-4.1-0.4-4.1,3.7-4.1c5,0,10,0.2,15,0C242.1,138.6,246.2,140.2,248.8,144.9z M247.9,165.8
			c0-1.4-0.1-2.8,0-4.1c0.1-1.1-0.5-1.3-1.4-1.3c-0.9,0-1.7,0-1.6,1.3c0,0.7,0.4,1.7-0.2,2.1c-1.1,0.7-2.5,1.3-3.8,1.6
			c-0.9,0.3-1.3-0.7-1.8-1.3c-0.8-0.8-1.3-0.8-2,0c-1.1,1.2-2.3,2.5-3.6,3.6c-0.9,0.8-0.9,1.5,0.1,2.1c2.2,1.4,0.4,2.9,0.1,4.4
			c-0.3,1.6-1.4,1.5-2.4,1.3c-1.2-0.1-1.6,0.4-1.5,1.5c0.1,1.6,0.1,3.2,0,4.9c-0.1,1.1,0.3,1.8,1.5,1.6c2.7-0.6,2.4,1.8,3.3,3.1
			c0.8,1.3-0.2,1.9-0.9,2.5c-0.8,0.7-0.9,1.2,0,2c1.2,1.1,2.4,2.2,3.4,3.4c0.9,1,1.5,0.8,2.3-0.1c0.5-0.6,1.1-1.7,2.2-0.9
			c1.3,0.9,3.9,0.5,3.5,3.3c-0.2,1.2,0.4,1.6,1.5,1.5c1.7-0.1,3.5,0,5.2,0c0.8,0,1.4-0.2,1.2-1.1c-0.4-1.9,0.6-2.5,2.2-3.2
			c1.5-0.6,2.6-1,3.7,0.6c0.5,0.8,1.1,0.9,1.9,0.1c1.1-1.2,2.3-2.4,3.6-3.6c0.8-0.7,0.9-1.4,0-2c-2.2-1.5-0.4-3.1-0.1-4.6
			c0.3-1.5,1.6-1,2.5-1c1.1,0,1.5-0.4,1.5-1.5c0-1.6-0.1-3.1,0-4.7c0.1-1.4-0.4-2-1.8-1.8c-1.4,0.2-2.2-0.3-2.3-1.7
			c0-0.3-0.2-0.7-0.4-1c-0.9-1.2-0.7-2.2,0.5-3c0.9-0.7,1-1.3,0-2.1c-1.3-1.1-2.4-2.3-3.6-3.6c-0.7-0.8-1.3-0.8-1.8,0.1
			c-1.5,2.4-3.1,0.5-4.7,0.1c-1.5-0.3-1.3-1.5-1.3-2.6c0.1-1-0.4-1.4-1.4-1.4c-1,0-1.4,0.3-1.4,1.3c0.1,2.5,0.1,5.1,0,7.6
			c0,1.1,0.3,1.5,1.5,1.7c5.6,0.8,9.2,6.4,7.9,11.7c-1.1,4.2-4.8,7.2-9,7.3c-4.2,0.1-8.3-2.8-9.4-6.8c-1.2-4.2,0.2-8.9,4.1-10.7
			c3.1-1.4,3.3-3.4,3-6C247.9,166.3,247.9,166,247.9,165.8z M230.9,140.8c-3.1,0-6.2,0-9.4,0c-1.2,0-1.6,0.4-1.5,1.6
			c0.5,5.4,5.6,10.2,11,10.2c4.6,0,9.1,0,13.7,0c3.6,0,3.1,0.5,3.1-3.2c0-4.7-3.7-8.5-8.4-8.5C236.7,140.8,233.8,140.8,230.9,140.8z
			 M267.2,140.8c-1.1,0-2.3,0-3.4,0c-2.3,0-4.6-0.2-6.8,0.1c-3.6,0.5-7.5,4.3-7.1,9.3c0.1,1.7,0.4,2.4,2.3,2.3c4.5-0.2,9-0.3,13.5,0
			c5.9,0.4,11.4-4.8,12-10.4c0.1-1.1-0.1-1.4-1.1-1.4C273.4,140.8,270.3,140.8,267.2,140.8z M249.9,181.3c-1.4,0-2.8,0-4.1,0
			c-0.7,0-1-0.2-1-0.9c0-0.6,0.3-0.9,0.9-0.8c2.5,0.5,2.4-1.1,2.3-2.7c-0.1-0.8-0.1-1.7,0-2.5c0.1-1.2-0.3-1.3-1.3-0.9
			c-3.2,1.5-5.1,5.7-4,9.1c1,3.3,4.9,6,8,5.5c4.2-0.6,7.1-3.8,7.1-7.7c0-3.8-2.9-7.1-6.6-7.7c-0.8-0.1-1.4,0-1.4,1c0,1.5,0,3,0,4.5
			c0,0.9,0.4,1.3,1.3,1.3c1,0,1.9,0,2.9,0c0.7,0,1.2,0,1.2,0.9c0,0.9-0.6,0.9-1.2,0.9C252.5,181.3,251.2,181.3,249.9,181.3z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M261.5,179.5c0.8,0,1.5-0.1,1.4,0.9c0,1-0.8,0.8-1.4,0.8c-0.6,0-1.4,0.2-1.4-0.8
			C260.1,179.3,261,179.6,261.5,179.5z"
              />
              <path
                style={{ fill: "#FFFFFF" }}
                className="st6"
                d="M238.4,181.3c-0.7,0-1.3,0.1-1.3-0.9c0-0.9,0.6-0.9,1.2-0.8c0.7,0,1.3-0.1,1.3,0.9
			C239.6,181.4,239,181.3,238.4,181.3z"
              />
            </g>
            <path
              style={{ fill: "#FFFFFF" }}
              className="st6"
              d="M202.9,244.1c-1.8,0-3.4-0.6-4.7-1.9c-3.2-3.3-6.5-6.4-9.7-9.7c-0.8-0.8-1.3-1.1-2.1-0.1
		c-0.4,0.5-0.8,1.2-1.6,0.4c-0.8-0.7-0.3-1.2,0.2-1.8c0.4-0.4,1.1-0.8,0.5-1.5c-0.6-0.6-1.1-1.7-2.3-1.2c-1.3,0.5-2.6,1.1-4,1.7
		c-1,0.4-0.6,1.2-0.6,1.9c-0.1,3.2,0,3.2-3.1,3.2c-2.5,0-5.1,0-7.6,0c-1.1,0-1.8-0.2-1.6-1.5c0.5-2.5-0.6-3.6-3-4.5
		c-2-0.8-3.3-0.8-4.5,1c-0.9,1.2-1.7,1.1-2.7,0c-2-2.2-4.2-4.3-6.4-6.4c-0.9-0.8-0.9-1.5,0-2.2c2-1.4,2.3-2.9,0.9-4.9
		c-0.2-0.3-0.4-0.8-0.4-1.2c-0.2-1.4-1.1-1.7-2.4-1.7c-3.1,0.1-2.7,0.5-2.8-2.8c0-2.6,0-5.3,0-7.9c0-1.2,0.3-1.7,1.5-1.5
		c0.2,0,0.4,0,0.5,0c1.9,0.3,3.1-0.3,3.4-2.3c0-0.2,0.1-0.3,0.2-0.5c1.3-2,1.1-3.6-0.9-4.9c-1-0.6-0.9-1.3,0-2.2
		c2.3-2.2,4.5-4.4,6.6-6.6c0.8-0.9,1.5-0.9,2.2,0c1.5,2.2,3,1.9,5.3,1c2-0.8,2.8-1.7,2.5-3.7c-0.3-1.6,0.3-2.1,2-2
		c2.9,0.1,5.8,0.1,8.7,0c1.2,0,1.9,0.3,1.7,1.6c-0.4,2.3,0.4,3.6,2.7,4.4c2,0.8,3.3,1,4.6-0.9c0.9-1.3,1.7-1.2,2.8,0
		c2,2.2,4.2,4.3,6.4,6.4c0.7,0.7,1.1,1.3,0.1,2c-2.2,1.5-2.3,3.1-1.2,5.6c0.8,1.7,1.5,2.3,3.4,2.2c2.9-0.1,2.5-0.4,2.6,2.6
		c0,2.8,0,5.5,0,8.3c0,1-0.3,1.6-1.3,1.3c-3.3-0.7-4.4,1.2-5.2,3.8c-0.4,1.2-0.3,1.9,0.6,2.8c0.8,0.7,1.3,0.7,1.9,0
		c0.4-0.4,0.8-1,1.5-0.3c0.6,0.6,0.6,1.2-0.1,1.7c-1.1,0.8-0.6,1.4,0.1,2.1c3.1,3.1,6.3,6.1,9.3,9.3c1.8,2,2.9,4.3,1.9,7.1
		C207.6,242.7,205.6,244.1,202.9,244.1z M157.5,186.8c-0.3,0.3-0.6,0.5-0.8,0.7c-1.4,1.4-2.7,2.8-4.1,4.1c-1,0.9-1,1.4,0,2.2
		c1.3,1.1,1.5,2.4,0.7,4c-0.5,0.9-0.9,2-1.2,3c-0.5,1.8-1.6,2.7-3.5,2.5c-1.1-0.1-1.5,0.3-1.4,1.4c0.1,1.9,0.1,3.7,0,5.6
		c-0.1,1.3,0.4,1.7,1.6,1.6c1.6-0.2,2.6,0.7,3.1,2.2c0.3,1,0.6,2,1.1,2.8c1.3,1.9,1,3.4-0.7,4.8c-0.7,0.5-0.6,1,0,1.6
		c1.4,1.3,2.8,2.6,4.1,4.1c0.9,1.1,1.5,1,2.4-0.1c1.1-1.3,2.4-1.6,3.9-0.7c0.8,0.5,1.7,0.9,2.6,1.1c2.1,0.5,3.2,1.5,2.9,3.7
		c-0.1,1,0.3,1.4,1.3,1.3c2-0.1,4-0.1,5.9,0c1,0,1.4-0.4,1.3-1.4c-0.2-2.1,0.7-3.3,2.8-3.8c0.6-0.1,1.2-0.5,1.8-0.8
		c2.9-1.4,2.9-1.4,5.2,0.7c0.7,0.6,1.1,0.7,1.7,0c1.3-1.4,2.7-2.8,4.1-4.1c1-0.9,0.9-1.5-0.1-2.2c-1.6-1.2-1.9-2.7-0.8-4.5
		c0.4-0.6,0.6-1.3,0.8-2c0.5-2.3,1.8-3.4,4.2-3.1c0.8,0.1,1.3-0.1,1.3-1.1c0-2.2,0-4.3,0-6.5c0-0.7-0.3-1.2-1.1-1.1
		c-2.6,0.3-4-1-4.5-3.4c-0.1-0.5-0.4-0.9-0.6-1.3c-1.3-2.7-1.3-2.7,0.7-4.9c0.9-0.9,0.7-1.5-0.1-2.2c-1.2-1.1-2.4-2.2-3.4-3.4
		c-1-1.2-1.9-1.3-2.9,0c-1,1.3-2.3,1.4-3.8,0.6c-0.8-0.4-1.6-0.9-2.5-1.1c-2.2-0.5-3.3-1.7-3-4c0.1-0.9-0.3-1.3-1.2-1.3
		c-1.9,0-3.7,0.1-5.6,0c-1.4-0.1-2,0.4-1.8,1.8c0.2,1.7-0.7,2.6-2.2,3.1c-1.1,0.4-2.3,0.8-3.3,1.3c-1.5,0.8-2.7,0.5-3.8-0.7
		C158.4,187.6,158,187.2,157.5,186.8z M206.8,238c0.1-0.9-0.2-1.7-0.8-2.5c-3.2-3.9-7-7.2-10.5-10.8c-0.4-0.4-0.8-0.5-1.2,0
		c-1.6,1.6-3.1,3.1-4.7,4.7c-0.5,0.5-0.5,0.9,0,1.4c3.5,3.5,7,7.1,10.6,10.5c1.2,1.1,2.7,1.5,4.3,0.6C206,241.1,206.9,240,206.8,238
		z"
            />
            <path
              style={{ fill: "#FFFFFF" }}
              className="st6"
              d="M172.3,195.7c6.8,0,12.1,5.2,12.1,12c0,6.4-5.1,12.2-12.1,12.2c-7,0-12.2-5.8-12.1-12.2
		C160.2,200.9,165.5,195.7,172.3,195.7z M172.2,218.1c4,0.1,8-2.6,9.6-6.4c0.2-0.4,0.7-0.9,0.2-1.3c-0.5-0.5-1,0.1-1.4,0.4
		c-3.2,1.8-6.5,3.3-10.4,2.3c-2.3-0.6-4.4-1.6-6.4-2.7c-0.4-0.2-0.8-0.7-1.3-0.3c-0.4,0.4-0.1,0.9,0.1,1.3
		C164.1,215.3,168.1,218,172.2,218.1z M182.2,205.4c0-0.5,0-0.8-0.1-1.1c-1.6-5.1-7.6-8.3-12.7-6.7c-3.1,1-5.4,3-6.7,6.1
		c-0.2,0.5-0.6,1.1-0.2,1.5c0.5,0.4,1-0.2,1.4-0.4c1-0.4,1.9-1,2.9-1.4c4-1.9,7.9-2,11.9,0.1C179.9,204.2,180.9,204.7,182.2,205.4z
		 M175.8,207.7c0-2-1.5-3.6-3.4-3.6c-1.9,0-3.5,1.5-3.5,3.6c0,2.1,1.4,3.6,3.4,3.6C174.2,211.3,175.7,209.7,175.8,207.7z
		 M177.3,210.3c1.8-0.5,3.7-1.3,4.2-2.6c0.3-0.9-2-1.6-3.1-2.4c-0.1-0.1-0.2-0.1-0.3-0.1c-0.5-0.1-0.8,0-0.6,0.6
		C177.8,207.2,177.6,208.6,177.3,210.3z M167,205.5c-1.5,0.5-3.2,1-3.6,2.1c-0.3,0.9,1.8,1.3,2.8,1.9c0.2,0.1,0.4,0.1,0.7,0.1
		C167,208.4,167,207.1,167,205.5z"
            />
          </g>
          {/*English Uzbek */}
          {commonStore.lang === "en" && surveyCode === "uzb" && englishLevels_uz}

          {/*English Gambodia */}
          {commonStore.lang === "en" && surveyCode === "kh" && englishLevels_kh}

          {/*Uzbek*/}
          {commonStore.lang === "uz" && uzbekLevels}

          {/*Russian*/}
          {commonStore.lang === "ru" && russianLevels}

          {/*Cambodia*/}
          {commonStore.lang === "kh" && cambodiaLevels}

          <g>
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M73.2,373.3c2.9-1,4.9-0.5,5.5,1.4c0.6,1.7-0.6,3.3-3.4,4.4c-2.8,1-4.9,0.3-5.5-1.4
		C69.3,375.8,70.5,374.2,73.2,373.3z M75,377.8c2.2-0.8,3.2-1.9,2.8-3c-0.4-1.2-2-1.2-4.2-0.5c-2.1,0.7-3.3,1.8-2.8,3
		C71.2,378.4,72.7,378.7,75,377.8z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M76.8,369l-10.5-2.3l-0.2-0.7l10.5,2.3L76.8,369z M69.8,368.8c1.8-0.6,3,0.1,3.4,1.2c0.3,1.1-0.2,2.3-2,2.8
		c-1.7,0.5-3-0.1-3.3-1.2C67.5,370.4,68.2,369.3,69.8,368.8z M70.9,371.9c1.1-0.3,1.8-1,1.6-1.7c-0.2-0.8-1.2-0.9-2.3-0.5
		c-1,0.3-1.8,0.9-1.6,1.7C68.8,372.2,69.8,372.3,70.9,371.9z M71.6,362.1c1.8-0.6,3,0.1,3.4,1.2c0.3,1.1-0.2,2.3-2,2.8
		c-1.7,0.5-3-0.1-3.4-1.2C69.3,363.7,70,362.6,71.6,362.1z M72.7,365.2c1.1-0.3,1.8-1,1.6-1.7c-0.2-0.8-1.2-0.9-2.3-0.5
		c-1,0.3-1.8,0.9-1.6,1.7C70.6,365.4,71.6,365.6,72.7,365.2z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M59.1,327.6l0.5,3.4l2.3,0c-0.1-0.2-0.1-0.4-0.2-0.7c-0.1-0.7,0-1.4,0.2-2c0.3-0.8,1-1.4,2.1-1.6
		c1.7-0.2,3.2,1,3.5,2.9c0.1,1,0,1.8-0.2,2.3l-1-0.2c0.2-0.4,0.3-1.2,0.2-2c-0.2-1.1-1-2-2.2-1.8c-1.2,0.2-1.9,1.1-1.6,2.8
		c0.1,0.5,0.2,0.9,0.3,1.2l-4.4,0l-0.6-4.3L59.1,327.6z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M57.4,287.7L57.4,287.7l0.8,1.6l-0.9,0.2l-1-2l0-1l9,0.4l0,1.2L57.4,287.7z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M61.3,277.4c3.1,0.2,4.7,1.5,4.5,3.5c-0.1,1.8-1.9,2.8-4.8,2.6c-3-0.2-4.6-1.6-4.5-3.5
		C56.7,278.1,58.5,277.2,61.3,277.4z M61.1,282.2c2.3,0.2,3.7-0.5,3.8-1.6c0.1-1.2-1.3-1.9-3.6-2.1c-2.2-0.2-3.7,0.3-3.8,1.6
		C57.4,281.2,58.7,282.1,61.1,282.2z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M63.7,242.5L63.7,242.5l0.5,1.7l-1,0l-0.6-2.2l0.2-1l8.8,2.1l-0.3,1.1L63.7,242.5z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M66.1,232.8l-0.9,3.3l2.1,0.9c0-0.2,0.1-0.4,0.1-0.7c0.2-0.7,0.5-1.3,1-1.7c0.6-0.6,1.5-0.9,2.6-0.6
		c1.7,0.5,2.6,2.2,2.1,4c-0.3,1-0.7,1.7-1.1,2l-0.8-0.5c0.3-0.3,0.8-0.9,1-1.7c0.3-1.1-0.2-2.3-1.3-2.6c-1.1-0.3-2.1,0.2-2.6,2
		c-0.1,0.5-0.2,0.9-0.2,1.2l-4-1.7l1.1-4.2L66.1,232.8z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M84.5,205l-0.7-0.3l-0.4-1.3c-1-3-1.7-4.4-2.9-5c-0.8-0.4-1.8-0.3-2.3,0.9c-0.3,0.7-0.2,1.5-0.1,2.1l-0.9,0
		c-0.2-0.8-0.2-1.8,0.2-2.7c0.8-1.8,2.4-2,3.5-1.4c1.5,0.7,2.2,2.3,3.1,4.8l0.3,0.9l0,0l1.7-3.7l0.9,0.4L84.5,205z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M85.9,191.2c2.7,1.4,3.8,3.1,2.9,4.9c-0.8,1.6-2.8,1.9-5.5,0.6c-2.7-1.3-3.6-3.2-2.8-4.9
		C81.4,190.1,83.4,189.9,85.9,191.2z M83.9,195.6c2.1,1,3.6,1,4.1,0c0.6-1.1-0.5-2.3-2.6-3.3c-2-1-3.5-1.1-4.1,0
		C80.9,193.3,81.7,194.6,83.9,195.6z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M106,166.5l-0.6-0.4l-0.2-1.3c-0.5-3.1-0.8-4.7-1.9-5.5c-0.7-0.5-1.7-0.7-2.5,0.4c-0.5,0.7-0.5,1.5-0.5,2
		l-0.9-0.2c-0.1-0.8,0.1-1.8,0.7-2.6c1.1-1.6,2.7-1.5,3.7-0.7c1.4,1,1.8,2.7,2.1,5.3l0.1,1l0,0l2.3-3.3l0.8,0.6L106,166.5z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M107,151.6l-2.1,2.7l1.6,1.7c0.1-0.2,0.2-0.4,0.4-0.6c0.4-0.6,1-1,1.6-1.3c0.7-0.3,1.7-0.3,2.6,0.4
		c1.4,1.1,1.6,3,0.4,4.5c-0.6,0.8-1.3,1.3-1.8,1.5l-0.6-0.8c0.4-0.2,1.1-0.6,1.6-1.2c0.7-0.9,0.7-2.2-0.3-2.9
		c-0.9-0.7-2.1-0.6-3.2,0.9c-0.3,0.4-0.5,0.8-0.7,1.1l-3.1-3.1l2.6-3.4L107,151.6z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M130,135.3c0.4-0.1,1.2-0.4,1.8-1c1.1-1.1,0.7-2.2,0.2-2.7c-0.9-0.9-2.1-0.5-2.9,0.4l-0.5,0.5l-0.6-0.6
		l0.5-0.5c0.6-0.6,1.1-1.7,0.3-2.5c-0.5-0.5-1.3-0.6-2.1,0.2c-0.5,0.5-0.8,1.2-0.9,1.7l-0.9-0.4c0.1-0.6,0.5-1.5,1.2-2.2
		c1.3-1.3,2.6-1.1,3.3-0.3c0.7,0.7,0.8,1.6,0.3,2.7l0,0c0.9-0.6,2.2-0.7,3.1,0.2c1,1,1.1,2.7-0.4,4.2c-0.7,0.7-1.6,1.1-2.1,1.2
		L130,135.3z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M137,124.1c2.1,2.2,2.4,4.2,1,5.6c-1.3,1.2-3.3,0.8-5.3-1.3c-2.1-2.2-2.3-4.3-0.9-5.6
		C133.1,121.5,135.1,122,137,124.1z M133.5,127.5c1.6,1.7,3,2.2,3.8,1.4c0.9-0.9,0.4-2.3-1.2-4c-1.5-1.6-2.9-2.3-3.8-1.4
		C131.5,124.2,131.9,125.7,133.5,127.5z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M164,106.7c0.4,0,1.3-0.2,2-0.6c1.3-0.9,1.1-2,0.7-2.6c-0.7-1-2-0.9-2.9-0.2l-0.6,0.4l-0.5-0.8l0.6-0.4
		c0.7-0.5,1.4-1.5,0.8-2.4c-0.4-0.6-1.1-0.9-2.1-0.2c-0.6,0.4-1,1.1-1.2,1.5l-0.8-0.6c0.2-0.6,0.8-1.3,1.6-1.9
		c1.5-1,2.7-0.6,3.3,0.4c0.5,0.8,0.5,1.7-0.2,2.7l0,0c1-0.4,2.3-0.2,3,0.8c0.8,1.2,0.6,2.9-1.2,4.1c-0.8,0.6-1.8,0.8-2.3,0.8
		L164,106.7z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M170.7,94.5l-2.9,1.8l0.9,2.1c0.2-0.1,0.3-0.3,0.6-0.4c0.6-0.4,1.3-0.6,1.9-0.6c0.8,0,1.7,0.3,2.3,1.3
		c0.9,1.5,0.4,3.4-1.2,4.4c-0.8,0.5-1.7,0.7-2.2,0.7l-0.2-0.9c0.4,0,1.2-0.2,1.9-0.6c1-0.6,1.4-1.8,0.8-2.8c-0.6-1-1.7-1.3-3.3-0.3
		c-0.4,0.3-0.7,0.5-1,0.7l-1.8-4l3.7-2.3L170.7,94.5z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M207.2,85l-0.9-2.3l-3.9,1.6l-0.3-0.7l1.5-6.9l1.2-0.5l2.1,5.2l1.2-0.5l0.4,0.9l-1.2,0.5l0.9,2.3L207.2,85z
		 M205.9,81.8l-1.2-2.8c-0.2-0.4-0.3-0.9-0.5-1.3l0,0c-0.1,0.6-0.1,1-0.2,1.5l-0.9,3.7l0,0L205.9,81.8z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M214.2,77.3c1.1,2.9,0.6,4.8-1.2,5.6c-1.6,0.6-3.3-0.5-4.4-3.3c-1.1-2.8-0.4-4.8,1.3-5.5
		C211.5,73.4,213.1,74.6,214.2,77.3z M209.6,79.2c0.8,2.2,2,3.2,3,2.8c1.2-0.4,1.2-2,0.4-4.2c-0.8-2.1-1.8-3.2-3-2.8
		C209,75.4,208.8,76.9,209.6,79.2z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M246,72.9l-0.5-2.4l-4.1,0.9l-0.2-0.8l2.7-6.5l1.3-0.3l1.2,5.5l1.2-0.3l0.2,0.9l-1.2,0.3l0.5,2.4L246,72.9z
		 M245.2,69.6l-0.6-2.9c-0.1-0.5-0.2-0.9-0.3-1.4l0,0c-0.2,0.6-0.3,1-0.4,1.5l-1.5,3.5l0,0L245.2,69.6z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M253,63.3l-3.4,0.6l0.1,2.3c0.2-0.1,0.4-0.1,0.7-0.2c0.7-0.1,1.4-0.1,2,0.1c0.8,0.3,1.5,0.9,1.7,2
		c0.3,1.7-0.8,3.3-2.7,3.7c-1,0.2-1.8,0.1-2.3-0.1l0.1-1c0.4,0.1,1.2,0.3,2,0.1c1.1-0.2,2-1.1,1.7-2.3c-0.2-1.1-1.1-1.8-2.9-1.5
		c-0.5,0.1-0.9,0.2-1.2,0.3l-0.2-4.4l4.2-0.8L253,63.3z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M291.2,59.6l-3.4,0.1l-0.3,2.3c0.2,0,0.4-0.1,0.7-0.1c0.7,0,1.4,0.1,2,0.4c0.7,0.4,1.3,1.1,1.4,2.3
		c0,1.8-1.3,3.1-3.3,3.2c-1,0-1.8-0.2-2.3-0.5l0.3-0.9c0.4,0.2,1.1,0.5,1.9,0.4c1.2,0,2.1-0.8,2.1-2c0-1.2-0.8-2-2.6-1.9
		c-0.5,0-0.9,0.1-1.2,0.1l0.5-4.3l4.3-0.1L291.2,59.6z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M299.1,63c0,3.1-1.2,4.8-3.2,4.7c-1.8,0-2.9-1.7-3-4.6c0-3,1.3-4.7,3.2-4.7C298,58.4,299.1,60.1,299.1,63z
		 M294.2,63.1c0,2.3,0.7,3.7,1.8,3.7c1.2,0,1.8-1.4,1.9-3.7c0-2.2-0.6-3.7-1.8-3.7C294.9,59.4,294.2,60.7,294.2,63.1z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M339.7,63.9l-3.4-0.6l-0.8,2.2c0.2,0,0.4,0,0.7,0.1c0.7,0.1,1.3,0.4,1.8,0.8c0.6,0.5,1.1,1.4,0.9,2.5
		c-0.3,1.7-1.9,2.8-3.9,2.4c-1-0.2-1.7-0.6-2.1-0.9l0.5-0.9c0.3,0.3,1,0.7,1.8,0.8c1.1,0.2,2.2-0.4,2.5-1.5c0.2-1.1-0.4-2.1-2.2-2.4
		c-0.5-0.1-0.9-0.1-1.2-0.1l1.3-4.2l4.2,0.8L339.7,63.9z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M346.8,65.3l-3.4-0.7l-0.8,2.2c0.2,0,0.4,0,0.7,0.1c0.7,0.1,1.3,0.4,1.8,0.9c0.6,0.5,1,1.4,0.8,2.5
		c-0.4,1.7-2,2.7-3.9,2.3c-1-0.2-1.7-0.7-2.1-1l0.5-0.8c0.3,0.3,1,0.7,1.8,0.9c1.1,0.2,2.2-0.3,2.5-1.5c0.2-1.1-0.4-2.1-2.1-2.5
		c-0.5-0.1-0.9-0.1-1.2-0.2l1.5-4.1l4.2,0.9L346.8,65.3z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M380.5,75.4c-0.2-0.1-0.5-0.2-0.9-0.3c-1.9-0.4-3.3,0.6-4.1,1.9l0,0c0.6-0.4,1.5-0.6,2.4-0.2
		c1.5,0.6,2.1,2,1.5,3.7c-0.6,1.5-2.2,2.6-3.9,1.9c-1.8-0.7-2.5-2.5-1.6-4.7c0.6-1.7,1.7-2.7,2.9-3.3c1-0.4,2.1-0.5,3.2-0.2
		c0.4,0.1,0.6,0.2,0.9,0.2L380.5,75.4z M378.3,80.2c0.5-1.2,0-2.2-1-2.6c-0.7-0.3-1.5-0.1-2,0.4c-0.1,0.1-0.2,0.2-0.3,0.5
		c-0.5,1.4-0.2,2.7,0.9,3.1C376.9,82,377.9,81.4,378.3,80.2z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M386.7,81.8c-1.2,2.8-2.9,4-4.7,3.2c-1.6-0.7-2.1-2.7-1-5.4c1.2-2.8,3-3.8,4.7-3.1
		C387.4,77.2,387.8,79.1,386.7,81.8z M382.1,80c-0.9,2.2-0.7,3.7,0.3,4.1c1.2,0.5,2.3-0.6,3.1-2.8c0.8-2.1,0.9-3.6-0.3-4.1
		C384.2,76.9,383,77.8,382.1,80z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M421.3,95.9c-0.2-0.1-0.5-0.3-0.8-0.4c-1.8-0.7-3.4-0.1-4.3,1.1l0,0c0.7-0.3,1.5-0.3,2.4,0.3
		c1.4,0.8,1.7,2.4,0.8,3.9c-0.9,1.4-2.6,2.1-4.2,1.1c-1.6-1-1.9-2.9-0.7-4.9c0.9-1.5,2.2-2.4,3.4-2.7c1-0.2,2.1-0.1,3.2,0.4
		c0.3,0.1,0.6,0.3,0.8,0.4L421.3,95.9z M418.3,100.2c0.7-1.1,0.5-2.1-0.5-2.7c-0.6-0.4-1.4-0.4-2.1,0c-0.1,0.1-0.3,0.2-0.4,0.4
		c-0.8,1.3-0.8,2.6,0.3,3.2C416.6,101.7,417.6,101.3,418.3,100.2z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M427.5,100.2l-2.9-1.9l-1.6,1.7c0.2,0.1,0.4,0.2,0.6,0.4c0.6,0.4,1.1,0.9,1.4,1.5c0.4,0.7,0.4,1.7-0.2,2.6
		c-1,1.5-2.9,1.8-4.5,0.7c-0.8-0.5-1.4-1.2-1.6-1.7l0.8-0.6c0.2,0.4,0.7,1,1.3,1.5c1,0.6,2.2,0.5,2.9-0.5c0.6-1,0.4-2.1-1.1-3.1
		c-0.4-0.3-0.8-0.5-1.1-0.6l2.9-3.3l3.6,2.4L427.5,100.2z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M458.6,123.7l-0.5,0.6l-8.4,3.4l-0.9-0.9l8.3-3.2l0,0l-3.2-3l0.7-0.7L458.6,123.7z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M460.9,132c-2.1,2.2-4.1,2.6-5.6,1.2c-1.3-1.2-1-3.2,1.1-5.4c2.1-2.2,4.2-2.4,5.5-1.2
		C463.3,128,462.9,130,460.9,132z M457.3,128.7c-1.6,1.7-2.1,3.1-1.3,3.9c0.9,0.9,2.3,0.2,3.9-1.4c1.6-1.6,2.2-3,1.3-3.9
		C460.4,126.6,459,127,457.3,128.7z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M487,155.8l-0.6,0.5l-8.9,1.8l-0.8-1l8.7-1.7l0,0l-2.7-3.5l0.8-0.6L487,155.8z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M490.1,161.9l-2-2.8l-2.1,1.1c0.1,0.2,0.3,0.3,0.5,0.6c0.4,0.6,0.7,1.2,0.7,1.9c0.1,0.8-0.2,1.7-1.1,2.4
		c-1.4,1-3.3,0.6-4.5-1c-0.6-0.8-0.8-1.6-0.8-2.2l0.9-0.3c0,0.4,0.2,1.2,0.7,1.9c0.7,0.9,1.8,1.3,2.8,0.6c0.9-0.7,1.2-1.8,0.1-3.3
		c-0.3-0.4-0.6-0.7-0.8-1l3.9-2l2.5,3.5L490.1,161.9z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M501.8,192.7c1-0.5,2-0.2,3,0.6l0,0c0-1.1,0.5-1.8,1.2-2.2c1.3-0.6,2.7,0,3.4,1.5c0.8,1.6,0.2,2.8-0.8,3.3
		c-0.7,0.3-1.6,0.4-2.5-0.4l0,0c0.1,1.2-0.3,2.2-1.3,2.7c-1.4,0.7-2.9-0.1-3.7-1.6C500.2,194.8,500.7,193.3,501.8,192.7z M504,197.1
		c1-0.5,1.1-1.4,0.9-2.6c-0.7-0.8-1.6-1-2.4-0.6c-0.8,0.4-1.3,1.3-0.8,2.4C502.3,197.1,503.2,197.5,504,197.1z M506.6,192.1
		c-0.8,0.4-0.9,1.2-0.7,2.3c0.6,0.6,1.3,0.9,2.1,0.5c0.6-0.3,1.1-1,0.7-2C508.1,191.9,507.3,191.7,506.6,192.1z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M509.6,203.7c-2.8,1.3-4.8,0.9-5.6-0.9c-0.7-1.6,0.3-3.4,3-4.6c2.8-1.2,4.8-0.7,5.6,0.9
		C513.3,200.9,512.2,202.6,509.6,203.7z M507.4,199.3c-2.1,1-3.1,2.2-2.6,3.2c0.5,1.1,2.1,1.1,4.2,0.1c2-0.9,3.1-2,2.6-3.2
		C511.2,198.5,509.7,198.3,507.4,199.3z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M518,234.3c1.1-0.3,2.1,0.2,2.8,1.1l0,0c0.2-1.1,0.8-1.7,1.6-1.9c1.4-0.4,2.6,0.5,3,2.1
		c0.5,1.7-0.4,2.8-1.5,3.1c-0.7,0.2-1.6,0-2.4-0.9l0,0c-0.1,1.2-0.7,2.1-1.8,2.4c-1.5,0.4-2.9-0.6-3.3-2.3
		C515.9,236,516.7,234.6,518,234.3z M519.3,238.9c1.1-0.3,1.4-1.2,1.4-2.4c-0.6-0.9-1.4-1.3-2.2-1.1c-0.9,0.2-1.5,1.1-1.2,2.2
		C517.5,238.7,518.4,239.2,519.3,238.9z M522.8,234.5c-0.9,0.2-1.2,1-1.2,2.1c0.5,0.7,1.1,1.1,1.9,0.9c0.7-0.2,1.3-0.8,1-1.9
		C524.3,234.7,523.5,234.3,522.8,234.5z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M526.6,245.3l-0.7-3.4l-2.3,0.2c0.1,0.2,0.1,0.4,0.2,0.7c0.1,0.7,0.1,1.4-0.1,2c-0.2,0.8-0.9,1.5-2,1.8
		c-1.7,0.4-3.3-0.7-3.7-2.6c-0.2-1-0.1-1.8,0.1-2.3l1,0.1c-0.1,0.4-0.2,1.2-0.1,2c0.2,1.1,1.2,1.9,2.4,1.7c1.1-0.3,1.8-1.2,1.4-3
		c-0.1-0.5-0.3-0.9-0.4-1.2l4.4-0.4l0.9,4.2L526.6,245.3z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M524.5,279.1c0,0.3,0,0.6,0.1,1c0.1,0.7,0.5,1.3,1,1.8c0.6,0.6,1.4,0.9,2.5,1l0,0c-0.6-0.5-1.1-1.1-1.1-2
		c-0.1-1.6,1-2.7,2.6-2.9c1.7-0.1,3.3,1,3.4,2.8c0.1,1.8-1.3,3.1-3.6,3.2c-2,0.1-3.4-0.4-4.3-1.3c-0.7-0.6-1.2-1.6-1.4-2.5
		c-0.1-0.4-0.1-0.8-0.1-1.1L524.5,279.1z M529.7,279.1c-1.1,0.1-1.9,0.8-1.8,1.9c0.1,0.8,0.5,1.4,1.1,1.7c0.1,0.1,0.3,0.1,0.5,0.1
		c1.5-0.1,2.7-0.8,2.6-2C532,279.7,531,279,529.7,279.1z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M528.9,291.2c-3.1,0.1-4.8-0.9-4.9-2.9c-0.1-1.8,1.5-3,4.5-3.2c3-0.1,4.7,1.1,4.8,2.9
		C533.5,290,531.8,291.1,528.9,291.2z M528.6,286.3c-2.3,0.1-3.6,0.9-3.6,2c0,1.2,1.5,1.8,3.8,1.7c2.2-0.1,3.6-0.7,3.6-2
		C532.4,287,531.1,286.3,528.6,286.3z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M523.8,323.3c-0.1,0.3-0.1,0.6-0.1,1c0,0.7,0.2,1.4,0.6,2c0.5,0.7,1.2,1.2,2.2,1.5l0,0
		c-0.5-0.6-0.8-1.3-0.7-2.2c0.2-1.6,1.5-2.5,3.1-2.3c1.7,0.2,3,1.6,2.8,3.4c-0.2,1.8-1.9,2.8-4.1,2.5c-2-0.2-3.3-1.1-4-2.1
		c-0.6-0.8-0.9-1.8-0.9-2.7c0-0.4,0-0.8,0.1-1.1L523.8,323.3z M528.9,324.4c-1.1-0.1-2,0.4-2.1,1.5c-0.1,0.8,0.2,1.5,0.7,1.9
		c0.1,0.1,0.2,0.1,0.4,0.2c1.5,0.2,2.8-0.2,2.9-1.5C531,325.4,530.2,324.6,528.9,324.4z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M529.2,336l0.5-3.4l-2.2-0.7c0,0.2,0,0.4-0.1,0.7c-0.1,0.7-0.4,1.3-0.8,1.8c-0.5,0.6-1.4,1.1-2.5,0.9
		c-1.7-0.3-2.8-1.9-2.5-3.8c0.2-1,0.6-1.8,0.9-2.1l0.9,0.4c-0.3,0.3-0.7,1-0.8,1.8c-0.2,1.1,0.4,2.2,1.6,2.4
		c1.2,0.2,2.1-0.5,2.4-2.3c0.1-0.5,0.1-0.9,0.1-1.2l4.2,1.2l-0.7,4.3L529.2,336z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M523.9,359.7L523.9,359.7l-0.4-1.8l1,0l0.5,2.2l-0.3,1l-8.7-2.4l0.3-1.1L523.9,359.7z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M517.8,368.9c-2.9-0.9-4.2-2.5-3.6-4.4c0.5-1.7,2.4-2.3,5.3-1.5c2.9,0.9,4.1,2.6,3.6,4.4
		C522.4,369.3,520.5,369.8,517.8,368.9z M519.1,364.2c-2.2-0.7-3.7-0.4-4.1,0.7c-0.4,1.2,0.8,2.2,3,2.9c2.1,0.7,3.7,0.5,4.1-0.7
		C522.4,366.1,521.4,365,519.1,364.2z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M515.4,375.7c-2.9-1-4.1-2.6-3.5-4.5c0.6-1.7,2.5-2.3,5.3-1.3c2.9,1,4,2.8,3.4,4.5
		C520.1,376.2,518.2,376.7,515.4,375.7z M516.9,371.1c-2.2-0.8-3.7-0.5-4.1,0.5c-0.4,1.2,0.8,2.2,3,3c2.1,0.7,3.7,0.7,4.1-0.5
		C520.2,373,519.2,371.9,516.9,371.1z"
            />
            <path
              style={{ fill: "#3A3A3A" }}
              className="st7"
              d="M509.8,385.5c-1.8-0.7-2.3-2-1.9-3c0.4-1,1.6-1.6,3.3-1c1.7,0.7,2.3,1.9,1.9,3
		C512.6,385.7,511.4,386.1,509.8,385.5z M510.9,382.4c-1.1-0.4-2-0.3-2.3,0.4c-0.3,0.8,0.4,1.4,1.5,1.8c1,0.4,2,0.4,2.3-0.4
		C512.6,383.5,511.9,382.8,510.9,382.4z M510,376.9l6.8,8.3l-0.3,0.7l-6.8-8.3L510,376.9z M515.3,381.4c-1.8-0.7-2.3-2-1.9-3
		c0.4-1,1.6-1.6,3.3-1c1.7,0.6,2.3,1.9,1.8,3C518.2,381.6,516.9,382,515.3,381.4z M516.5,378.3c-1.1-0.4-2-0.4-2.3,0.4
		c-0.3,0.8,0.4,1.4,1.5,1.8c1,0.4,2,0.4,2.3-0.4C518.2,379.4,517.5,378.7,516.5,378.3z"
            />
          </g>
          <g>
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M90.1,358.7l-6.9,2.1l-0.4-1.1l6.9-2.1L90.1,358.7z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M87.7,351l-7,1.9l-0.3-1.2l7-1.9L87.7,351z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M85.6,343.1l-7.1,1.5l-0.2-1.2l7.1-1.5L85.6,343.1z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M83.9,335.4l-7.1,1.2l-0.2-1.2l7.1-1.2L83.9,335.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M88.6,326.6l-13.2,1.5l-0.1-1.2l13.2-1.5L88.6,326.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M81.5,319.2l-7.2,0.4l-0.1-1.2l7.2-0.4L81.5,319.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M80.9,311l-7.2,0.4l-0.1-1.2l7.2-0.4L80.9,311z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M80.5,302.6l-7.2,0.3l0-1.2l7.2-0.3L80.5,302.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M80.3,294.6l-7.2,0l0-1.2l7.2,0L80.3,294.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M81.2,278.3l-7.2-0.5l0.1-1.2l7.2,0.5L81.2,278.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M88.2,286.6l-14.7-0.2l0-1.2l14.7,0.2L88.2,286.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M82,270.3l-7.2-0.7l0.1-1.2l7.2,0.7L82,270.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M83,262.2l-7.2-1l0.2-1.2l7.2,1L83,262.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M92.5,247.7l-13.5-3.2l0.3-1.2l13.5,3.2L92.5,247.7z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M84.6,254.2l-7.1-1.5l0.2-1.2l7.1,1.5L84.6,254.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M88.4,238.3l-7-1.9l0.3-1.2l7,1.9L88.4,238.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M93.2,222.8l-6.8-2.5l0.4-1.1l6.8,2.5L93.2,222.8z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M96.3,215.3l-6.7-2.7l0.5-1.1l6.7,2.7L96.3,215.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M105.4,210.6l-12.8-5.7l0.5-1.1l12.8,5.7L105.4,210.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M102.9,200.5l-6.5-3.3l0.5-1.1l6.5,3.3L102.9,200.5z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M106.7,193.2l-6.3-3.5l0.6-1l6.3,3.5L106.7,193.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M110.9,186.2l-6.2-3.8l0.6-1l6.2,3.8L110.9,186.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M115.3,179.2l-6-4l0.7-1l6,4L115.3,179.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M126.4,177.3l-12.5-9.1l0.7-1l12.5,9.1L126.4,177.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M124.6,166.1l-5.7-4.5l0.7-0.9l5.7,4.5L124.6,166.1z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M129.5,159.5l-5.6-4.6l0.8-0.9l5.6,4.6L129.5,159.5z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M135,153.4l-5.3-4.9l0.8-0.9l5.3,4.9L135,153.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M140.4,147.4l-5.2-5l0.8-0.9l5.2,5L140.4,147.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M153.4,149.1l-12.1-12.6l0.9-0.8l12.1,12.6L153.4,149.1z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M152.3,136.3l-4.8-5.4l0.9-0.8l4.8,5.4L152.3,136.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M158.6,130.9l-4.7-5.5l0.9-0.8l4.7,5.5L158.6,130.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M171.6,121l-4.2-5.9l1-0.7l4.2,5.9L171.6,121z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M184.1,125.2l-9.7-14.6l1-0.6l9.7,14.6L184.1,125.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M185.3,112.2l-3.7-6.2l1-0.6l3.7,6.2L185.3,112.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M192.2,108.2l-3.3-6.4l1.1-0.5l3.3,6.4L192.2,108.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M199.6,104.4l-3.2-6.5l1.1-0.5l3.2,6.5L199.6,104.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M206.7,100.9l-2.9-6.6l1.1-0.5l2.9,6.6L206.7,100.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M217.7,106.9l-6-15.8l1.1-0.4l6,15.8L217.7,106.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M221.7,94.9l-2-7l1.1-0.3l2,7L221.7,94.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M229.5,92.4l-1.8-7l1.2-0.3l1.8,7L229.5,92.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M237.3,90l-1.8-7l1.2-0.3l1.8,7L237.3,90z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M245.3,88.1l-1.7-7l1.2-0.3l1.7,7L245.3,88.1z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M255.2,96.4l-3.1-17.3l1.2-0.2l3.1,17.3L255.2,96.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M261.4,84.8l-1.1-7.2l1.2-0.2l1.1,7.2L261.4,84.8z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M269.5,83.7l-0.8-7.2l1.2-0.1l0.8,7.2L269.5,83.7z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M277.5,83l-0.5-7.2l1.2-0.1l0.5,7.2L277.5,83z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M285.4,82.5l0.1-7.2l1.2,0l-0.1,7.2L285.4,82.5z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M302.2,82.3l-0.1-7.2l1.2,0l0.1,7.2L302.2,82.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M310.1,82.9l0.5-7.2l1.2,0.1l-0.5,7.2L310.1,82.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M318.1,83.6l0.8-7.2l1.2,0.1l-0.8,7.2L318.1,83.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M333,93.6l2.8-14.6l1.2,0.2l-2.8,14.6L333,93.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M326.2,84.8l1.2-7.1l1.2,0.2l-1.2,7.1L326.2,84.8z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M342.3,87.7l1.7-7.1l1.2,0.3l-1.7,7.1L342.3,87.7z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M350.1,89.7l1.9-7l1.2,0.3l-1.9,7L350.1,89.7z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M357.9,91.9l2.2-6.9l1.1,0.4l-2.2,6.9L357.9,91.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M365.8,94.5l2.4-6.8l1.1,0.4l-2.4,6.8L365.8,94.5z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M372.2,100.6l4-9.8l1.1,0.5l-4,9.7L372.2,100.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M380.8,100.7l2.9-6.6l1.1,0.5l-2.9,6.6L380.8,100.7z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M388.2,103.8l3.3-6.4l1.1,0.5l-3.3,6.4L388.2,103.8z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M395.4,107.8l3.4-6.4l1.1,0.6l-3.4,6.4L395.4,107.8z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M402.6,111.8l3.7-6.2l1,0.6l-3.7,6.2L402.6,111.8z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M406.1,121.1l7.5-11.2l1,0.6l-7.5,11.2L406.1,121.1z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M416.2,120.4l4.3-5.8l1,0.7l-4.3,5.8L416.2,120.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M429.4,130.5l4.5-5.7l0.9,0.7l-4.5,5.7L429.4,130.5z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M435.6,135.4l4.9-5.4l0.9,0.8l-4.9,5.4L435.6,135.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M436.7,145.8l9.9-10.4l0.9,0.8l-9.9,10.4L436.7,145.8z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M447.5,146.7l5.3-5l0.8,0.9l-5.3,5L447.5,146.7z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M453.1,152.4l5.4-4.9l0.8,0.9l-5.4,4.9L453.1,152.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M458.3,158.9l5.6-4.6l0.8,0.9l-5.6,4.6L458.3,158.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M463.5,165.1l5.8-4.4l0.7,0.9l-5.8,4.4L463.5,165.1z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M465.6,173.5l8.7-6.1l0.7,1l-8.8,6.2L465.6,173.5z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M472.9,177.9l6.3-3.6l0.6,1l-6.3,3.6L472.9,177.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M477.2,185.1l6.2-3.7l0.6,1l-6.2,3.7L477.2,185.1z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M481.1,192.2l6.4-3.4l0.6,1.1l-6.4,3.4L481.1,192.2z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M485.1,199.3l6.5-3.2l0.5,1.1l-6.5,3.2L485.1,199.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M480.9,210.1l14.4-6.5l0.5,1.1l-14.4,6.5L480.9,210.1z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M492.2,213.9l6.7-2.8l0.5,1.1l-6.7,2.8L492.2,213.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M495.1,221.9l6.8-2.5l0.4,1.1l-6.8,2.5L495.1,221.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M499.8,237.3l7-1.9l0.3,1.2l-7,1.9L499.8,237.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M493.2,247.3l15.8-4l0.3,1.2l-15.8,4L493.2,247.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M503.4,253l7.1-1.4l0.2,1.2l-7.1,1.4L503.4,253z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M505.3,260.9l7.2-1l0.2,1.2l-7.2,1L505.3,260.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M506.4,268.4l7.2-0.2l0,1.2l-7.2,0.2L506.4,268.4z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M507.7,276.9l7.2-0.1l0,1.2l-7.2,0.1L507.7,276.9z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M495.9,285.8l19.5-0.7l0.1,1.2l-19.5,0.7L495.9,285.8z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M508.3,293.3l7.2-0.1l0,1.2l-7.2,0.1L508.3,293.3z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M508.3,301.5l7.2,0.2l0,1.2l-7.2-0.2L508.3,301.5z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M507.7,309.6l7.2,0.4l-0.1,1.2l-7.2-0.4L507.7,309.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M507,318l7.2,0.2l0,1.2l-7.2-0.2L507,318z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M496.8,324.6l17,2.4l-0.2,1.2l-17-2.4L496.8,324.6z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M504.8,334l7.1,1.3l-0.2,1.2l-7.1-1.3L504.8,334z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M503.4,342l7.1,1.6l-0.3,1.2l-7.1-1.6L503.4,342z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M501.2,350l7,1.7l-0.3,1.2l-7-1.7L501.2,350z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M499.1,358.1l7,1.7l-0.3,1.2l-7-1.7L499.1,358.1z"
            />
            <path
              style={{ fill: "#EFEFEF" }}
              className="st10"
              d="M488.4,362.9l15.8,5l-0.4,1.1l-15.8-5L488.4,362.9z"
            />
          </g>
          <path
            style={{ fill: "#F5A00C", transform: getDegree(), transformOrigin: "50% 72%" }}
            className="st8"
            d="M79.4,361.3l0.3,1.2L268.1,309c2.2,4.2,5.4,8,9.7,10.8c13.3,8.9,31.4,5.3,40.2-8.1c8.9-13.3,5.3-31.4-8.1-40.2
	c-13.3-8.9-31.4-5.3-40.2,8.1c-4,6.1-5.5,13.1-4.6,19.9L79.4,361.3z"
          />
        </svg>



      </div>
</>
const threePointsMeter = <>
<div className="three-pointer-meter-large">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 587.8 411.4" style={{ width: "590px", height: "450px", margin: "0 auto", display: "block" }}>
<g id="Scalebody">
	<path style={
                level != null && level.toLowerCase() === "b-level"
                  ? { fill: "#D1D1D1", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#D1D1D1" }
              } className="st0" d="M143.6,101.7L117,67.4C49.4,120.3,6,202.6,6,295.1c0,31.6,5.1,62,14.5,90.5l40.1-13.3
		c-7.8-24-12.1-49.7-12.1-76.3C48.5,216.9,85.7,146.6,143.6,101.7z"/>
	<path style={
                level != null && level.toLowerCase() === "b-level"
                  ? { fill: "#D1D1D1", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#D1D1D1" }
              } className="st0" d="M258.6,249.4l-101-129.7c-52.7,40.9-86.7,104.8-86.7,176.7c0,24,3.8,47.1,10.8,68.8l156.4-52
		c-1.7-5.4-2.5-11.2-2.5-17.2C235.5,277,244.6,260.1,258.6,249.4z"/>
	<path style={
                level != null && level.toLowerCase() === "c-level"
                  ? { fill: "#ACACAC", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#ACACAC" }
              } className="st1" d="M465.5,62.1C417.7,27,358.7,6.2,294.8,6.2c-64.3,0-123.8,21-171.8,56.6l25.9,34.9
		c40.7-29.9,90.9-47.5,145.3-47.5c54.2,0,104.3,17.6,144.9,47.3L465.5,62.1z"/>
	<path style={
                level != null && level.toLowerCase() === "c-level"
                  ? { fill: "#ACACAC", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#ACACAC" }
              } className="st1" d="M425.6,115.5c-36.8-26.8-82.2-42.6-131.2-42.6c-49.3,0-94.9,16-131.9,43.1l98.1,132
		c9.6-6.7,21.2-10.7,33.8-10.7c12.1,0,23.3,3.6,32.6,9.9L425.6,115.5z"/>
	<path style={
                level != null && level.toLowerCase() === "d-level"
                  ? { fill: "#888888", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#888888" }
              } className="st2" d="M471.6,66.7l-27.2,34.7c58.1,44.9,95.6,115.3,95.6,194.5c0,26.8-4.3,52.6-12.2,76.7l41.2,13.7
		c9.5-28.7,14.7-59.4,14.7-91.3C583.6,202.2,539.8,119.5,471.6,66.7z"/>
	<path style={
                level != null && level.toLowerCase() === "d-level"
                  ? { fill: "#888888", stroke: "#f5a00c", strokeWidth: "5px" }
                  : { fill: "#888888" }
              } className="st2" d="M430.5,119.1L329,248.5c14.7,10.7,24.2,28,24.2,47.6c0,6.1-0.9,12-2.7,17.6l156.3,52c7.1-21.8,11-45.1,11-69.3
		C517.8,224.2,483.6,160,430.5,119.1z"/>
</g>
<g id="Symbols">
	<g>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M431.8,267.3c0.4,0.2,0.8-0.1,1.2,0.3c3.4,2.7,6.1,5.8,6.2,10.4c0.1,2.8,0,5.6,0,8.5c0,1-0.3,1.4-1.3,1.4
			c-9.7,0-19.5,0-29.2,0c-1.2,0-1.4-0.4-1.4-1.5c0.1-2.9,0-5.9,0-8.8c0.1-3.9,3.8-9.2,7.2-10.2l0,0c0.5,1,0.4,1.7-0.6,2.5
			c-3.1,2.5-5,5.6-4.6,9.8c0.2,1.5,0.1,3.1,0,4.7c-0.1,1.1,0.3,1.6,1.5,1.6c3.5-0.1,7.1-0.1,10.6,0c1.5,0,1.7-0.4,0.9-1.6
			c-2.2-3.6-4.4-7.2-6.6-10.7c-0.4-0.6-1-1.2,0.1-1.8c0.9-0.5,1.2,0.2,1.5,0.7c1.6,2.6,3.2,5.2,4.8,7.8c1.1,1.8,1.1,1.8,2.2-0.1
			c1.4-2.6,2.8-5.1,4.3-7.7c0.3-0.6,0.5-1.3,1.4-0.7c0.9,0.5,0.6,1,0.3,1.6c-0.6,1.1-1.2,2.2-1.8,3.3c-1.6,3-3.3,6-5.1,9.2
			c4.6,0,8.8,0,13,0c0.9,0,0.9-0.6,0.9-1.2c0-1.5-0.1-3,0-4.5c0.5-4.5-1.5-7.8-4.8-10.4c-0.7-0.6-0.9-1.2-1.1-2l0,0
			C431.9,267.8,432,267.6,431.8,267.3L431.8,267.3z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M423.3,246c-1.6,0-3.1-0.1-4.7,0c-1.1,0.1-1.5-0.3-1.5-1.4c0.1-0.9,0.3-1.9-0.6-2.7c-0.1-0.1-0.2-0.5-0.1-0.7
			c1.3-1.7-0.3-2.7-1-4c-2-3.9-0.9-8.8,2.6-11.3c3.6-2.6,8.4-2.3,11.5,0.8c3.2,3.2,3.5,8.1,0.8,11.7c-0.5,0.7-1.4,1.2-0.4,2.2
			c0.3,0.3,0.3,1.1-0.2,1.5c-0.4,0.3-0.4,0.7-0.4,1.1c-0.2,2.7-0.2,2.7-2.8,2.7c-0.5,0-1.1,0-1.6,0C424.3,246,423.8,246,423.3,246z
			 M416.3,233.5c-0.3,2.5,1.9,4.3,3,6.5c0.3,0.7,3,0.3,3.1-0.4c0-1.2,0.5-2.6-1.2-3.4c-1.5-0.7-2.1-2.8-1.5-4.4
			c0.6-1.6,1.8-2.5,3.6-2.5c1.7,0,3.3,1.1,3.8,2.8c0.5,1.6-0.1,3.4-1.8,4.3c-1.4,0.7-0.8,1.8-0.9,2.8c-0.1,0.4-0.1,0.9,0.5,1
			c1.3,0.1,2.7,0.4,3.2-1.2c0.3-0.8,0.8-1.4,1.2-2.1c1.6-2.6,1.4-5.9-0.5-8.2c-1.8-2.2-4.9-3.1-7.7-2.1
			C418.2,227.5,416.3,230.1,416.3,233.5z M423.3,244.2c1.1,0,2.1,0,3.2,0c0.7,0,1-0.2,1-0.9c0-0.7-0.1-1.1-1-1.1c-2.1,0-4.3,0-6.4,0
			c-0.7,0-1.1,0.2-1.1,1c0,0.8,0.3,1.1,1.1,1C421.2,244.1,422.3,244.2,423.3,244.2z M425.3,233.1c-0.2-1.1-0.8-1.9-2-1.9
			c-1.2,0-1.9,0.7-1.9,1.9c0,1.2,0.8,1.9,1.9,1.9C424.5,235.1,425.1,234.3,425.3,233.1z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M414.5,267.3c-0.9-2-2.2-3.7-2.7-5.9c-1.3-6.3,2.8-12.3,9.4-13.7c5.9-1.2,12.1,3,13.4,8.9
			c0.9,4.1-0.5,7.5-2.9,10.7c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.4,0.4c0,0,0,0,0,0c-0.5,0.3-1,0.6-1.5,1c-4.5,3.2-10.1,2.9-14.4-0.7
			C415.3,267.6,415.1,267.1,414.5,267.3L414.5,267.3z M433,259.2c0-5.4-4.3-9.8-9.6-9.9c-5.2-0.1-9.8,4.4-9.9,9.6
			c-0.1,5.4,4.3,9.9,9.8,9.9C428.7,268.9,433,264.6,433,259.2z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M447.7,262.6c-0.7-0.2-1,0.5-1.5,0.8c-3.1,2.2-6.5,3-10.2,1.9c-0.5-0.1-1.5,0-1.1-1.2c0.3-1,0.9-0.8,1.7-0.7
			c5.5,1.2,10.1-1.3,11.8-6.2c1.5-4.4-0.3-9.2-4.4-11.6c-3.9-2.3-9.2-1.4-12.1,2c-0.2,0.2-0.4,0.4-0.6,0.7c-0.5,0.7-0.9,0.3-1.4,0
			c-0.7-0.4-0.4-0.8-0.1-1.3c2.5-3.5,7.3-5.3,11.8-4.4c4.4,0.9,8,4.6,8.9,8.9c0.7,3.5-0.1,6.5-2,9.4c-0.2,0.4-0.8,0.6-0.5,1.2l0,0
			C447.7,262.1,447.6,262.3,447.7,262.6L447.7,262.6z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M398.7,262.2c0.1-0.6-0.4-0.8-0.7-1.2c-3.7-5.1-2.8-12.1,2.1-16c5-4,11.9-3.4,16.2,1.5
			c0.4,0.5,1.3,0.9,0.5,1.8c-0.9,0.9-1.3,0.2-1.8-0.4c-2.8-3.2-6.3-4.2-10.2-3.1c-3.9,1.1-6.2,3.9-6.9,8c-1.2,6.6,5.1,12.3,12,10.9
			c0.7-0.1,1.6-0.8,1.9,0.5c0.3,1.4-0.9,1.2-1.6,1.4c-3.6,0.9-6.8,0-9.7-2c-0.4-0.3-0.7-0.9-1.3-0.5l0,0
			C399.4,262.5,399,262.3,398.7,262.2L398.7,262.2z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M399,262.9c0.3,0.9-0.4,1.3-0.9,1.7c-3.2,2.6-5.1,5.8-4.7,10.2c0.2,1.5,0.1,3.1,0,4.7c0,1.1,0.4,1.5,1.5,1.5
			c3.2-0.1,6.4,0,9.5,0c0.7,0,1.5-0.2,1.5,1c0,1.1-0.8,0.9-1.4,0.9c-3.9,0-7.8,0-11.7,0c-1,0-1.4-0.3-1.3-1.3c0.1-3.1,0-6.1,0-9.2
			c0.1-3.7,3.9-9,7.2-10.1c0,0,0,0,0,0C398.5,262.6,398.7,262.8,399,262.9L399,262.9z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M448.1,262.2c3.9,2.4,6.7,5.5,6.9,10.2c0.2,3,0,6,0.1,9c0,1-0.3,1.4-1.3,1.3c-4,0-7.9,0-11.9,0
			c-0.7,0-1.2,0-1.2-0.9c0-0.9,0.5-0.9,1.2-0.9c2.8,0,5.6,0,8.5,0c2.9,0,2.9,0,2.9-3c0-1-0.1-2.1,0-3.1c0.5-4.4-1.5-7.6-4.8-10.3
			c-0.8-0.6-1-1.2-0.7-2l0,0C448,262.6,448.1,262.5,448.1,262.2L448.1,262.2z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M431.5,267.7c0-0.2,0.1-0.4,0.4-0.4C432,267.6,431.9,267.8,431.5,267.7z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M448.1,262.2c0,0.2-0.1,0.4-0.4,0.4C447.6,262.3,447.7,262.1,448.1,262.2z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M399,263c-0.3-0.1-0.5-0.4-0.4-0.8C399,262.3,399.4,262.5,399,263z"/>
	</g>
	<g style={{ display: "none" }} className="st4">
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M146.1,288.1c0.7-3.9-1.2-6.4-4.8-6.5c-0.7,0-1.8,0.5-2-0.6c-0.2-1.2,1-1.4,1.8-1.7c0.5-0.2,1.1-0.2,1.6-0.2
			c1.7,0,3.4,0,5,0c0.7,0,1.3,0,1.3-1c0-0.9-0.7-0.8-1.3-0.8c-2.2,0-4.4-0.1-6.7,0c-1.7,0.1-3.1,1.1-3.6,2.8
			c-0.3,1.1-0.7,1.7-1.9,1.6c-0.8-0.1-1,0.4-1,1.1c0,0.6,0.2,1.1,0.9,1c1.6-0.2,2.7,0.4,3.8,1.5c0.7,0.7,1.6,0.9,1.8-0.4
			c0.3-1.6,1.2-1.2,2.1-0.8c1.5,0.8,1.7,2.9,0.2,3.7c-0.8,0.5-1.1,1.1-0.7,1.7c0.4,0.8,1.2,0.3,1.8,0c0.5-0.3,0.9-0.7,1.4-1.1
			c0.1,1.7-0.6,2.4-2.4,2.2c-1.4-0.1-2.9,0-4.3,0c-2.5,0-4.1,1.4-4.7,3.9c-0.4,1.7,0.6,3.7,2.5,4.7c0.3,0.2,0.8,0.7,1.1,0.2
			c0.3-0.5,0.7-1,0.2-1.6c-0.3-0.3-0.7-0.5-1-0.8c-0.7-0.6-1.1-1.3-0.7-2.2c0.3-0.8,0.7-2,1.7-1.8c3,0.3,6.4-1.4,9,1.4
			c0.2,0.2,0.6,0.4,1,0.5c0.6,0.2,1.3,0.8,1.8,0.2c0.4-0.7,0.2-1.5-0.8-2.1c1.3,0,2.3,0,3.3,0c0.9,0,1.7,0.1,2.1,1
			c0.5,1,0.4,2-0.4,2.8c-0.3,0.4-0.7,0.7-1,1c-0.5,0.5-0.5,1.1-0.1,1.6c0.4,0.6,0.9,0.2,1.3,0c1.9-0.9,2.9-3.2,2.4-5.5
			c-0.4-1.7-2.1-3.1-4.1-3.1c-1.3,0-2.6,0-4,0c-0.4,0-1.1,0.2-1.2-0.5c-0.1-0.5,0.2-1,0.6-1.2c0.5-0.3,1.1-0.7,1.6-0.7
			c3.8-0.1,7.7,0,11.5-0.1c0.3,0,0.7,0,0.7,0.3c0,0.2-0.2,0.5-0.4,0.7c-0.3,0.2-0.6,0.4-0.9,0.5c-0.7,0.3-0.8,0.9-0.6,1.5
			c0.2,0.7,0.9,0.5,1.4,0.3c1.2-0.5,2.3-1.1,2.7-2.4c0.4-1.3,1.3-1.1,2.2-0.8c1.2,0.4,2.2,1.1,2,2.6c-0.1,1-0.4,2-1.7,1.8
			c-2.1-0.2-4,0.5-6.1,0.4c-1.1,0-1.8,1.2-1.1,1.7c1,0.8,0.7,1.4,0.4,2.2c-0.2,0.5-0.1,1,0.1,1.6c0.4,1.5,1.5,2.5,3,3.5
			c-1.2,0-1.9,0-2.7,0c-0.7,0-0.9,0.4-0.9,1.1c0,0.6,0.1,1.1,0.9,1.1c1.1,0,2.2,0.1,3.2,0c2.9-0.1,6,0.8,8.2-2
			c0.1-0.1,0.3-0.1,0.5-0.1c0.6-0.1,1.3,0.1,1.3-0.8c0.1-0.7,0-1.3-0.9-1.4c-0.4,0-0.4-0.4-0.6-0.6c-0.7-1.4-1.9-2.2-3.5-2.6
			c-0.6-0.2-1.2-0.4-1.4,0.5c-0.3,0.8,0.1,1.2,0.8,1.4c0.3,0.1,0.7,0.2,1,0.3c0.3,0.1,0.8,0.3,0.7,0.7c-0.1,0.5-0.6,0.3-0.9,0.4
			c-1.5,0-3,0-4.5,0c-1.5,0-2.3-0.7-2.3-2.2c-0.1-1.5,0.8-2.5,2.4-2.5c0.7,0,1.5,0.1,2.2,0c1.3-0.2,2.8-0.4,3.9-1
			c0.9-0.5-0.4-1.4-0.2-2.2c0-0.2,0.1-0.4,0.1-0.5c0.8-2.8-1.8-5.3-3.6-5.2c-2.4,0.2-2.5-1.7-3.5-2.9c-0.3-0.4-0.1-0.6,0.1-1
			c1.9-3.2,1.4-4.9-2-6.3c-0.4-0.2-0.9-0.7-1.2,0c-0.2,0.5-0.4,1.2,0.2,1.6c0.3,0.2,0.7,0.4,1.1,0.6c1.3,0.7,1.4,1.7,0.4,2.7
			c-0.7,0.7-1.5,1.1-2.6,1c-2.1-0.1-4.2,0-6.3,0c-0.6,0-1.2,0-1.3,0.9c0,1,0.6,1,1.3,1c2.1,0,4.2,0,6.3,0c0.7,0,1.4,0,2.1,0.5
			c0.4,0.3,0.8,0.6,0.7,1.1c-0.1,0.7-0.8,0.5-1.2,0.5c-3.2,0-6.5,0.1-9.7,0C149.3,286.2,147.6,286.7,146.1,288.1z M174.3,326.7
			c1.4,0,2.9-0.1,4.3,0c1.1,0.1,1.5-0.3,1.5-1.4c-0.1-1.4,0-2.9,0-4.3c0-1,0.3-1.7,1.1-2.2c1.4-0.9,2.3-2.2,2.8-3.8
			c0.5-1.3,0.3-2.7,0.6-4.1c0.2-0.7,0.5-1.8-0.9-1.8c-1.4-0.1-1.2,0.9-1.1,1.7c0,2.8-0.6,5.4-3.3,7c-0.2,0.1-0.3,0.3-0.5,0.5
			c-1.5,1.4-0.9,3.1-0.9,4.8c0,1.3-0.4,1.7-1.7,1.6c-1.5-0.1-3-0.1-4.5,0c-1.1,0.1-1.5-0.4-1.4-1.5c0.1-0.7,0-1.3,0-2
			c-0.1-1.2-0.6-2.1-1.8-2.5c-3.3-1-5.1-3.3-5.9-6.6c-0.3-1-0.3-1.8,0.8-2.4c1-0.6,1.8-1.4,2.6-2.2c0.6-0.5,1.1-1,0.4-1.8
			c-0.8-0.9-1.3-0.2-1.7,0.3c-1.6,2-3.9,2.9-6.1,3.7c-4,1.5-7.2-0.4-9.9-3.3c-0.8-0.9-1.5-1.5,0.1-2.2c0.5-0.2,0.8-0.6,0.5-1.1
			c-0.2-0.4-0.5-1.1-1-0.7c-1.1,0.8-2.6,0.6-3.7,1.7c-3.3,3-9.5,1.7-11.5-2.4c-0.9-1.9-1.3-4-1.3-6.1c0-0.9-0.3-1.3-1.2-1.3
			c-1,0.1-1,0.7-0.8,1.4c0.1,0.6,0.1,1.2,0.2,1.8c0.6,4,1.6,7.7,5.8,9.5c2.9,1.3,5.8,0.6,8.5-0.5c1.1-0.4,1.7-0.4,2.5,0.6
			c3.2,4,7.2,5.9,12.4,4.5c1.2-0.3,1.5,0,1.7,1.1c0.6,2.7,1.8,5.4,4.4,6.4c3.2,1.2,3.7,3.4,3.3,6.2c-0.2,1.1,0.4,1.5,1.5,1.4
			C171.4,326.7,172.8,326.7,174.3,326.7z M171.3,279c-0.4-1.1-0.8-2-1.2-2.9c-3.1-6.5-8.2-8.2-14.5-4.8c-1,0.5-1.5,0.5-2.4-0.1
			c-3.4-2.2-7-3.5-11.2-3.4c-5.9,0.2-10.2,6.3-11.4,11c-0.1,0.5,0.1,0.8,0.6,0.9c0.6,0.1,1.1,0,1.3-0.6c0.3-0.8,0.7-1.7,1-2.5
			c1.8-4.6,6-7.4,10.3-6.9c2.7,0.3,5.1,1.2,7.4,2.5c1,0.5,1.9,1.1,0.2,2c-0.7,0.4-1,1-0.3,1.8c0.7,0.8,1.2,0.2,1.6-0.3
			c1.5-1.5,3.2-2.7,5.2-3.5c3.1-1.4,6-0.8,8.4,1.6c1.7,1.7,2.4,4,3.1,6.2c0.1,0.4,0,1,0.6,1c0.5,0,1.2-0.1,1.2-0.5
			c0.3-1.8,1.4-1.1,2.3-0.7c2.5,0.9,4.2,2.7,4.9,5.3c0.6,2,0.5,4,0.1,6.1c-0.2,1-0.3,1.3-1.3,0.9c-0.5-0.2-1.3-0.9-1.6,0.3
			c-0.2,0.8,0.3,1.2,1,1.6c1.6,1.2,3.8,1.6,4.8,3.8c1.5,3.3,0.5,6.2-1.5,8.9c-0.4,0.6-0.8,1-0.1,1.6c0.7,0.6,1.1,0.1,1.5-0.3
			c3.6-3.5,3.7-10.1,0.1-13.5c-0.9-0.9-1-1.6-0.9-2.8c0.8-6.2-0.3-11.3-6.6-13.8C172.8,277.4,171.6,276.8,171.3,279z M117.3,293.6
			c0.1-2.2,0.9-4.5,2.7-6.5c0.8-0.9,1.5-1.1,2,0.4c0.2,0.7,0.6,1.3,0.9,1.9c0.3,0.5,0.7,1,1.5,0.6c0.7-0.4,0.6-0.9,0.3-1.5
			c-0.5-1.1-1-2.2-1.3-3.3c-1-3.5,0.2-6.2,3.4-7.8c0.7-0.4,1.5-0.7,2.3-1c0.7-0.3,0.5-0.8,0.3-1.4c-0.1-0.5-0.4-0.7-0.9-0.5
			c-3.5,1.1-7.3,3.6-7.5,8.2c0,0.9-0.3,1.4-1,1.9c-4,3.1-5.6,8.8-3.8,13.3c2,5.1,7.7,7.2,12.1,7.1c0.6,0,1.1-0.1,1.1-0.9
			c0-0.8-0.4-0.9-1.1-1c-1.4-0.2-2.7-0.4-4.1-0.7C119.9,301.4,117.3,298.1,117.3,293.6z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M146.1,288.1c1.5-1.4,3.2-1.9,5.2-1.9c3.2,0.1,6.5,0,9.7,0c0.4,0,1.1,0.2,1.2-0.5c0.1-0.5-0.4-0.9-0.7-1.1
			c-0.6-0.5-1.3-0.5-2.1-0.5c-2.1,0-4.2,0-6.3,0c-0.7,0-1.4,0-1.3-1c0-0.9,0.6-0.9,1.3-0.9c2.1,0,4.2-0.1,6.3,0c1.1,0,1.9-0.4,2.6-1
			c1-1,0.9-2-0.4-2.7c-0.4-0.2-0.8-0.4-1.1-0.6c-0.6-0.4-0.5-1.1-0.2-1.6c0.3-0.7,0.8-0.2,1.2,0c3.4,1.4,3.9,3.1,2,6.3
			c-0.2,0.3-0.4,0.6-0.1,1c0.9,1.2,1,3.1,3.5,2.9c1.9-0.1,4.5,2.4,3.6,5.2c-0.1,0.2-0.1,0.3-0.1,0.5c-0.2,0.8,1,1.8,0.2,2.2
			c-1.2,0.6-2.6,0.8-3.9,1c-0.7,0.1-1.4,0-2.2,0c-1.5,0-2.4,1-2.4,2.5c0.1,1.4,0.9,2.2,2.3,2.2c1.5,0,3,0,4.5,0
			c0.3,0,0.8,0.1,0.9-0.4c0.1-0.4-0.3-0.6-0.7-0.7c-0.3-0.1-0.7-0.3-1-0.3c-0.8-0.2-1.1-0.6-0.8-1.4c0.3-0.9,0.8-0.6,1.4-0.5
			c1.5,0.4,2.7,1.2,3.5,2.6c0.1,0.3,0.2,0.6,0.6,0.6c0.9,0.1,1,0.7,0.9,1.4c-0.1,0.9-0.7,0.8-1.3,0.8c-0.2,0-0.4,0-0.5,0.1
			c-2.2,2.8-5.3,1.9-8.2,2c-1.1,0.1-2.2,0-3.2,0c-0.7,0-0.9-0.5-0.9-1.1c0-0.6,0.2-1.1,0.9-1.1c0.8,0,1.6,0,2.7,0
			c-1.6-1-2.6-1.9-3-3.5c-0.1-0.5-0.3-1-0.1-1.6c0.3-0.8,0.6-1.5-0.4-2.2c-0.7-0.5,0-1.8,1.1-1.7c2.1,0.1,4-0.7,6.1-0.4
			c1.3,0.1,1.6-0.8,1.7-1.8c0.2-1.5-0.8-2.2-2-2.6c-0.8-0.3-1.8-0.4-2.2,0.8c-0.4,1.3-1.5,2-2.7,2.4c-0.5,0.2-1.1,0.5-1.4-0.3
			c-0.2-0.6-0.2-1.2,0.6-1.5c0.3-0.1,0.7-0.3,0.9-0.5c0.2-0.2,0.4-0.5,0.4-0.7c0-0.4-0.4-0.3-0.7-0.3c-3.8,0-7.7,0-11.5,0.1
			c-0.5,0-1.1,0.4-1.6,0.7c-0.4,0.3-0.7,0.7-0.6,1.2c0.1,0.7,0.8,0.5,1.2,0.5c1.3,0,2.6,0,4,0c2,0.1,3.8,1.4,4.1,3.1
			c0.5,2.3-0.5,4.6-2.4,5.5c-0.4,0.2-0.9,0.6-1.3,0c-0.4-0.5-0.4-1.1,0.1-1.6c0.3-0.4,0.7-0.6,1-1c0.7-0.9,0.8-1.8,0.4-2.8
			c-0.4-0.9-1.2-1-2.1-1c-1,0-2,0-3.3,0c1,0.6,1.2,1.4,0.8,2.1c-0.5,0.7-1.2,0-1.8-0.2c-0.3-0.1-0.7-0.2-1-0.5c-2.6-2.7-6-1-9-1.4
			c-1-0.1-1.4,1-1.7,1.8c-0.3,0.9,0.1,1.6,0.7,2.2c0.3,0.3,0.7,0.5,1,0.8c0.5,0.6,0.1,1.2-0.2,1.6c-0.3,0.5-0.8,0-1.1-0.2
			c-1.9-1-2.9-3-2.5-4.7c0.6-2.5,2.2-3.9,4.7-3.9c1.4,0,2.9-0.1,4.3,0c1.7,0.2,2.5-0.5,2.4-2.2c0,0,0,0,0,0
			C145.9,288.4,146,288.2,146.1,288.1C146.2,288.1,146.1,288.1,146.1,288.1z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M174.3,326.7c-1.4,0-2.9,0-4.3,0c-1.1,0-1.6-0.3-1.5-1.4c0.4-2.8,0-5-3.3-6.2c-2.6-1-3.8-3.7-4.4-6.4
			c-0.2-1.1-0.5-1.4-1.7-1.1c-5.1,1.4-9.2-0.5-12.4-4.5c-0.8-1.1-1.4-1.1-2.5-0.6c-2.8,1.1-5.6,1.8-8.5,0.5
			c-4.1-1.8-5.2-5.5-5.8-9.5c-0.1-0.6-0.1-1.2-0.2-1.8c-0.1-0.7-0.2-1.3,0.8-1.4c1-0.1,1.3,0.4,1.2,1.3c0,2.1,0.4,4.2,1.3,6.1
			c2,4,8.2,5.4,11.5,2.4c1.1-1,2.5-0.9,3.7-1.7c0.5-0.3,0.8,0.3,1,0.7c0.3,0.6,0,0.9-0.5,1.1c-1.6,0.6-0.9,1.3-0.1,2.2
			c2.7,2.9,5.9,4.8,9.9,3.3c2.2-0.8,4.5-1.8,6.1-3.7c0.4-0.5,1-1.2,1.7-0.3c0.7,0.8,0.2,1.3-0.4,1.8c-0.9,0.8-1.7,1.6-2.6,2.2
			c-1.1,0.6-1,1.4-0.8,2.4c0.8,3.3,2.6,5.6,5.9,6.6c1.2,0.4,1.8,1.3,1.8,2.5c0,0.7,0.1,1.3,0,2c-0.1,1.1,0.3,1.5,1.4,1.5
			c1.5-0.1,3-0.1,4.5,0c1.2,0.1,1.7-0.3,1.7-1.6c0-1.6-0.6-3.4,0.9-4.8c0.2-0.2,0.3-0.4,0.5-0.5c2.6-1.6,3.3-4.1,3.3-7
			c0-0.8-0.2-1.8,1.1-1.7c1.4,0.1,1.1,1.1,0.9,1.8c-0.3,1.3-0.2,2.7-0.6,4.1c-0.5,1.6-1.4,2.9-2.8,3.8c-0.9,0.5-1.2,1.2-1.1,2.2
			c0.1,1.4,0,2.9,0,4.3c0.1,1.1-0.4,1.5-1.5,1.4C177.2,326.7,175.7,326.7,174.3,326.7z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M171.3,279c0.3-2.2,1.5-1.6,2.7-1.1c6.3,2.5,7.4,7.6,6.6,13.8c-0.2,1.2-0.1,1.9,0.9,2.8
			c3.6,3.4,3.5,10-0.1,13.5c-0.4,0.4-0.8,1-1.5,0.3c-0.7-0.6-0.3-1.1,0.1-1.6c2-2.7,3-5.6,1.5-8.9c-0.9-2.1-3.1-2.6-4.8-3.8
			c-0.7-0.5-1.2-0.8-1-1.6c0.3-1.1,1.1-0.5,1.6-0.3c1,0.4,1.1,0.1,1.3-0.9c0.4-2,0.4-4-0.1-6.1c-0.7-2.6-2.4-4.4-4.9-5.3
			c-0.9-0.3-2-1-2.3,0.7c-0.1,0.5-0.8,0.5-1.2,0.5c-0.6,0-0.4-0.6-0.6-1c-0.8-2.2-1.4-4.5-3.1-6.2c-2.4-2.5-5.2-3-8.4-1.6
			c-1.9,0.9-3.7,2-5.2,3.5c-0.5,0.5-0.9,1-1.6,0.3c-0.7-0.8-0.4-1.4,0.3-1.8c1.6-0.9,0.7-1.5-0.2-2c-2.3-1.3-4.8-2.3-7.4-2.5
			c-4.3-0.5-8.5,2.4-10.3,6.9c-0.3,0.8-0.7,1.7-1,2.5c-0.2,0.6-0.8,0.7-1.3,0.6c-0.5-0.1-0.7-0.5-0.6-0.9c1.2-4.8,5.5-10.9,11.4-11
			c4.1-0.1,7.8,1.2,11.2,3.4c0.9,0.6,1.5,0.6,2.4,0.1c6.3-3.4,11.4-1.6,14.5,4.8C170.5,277,170.8,277.9,171.3,279z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M117.3,293.6c0,4.5,2.6,7.8,6.8,8.9c1.3,0.3,2.7,0.5,4.1,0.7c0.7,0.1,1.2,0.2,1.1,1c0,0.8-0.5,0.9-1.1,0.9
			c-4.4,0-10.1-2-12.1-7.1c-1.7-4.5-0.2-10.2,3.8-13.3c0.7-0.5,1-1,1-1.9c0.2-4.6,3.9-7.1,7.5-8.2c0.5-0.2,0.8,0,0.9,0.5
			c0.2,0.5,0.4,1.1-0.3,1.4c-0.8,0.3-1.6,0.6-2.3,1c-3.2,1.6-4.4,4.3-3.4,7.8c0.3,1.1,0.8,2.2,1.3,3.3c0.3,0.6,0.4,1.1-0.3,1.5
			c-0.7,0.4-1.1-0.1-1.5-0.6c-0.4-0.6-0.7-1.3-0.9-1.9c-0.4-1.5-1.1-1.3-2-0.4C118.2,289.1,117.4,291.5,117.3,293.6z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M145.8,288.5c-0.5,0.4-0.9,0.8-1.4,1.1c-0.5,0.3-1.3,0.8-1.8,0c-0.4-0.7-0.1-1.3,0.7-1.7
			c1.5-0.9,1.3-3-0.2-3.7c-0.9-0.4-1.8-0.9-2.1,0.8c-0.2,1.3-1.1,1.1-1.8,0.4c-1.1-1.1-2.2-1.8-3.8-1.5c-0.7,0.1-0.9-0.4-0.9-1
			c0-0.7,0.2-1.2,1-1.1c1.2,0.1,1.6-0.5,1.9-1.6c0.5-1.7,1.9-2.7,3.6-2.8c2.2-0.1,4.4,0,6.7,0c0.6,0,1.2-0.1,1.3,0.8
			c0,1-0.6,1-1.3,1c-1.7,0-3.4,0-5,0c-0.5,0-1.1,0-1.6,0.2c-0.8,0.3-2,0.5-1.8,1.7c0.2,1.1,1.3,0.6,2,0.6c3.6,0.1,5.5,2.6,4.8,6.5
			c0,0,0,0,0,0C146,288.2,145.9,288.4,145.8,288.5C145.8,288.5,145.8,288.5,145.8,288.5z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M145.8,288.5c0.1-0.1,0.3-0.3,0.4-0.4C146,288.2,145.9,288.4,145.8,288.5z"/>
	</g>
	<g style={{ display: "none" }} className="st4">
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M426.5,299.2c0-1.3,0-2.5,0-3.8c0-0.9,0.2-1.8-1.2-2.2c-0.9-0.2-0.9-1.4,0-1.7c0.8-0.3,1.2-0.6,1.2-1.5
			c-0.1-0.6,0.3-0.8,0.9-0.8c0.6,0,0.9,0.3,0.9,0.9c-0.1,1.3,0.7,1.3,1.6,1.3c4.7,0.1,4.6,0.1,4.6-4.6c0-1-0.2-1.6-1.3-2
			c-2.4-1-3.6-3.6-3-6.3c0.5-2.2,2.8-4.1,5.1-4.1c2.5,0,4.8,1.8,5.5,4.4c0.6,2.3-0.6,4.9-3,5.9c-1.3,0.5-1.6,1.3-1.5,2.6
			c0.1,4.1,0,4.1,4,4.1c1.1,0,2.4,0.3,2.2-1.6c-0.1-0.7,0.6-0.6,1.1-0.6c0.6,0,0.9,0.3,0.9,0.9c0,0.7,0.2,1.1,1,1.4
			c0.8,0.4,0.9,1.5-0.1,1.9c-1,0.4-0.8,1-0.8,1.7c0,2.7,0.1,5.4,0,8.1c-0.1,1.6,0.6,2.1,2,2.3c4.2,0.5,8.4,1.3,12.4,2.8
			c2,0.7,3.9,1.6,5.4,3.1c2.6,2.5,2.4,5.5-0.5,7.6c-3.3,2.4-7.1,3.6-10.9,4.4c-7.3,1.6-14.7,2.2-22.1,1.8c-8-0.4-15.9-1.2-23.2-4.7
			c-1.2-0.6-2.1-1.3-3-2.2c-2.3-2.4-2.1-5.3,0.6-7.2c3.7-2.7,7.9-3.9,12.3-4.7c2.6-0.5,5.3-1.1,8-1.1c1,0,1.2-0.5,1.2-1.4
			C426.5,302.3,426.6,300.7,426.5,299.2C426.5,299.2,426.5,299.2,426.5,299.2z M434.6,323.5c6-0.2,12-0.6,17.9-1.9
			c3.3-0.8,6.7-1.6,9.5-3.6c3.1-2.1,3.1-4.2-0.1-6.2c-3.4-2.1-7.1-3.1-11-3.8c-2-0.4-4-0.8-6-0.8c-0.3,0-0.8,0-0.9,0.4
			c-0.1,0.6,0.4,0.6,0.8,0.7c0.4,0.1,0.7,0,1.1,0c4.2,0.5,8.4,1.1,12.4,2.9c1.7,0.8,3.6,1.7,3.5,3.9c-0.1,2.2-2.1,2.9-3.8,3.7
			c-5,2.2-10.4,2.9-15.8,3.1c-8.6,0.4-17.2,0.5-25.6-1.4c-2.8-0.6-5.7-1.2-7.9-3.2c-1.9-1.7-1.7-3.6,0.3-5.1c1.8-1.3,3.9-1.8,6-2.4
			c3.6-1.1,7.3-1.3,11-1.8c0.3,0,0.8,0.1,0.8-0.4c0-0.5-0.4-0.7-0.9-0.7c-0.4,0-0.8,0-1.3,0c-2.8,0.5-5.7,0.8-8.5,1.5
			c-3.6,0.9-7.4,1.7-10.3,4.5c-1.4,1.4-1.4,2.7,0,4.2c1.6,1.6,3.6,2.4,5.6,3.1C418.9,322.7,426.7,323.2,434.6,323.5z M434.5,318.8
			c-4,0.1-8.1,0-12.2-0.4c-2.6-0.3-5.1-0.6-7.6-1.4c-1-0.3-2.1-0.8-2.1-1.9c-0.1-1.3,1.1-1.7,2.1-2.1c4.2-1.4,8.6-1.5,12.9-1.7
			c0.5,0,1.6,0.4,1.6-0.5c0-0.8-0.9-1-1.7-0.9c-1.4,0.1-2.9,0.2-4.3,0.4c-3.7,0.5-7.4,1-10.8,2.4c-1.2,0.5-3.1,0.9-3.1,2.4
			c0,1.6,1.8,2,3.2,2.5c5.6,2,11.4,2.7,17.3,2.8c5,0.1,10,0.3,14.9-0.3c4.2-0.5,8.4-1,12.4-2.7c1.1-0.5,2.8-0.9,2.8-2.3
			c0-1.4-1.6-1.8-2.7-2.3c-3.6-1.5-7.4-2-11.2-2.6c-1.1-0.2-2.1-0.3-3.2-0.3c-0.7,0-1.3,0.4-1.3,1c0,0.7,0.7,0.4,1.2,0.5
			c1.8,0.1,3.6,0.1,5.4,0.4c2.2,0.3,4.5,0.5,6.7,1.4c0.8,0.3,1.7,0.7,1.8,1.8c0.1,1.2-0.9,1.5-1.7,1.8c-0.6,0.3-1.2,0.5-1.9,0.6
			C446.9,318.7,440.8,318.9,434.5,318.8z M414.6,315.1c6.8,1.7,13.2,2,19.9,1.9c-1.7-2.5-3-4.6-6.2-4.1c-2.2,0.4-4.6,0.1-6.8,0.5
			C419.4,313.7,417.1,313.7,414.6,315.1z M454.1,315c-0.8-0.6-1.6-0.8-2.4-0.9c-2.5-0.5-5-0.6-7.4-0.9c-2.9-0.5-5.5-0.4-7,2.6
			c-0.2,0.3-0.6,0.5-0.5,0.9c0.2,0.5,0.7,0.3,1.1,0.3c2.9,0.2,5.9-0.2,8.8-0.5C449.1,316.3,451.7,316.1,454.1,315z M436.2,299.5
			c0,1.6,0.1,3.1,0,4.7c-0.1,1.3,0.6,1.6,1.8,1.6c1.1,0,1.9-0.1,1.9-1.5c-0.1-3.2-0.1-6.4,0-9.6c0-1.6-1.1-1.2-2-1.3
			c-1-0.1-1.8,0-1.7,1.4C436.3,296.4,436.2,298,436.2,299.5z M434.5,299.8c0-1.7,0-3.5,0-5.2c0-1.2-0.8-1.1-1.6-1.1
			c-0.8,0-1.8-0.3-1.8,1.1c0,3.3,0,6.7,0,10c0,1.3,0.8,1.2,1.7,1.2c0.8,0,1.7,0.1,1.7-1.2C434.4,303,434.5,301.4,434.5,299.8z
			 M431.9,280c0,2,1.5,3.5,3.6,3.5c1.8,0,3.7-1.8,3.6-3.5c-0.1-1.9-1.9-3.7-3.8-3.7C433.6,276.3,431.9,278.1,431.9,280z
			 M429.6,307.6c1.7,2,3.1,3.7,4.5,5.3c0.4,0.5,0.9,0.7,1.3,0.1c1.2-1.5,2.4-2.9,3.6-4.4c0.4-0.5,0.5-1-0.5-1
			C435.7,307.6,432.9,307.6,429.6,307.6z M429.4,299.5c0-1.6,0-3.2,0-4.9c0-0.4,0.1-1.1-0.6-1.1c-0.6,0-0.5,0.6-0.5,1
			c0,3.4,0,6.7,0,10.1c0,0.4-0.1,1,0.5,1c0.7,0,0.6-0.7,0.6-1.1C429.4,302.9,429.4,301.2,429.4,299.5z M442.1,293.6
			c-0.6,0.4-0.4,0.8-0.4,1.2c0,2.9,0,5.9,0,8.8c0,0.5-0.3,1.3,0.5,1.3c0.7,0,0.7-0.8,0.6-1.3c-0.4-2.7-0.3-5.4-0.3-8.1
			C442.4,294.9,442.6,294.2,442.1,293.6z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M423.2,279.1c0,2.8,1,5.3,2.9,7.4c0.5,0.6,1.2,1.1,0.3,1.9c-0.9,0.8-1.3-0.2-1.7-0.6
			c-1.4-1.6-2.4-3.4-2.9-5.5c-0.2-1-0.6-1.6-1.8-1.4c-0.8,0.1-1.4,0-1.4-1.1c0-1,0.7-0.9,1.4-0.9c0.7,0,1.7,0.1,1.5-1
			c-0.2-1,1.2-2.4-0.7-3c-0.6-0.2-1.7-0.3-1.1-1.5c0.5-1.1,1.2-0.4,1.8-0.2c0.7,0.3,1.3,0.2,1.6-0.5c0.6-1.2,2.2-2.3,0.2-3.7
			c-0.5-0.3-0.1-0.9,0.2-1.2c0.4-0.5,0.8-0.4,1.2,0c0.5,0.4,0.8,1.3,1.6,0.9c0.9-0.4,1.8-1,2.5-1.7c0.5-0.4-0.1-1-0.2-1.5
			c-0.1-0.5-0.5-1.1,0.3-1.4c0.7-0.3,1.2-0.1,1.4,0.7c0.3,1.3,0.9,1.4,2.2,1.2c5.5-1,11.1,2,13.7,6.9c2.6,4.9,1.9,11-1.8,14.9
			c-0.4,0.5-0.8,1.6-1.8,0.8c-1.1-0.9,0-1.4,0.4-1.9c5-5.9,3.2-15.1-4.3-18.2C431.2,265.3,423.2,270.9,423.2,279.1z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M413.9,280.8c-0.8,0-1.6,0-2.3,0c-0.7,0-0.9-0.4-0.9-1c0-0.6,0.2-1,0.9-1c1.5,0,3,0,4.5,0c0.7,0,1,0.2,1,0.9
			c0,0.7-0.2,1.1-1,1.1C415.3,280.8,414.6,280.8,413.9,280.8z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M457.2,280.9c-0.7,0-1.4,0-2.1,0c-0.6,0-1-0.1-1-0.9c0-0.6,0.2-1.1,0.9-1.1c1.5,0,3.1,0,4.6,0
			c0.7,0,0.9,0.5,0.9,1.1c0,0.7-0.4,0.9-1,0.9C458.6,280.8,457.9,280.9,457.2,280.9z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M436.5,264.2c0,0.6,0,1.2-1,1.2c-1.1,0-1.1-0.6-1.1-1.4c0-0.7-0.1-1.5,1-1.4
			C436.5,262.6,436.5,263.3,436.5,264.2z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M451.8,280.8c-1.2,0.1-1.9,0.1-1.9-1c0-1,0.6-1,1.3-1c0.9,0,1.6,0.1,1.5,1.2
			C452.7,281.1,452,280.8,451.8,280.8z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M441.4,266.7c-0.5-0.2-1.2-0.3-1.1-1c0.1-0.7,0.1-1.7,0.9-1.9c0.5-0.2,1.2,0.2,1.1,1
			C442.3,265.6,442.1,266.3,441.4,266.7z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M421.1,284.9c0.7-0.1,1,0.2,1,0.8c0.1,1.2-1,1.1-1.7,1.4c-0.9,0.3-0.9-0.5-0.9-0.9
			C419.3,284.9,420.7,285.4,421.1,284.9z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M449.6,274.9c-0.8,0.1-0.9-0.6-0.9-1c0-1.1,1.1-0.9,1.8-1.2c0.6-0.2,0.9,0.3,0.9,0.8
			C451.4,274.8,450.2,274.5,449.6,274.9z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M451.4,285.9c0,0.7-0.2,1.2-0.8,1c-0.7-0.2-1.8,0-1.9-1.2c0-0.3,0-1.3,0.8-1.1
			C450.3,284.9,451.2,284.9,451.4,285.9z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M447,267.3c0.5,0.3,1.1,0.6,1,1.1c-0.3,0.8-0.8,1.5-1.7,1.6c-0.4,0.1-1-0.5-0.9-1
			C445.6,268.2,446.4,267.7,447,267.3z"/>
	</g>
	<g>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M304.4,189.1c-1.1-1-2.2-1.8-3.2-2.8c-1-1-1.6-0.8-2.5,0.1c-0.7,0.8-1.6,1.5-2.8,2.6c0-2.4,0-4.3,0-6.2
			c0-1-0.2-1.4-1.3-1.3c-1,0-1.6,0-1.5,1.3c0.1,1.9,0,3.8,0,6c-1.2-0.6-1.9-1.4-2.6-2.2c-1.1-1.4-2-1.2-3.2,0
			c-0.8,0.9-1.7,1.8-3.2,2.5c0-2.8,0-5.3,0-7.9c0-2,0.2-4-0.9-5.8c-0.4-0.6-0.5-1.4-0.2-2.1c0.6-1.7-0.4-1.7-1.6-1.7
			c-4.9,0-9.9,0-14.8,0c-1.4,0-1.7-0.4-1.7-1.7c0-13.3,0-26.7,0-40c0-1.2,0.3-1.6,1.6-1.6c18.5,0,37,0,55.5,0c1.3,0,1.6,0.4,1.6,1.7
			c0,13.3,0,26.7,0,40c0,1.4-0.4,1.7-1.7,1.7c-4.9-0.1-9.7,0-14.6,0c-1.2,0-2.2,0-1.7,1.7c0.1,0.4,0.2,1,0,1.4
			c-1.9,4-0.7,8.3-1,12.4C304.6,187.8,304.8,188.4,304.4,189.1z M294.5,133.5c-7.3,0-14.5,0-21.8,0c-1,0-1.7,0.1-1.6,1.4
			c0,10.1,0,20.2,0,30.3c0,1.2,0.4,1.4,1.5,1.4c1.9-0.1,3.7-0.1,5.6,0c1.6,0.1,3,0.1,3.5-1.8c0.1-0.4,0.6-0.8,1-1
			c0.7-0.4,0.8-0.9,0.7-1.6c-0.6-3.7,2-6.4,5.7-5.7c0.7,0.1,1.2,0,1.7-0.6c2.2-2.7,5.4-2.7,7.6-0.1c0.7,0.8,1.2,0.9,2.1,0.7
			c2.6-0.5,5.5,1.6,5.4,4.2c0,1.7,0.9,2.7,1.6,4c1.2,2.4,3,2.1,4.9,2.1c1.3,0,2.7-0.1,4,0c1.3,0.1,1.6-0.4,1.6-1.6
			c0-9.9-0.1-19.8,0-29.8c0-1.3-0.3-1.7-1.7-1.7C308.8,133.6,301.7,133.5,294.5,133.5z M294.4,130.3c-8.5,0-17.1,0-25.6,0
			c-1.1,0-1.7,0.2-1.7,1.5c0.1,12.2,0,24.4,0,36.6c0,1.1,0.3,1.4,1.4,1.4c3.7-0.1,7.5,0,11.2,0c0.4,0,1.3,0.4,1.3-0.4
			c0.1-0.8-0.7-1-1.4-1c-2.9,0-5.9,0-8.8,0c-1.3,0-1.6-0.4-1.6-1.7c0-11.2,0-22.4,0-33.5c0-1.4,0.4-1.7,1.7-1.7
			c15.7,0,31.4,0,47.1,0c1.2,0,1.7,0.3,1.7,1.6c0,11.2,0,22.5,0,33.7c0,1.3-0.5,1.6-1.7,1.6c-2.8-0.1-5.5,0-8.3,0
			c-0.6,0-1.3-0.1-1.3,0.8c0,0.9,0.8,0.5,1.2,0.5c3.4,0,6.7-0.1,10.1,0.1c1.5,0.1,2-0.3,2-1.9c-0.1-11.9-0.1-23.8,0-35.7
			c0-1.7-0.5-2-2-2C311.2,130.3,302.8,130.3,294.4,130.3z M297.5,175c2.9,2.2,4.1,2.4,5.3,1.2c2.2-2.2,0.3-3.8-1-5.5
			c3.6-0.4,4.6-1,4.7-2.8c0.2-3.4-2.6-2.9-4.8-3.3c1.5-1.7,3.3-3.3,1.4-5.4c-2-2.1-3.8-0.4-5.5,0.9c-0.5-3.2-1.2-4.2-2.9-4.3
			c-2.9-0.1-2.9,2.2-3.4,4.2c-2.9-2-4.3-2.2-5.5-1c-1.2,1.2-0.9,2.7,1.1,5.4c-2,0.3-4.2,0.5-4.2,3.2c0,2.5,2.1,2.7,4,3.1
			c-1.3,1.6-2.8,3.3-1,5.1c2.1,2.2,3.9,0.3,5.7-1c0.7,3.8,1.3,4.8,3.2,4.7C296.4,179.5,297.2,178.4,297.5,175z M302.8,185.1
			c0-1.3,0-2.3,0-3.2c0-1,0.1-2.1-0.2-3c-0.1-0.2-1.6,0.2-2.3,0c-1.8-0.5-2.1,0.7-2.4,1.8c-0.2,1.1-0.1,2.3-0.1,4.2
			C299.9,181.5,301.1,183.7,302.8,185.1z M291.2,184.3c0-1.1-0.1-1.9,0-2.7c0.1-1.2-0.5-2.3-1.3-2.8c-1-0.6-2.3,0.3-3.5,0
			c-0.2-0.1-0.2,0.5-0.2,0.8c0,1.7,0,3.4,0,5.2C289,182.9,289,182.9,291.2,184.3z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M294.7,144.6c5.8,0,11.7,0,17.5,0c0.7,0,1.7-0.3,1.7,1c0,1.3-1,0.9-1.7,0.9c-11.8,0-23.6,0-35.3,0
			c-0.6,0-1.4,0.4-1.7-0.5c-0.4-1.2,0.3-1.4,1.4-1.4C282.6,144.6,288.7,144.6,294.7,144.6z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M294.6,148.2c5.9,0,11.8,0,17.7,0c0.6,0,1.5-0.3,1.6,0.9c0.1,1.3-0.9,1-1.6,1c-11.8,0-23.7,0-35.5,0
			c-0.6,0-1.5,0.4-1.6-0.9c0-1.3,0.9-1,1.6-1C282.7,148.2,288.6,148.2,294.6,148.2z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M294.5,140.6c5.9,0,11.8,0,17.7,0c0.6,0,1.5-0.3,1.6,0.9c0.1,1.3-0.9,1-1.6,1c-11.8,0-23.7,0-35.5,0
			c-0.6,0-1.5,0.4-1.6-0.9c-0.1-1.3,0.9-1,1.6-1C282.7,140.6,288.6,140.6,294.5,140.6z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M282.1,152.6c1.9,0,3.8,0,5.7,0c0.6,0,1.2-0.1,1.3,0.8c0,0.9-0.5,1.1-1.2,1.1c-3.9,0-7.9,0.1-11.8,0.1
			c-0.8,0-1-0.4-1-1.1c0-0.8,0.5-1,1.1-1C278.1,152.6,280.1,152.6,282.1,152.6z"/>
		<path style={{ fill: "#FFFFFF" }} className="st3" d="M294.4,161.8c3.3,0,5.9,2.6,5.9,5.8c0,3.1-2.7,5.8-5.8,5.8c-3.2,0-5.8-2.6-5.8-5.9
			C288.7,164.3,291.2,161.9,294.4,161.8z M294.5,171.4c2.1,0,3.8-1.7,3.9-3.7c0-2.1-1.7-3.9-3.9-3.9c-2,0-3.8,1.7-3.9,3.7
			C290.6,169.6,292.4,171.4,294.5,171.4z"/>
	</g>
	<g style={{ display: "none" }} className="st4">
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M248.8,144.9c1.3-1.4,2.1-3,3.7-4.1c1.9-1.3,3.8-2,6.1-2c6.5,0,13,0,19.5,0c1.3,0,1.6,0.4,1.6,1.6
			c0.3,7.7-6.6,14.4-13.9,14.2c-4.7-0.2-9.4,0-14.1-0.1c-1.7,0-1.7,0.8-1.8,2.1c0,1.4,0.2,2.2,1.8,2c0.4-0.1,0.8,0,1.3,0
			c1.4-0.2,1.9,0.4,1.7,1.7c0,0.3,0,0.6,0,0.9c-0.1,0.9,0.3,1.4,1.1,1.8c0.9,0.4,1.3,0,1.8-0.6c2-1.9,2-1.9,3.9,0.1
			c1.7,1.7,3.4,3.5,5.1,5.1c0.9,0.9,1,1.5,0,2.3c-0.3,0.2-0.5,0.5-0.8,0.8c-0.7,0.6-0.8,1.2-0.4,2.1c0.4,0.9,0.9,1.1,1.8,1.1
			c2.6,0,2.6,0.1,2.6,2.6c0,2.5-0.1,4.9,0,7.4c0,1.2-0.3,1.7-1.5,1.5c-0.5-0.1-1.1,0-1.6,0c-0.7,0-1,0.4-1.3,1
			c-0.2,0.6-0.3,1.1,0.2,1.6c0.4,0.3,0.7,0.7,1,1c1,0.8,0.9,1.4,0,2.3c-2,1.8-3.9,3.8-5.7,5.7c-1,1.1-1.8,1.3-2.7,0
			c-0.2-0.2-0.4-0.4-0.6-0.6c-0.6-0.6-1.2-0.7-1.9-0.4c-0.8,0.3-1,0.9-1,1.7c-0.1,2.8-0.1,2.8-2.9,2.8c-2.2,0-4.5-0.1-6.7,0
			c-1.5,0.1-2.2-0.3-1.9-1.9c0.1-0.4,0-0.7,0-1.1c0.1-0.8-0.3-1.2-1-1.5c-0.7-0.3-1.3-0.2-2,0.3c-2.2,2-2.2,1.9-4.4-0.2
			c-1.6-1.6-3.1-3.2-4.7-4.7c-1-0.9-1-1.6,0-2.5c0.6-0.6,1.7-1,1.4-2.1c-0.3-1.4-1.3-1.8-2.5-1.6c-1.5,0.2-2.1-0.2-2-1.9
			c0.2-2.6,0.1-5.3,0-7.9c-0.1-1.4,0.4-1.8,1.8-1.7c0.7,0.1,1.5,0.3,2.1-0.3c0.9-1,0.9-2-0.3-2.9c-1.5-1.1-1.4-2.1,0-3.4
			c1.6-1.4,3.1-3,4.6-4.6c1.9-1.9,1.9-1.9,3.8,0c0.5,0.5,1,1,1.8,0.5c0.7-0.4,1.2-0.8,1.1-1.6c0-0.2,0-0.5,0-0.7
			c-0.3-1.7,0.5-2.3,2.1-2c0.2,0,0.4,0,0.5,0c2.3,0,3.1-1.1,2.4-3.4c-0.3-1-1-0.6-1.6-0.6c-5.1,0-10.1,0-15.2,0
			c-6,0-12.2-5.7-12.8-11.6c-0.4-4.1-0.4-4.1,3.7-4.1c5,0,10,0.2,15,0C242.1,138.6,246.2,140.2,248.8,144.9z M247.9,165.8
			c0-1.4-0.1-2.8,0-4.1c0.1-1.1-0.5-1.3-1.4-1.3c-0.9,0-1.7,0-1.6,1.3c0,0.7,0.4,1.7-0.2,2.1c-1.1,0.7-2.5,1.3-3.8,1.6
			c-0.9,0.3-1.3-0.7-1.8-1.3c-0.8-0.8-1.3-0.8-2,0c-1.1,1.2-2.3,2.5-3.6,3.6c-0.9,0.8-0.9,1.5,0.1,2.1c2.2,1.4,0.4,2.9,0.1,4.4
			c-0.3,1.6-1.4,1.5-2.4,1.3c-1.2-0.1-1.6,0.4-1.5,1.5c0.1,1.6,0.1,3.2,0,4.9c-0.1,1.1,0.3,1.8,1.5,1.6c2.7-0.6,2.4,1.8,3.3,3.1
			c0.8,1.3-0.2,1.9-0.9,2.5c-0.8,0.7-0.9,1.2,0,2c1.2,1.1,2.4,2.2,3.4,3.4c0.9,1,1.5,0.8,2.3-0.1c0.5-0.6,1.1-1.7,2.2-0.9
			c1.3,0.9,3.9,0.5,3.5,3.3c-0.2,1.2,0.4,1.6,1.5,1.5c1.7-0.1,3.5,0,5.2,0c0.8,0,1.4-0.2,1.2-1.1c-0.4-1.9,0.6-2.5,2.2-3.2
			c1.5-0.6,2.6-1,3.7,0.6c0.5,0.8,1.1,0.9,1.9,0.1c1.1-1.2,2.3-2.4,3.6-3.6c0.8-0.7,0.9-1.4,0-2c-2.2-1.5-0.4-3.1-0.1-4.6
			c0.3-1.5,1.6-1,2.5-1c1.1,0,1.5-0.4,1.5-1.5c0-1.6-0.1-3.1,0-4.7c0.1-1.4-0.4-2-1.8-1.8c-1.4,0.2-2.2-0.3-2.3-1.7
			c0-0.3-0.2-0.7-0.4-1c-0.9-1.2-0.7-2.2,0.5-3c0.9-0.7,1-1.3,0-2.1c-1.3-1.1-2.4-2.3-3.6-3.6c-0.7-0.8-1.3-0.8-1.8,0.1
			c-1.5,2.4-3.1,0.5-4.7,0.1c-1.5-0.3-1.3-1.5-1.3-2.6c0.1-1-0.4-1.4-1.4-1.4c-1,0-1.4,0.3-1.4,1.3c0.1,2.5,0.1,5.1,0,7.6
			c0,1.1,0.3,1.5,1.5,1.7c5.6,0.8,9.2,6.4,7.9,11.7c-1.1,4.2-4.8,7.2-9,7.3c-4.2,0.1-8.3-2.8-9.4-6.8c-1.2-4.2,0.2-8.9,4.1-10.7
			c3.1-1.4,3.3-3.4,3-6C247.9,166.3,247.9,166,247.9,165.8z M230.9,140.8c-3.1,0-6.2,0-9.4,0c-1.2,0-1.6,0.4-1.5,1.6
			c0.5,5.4,5.6,10.2,11,10.2c4.6,0,9.1,0,13.7,0c3.6,0,3.1,0.5,3.1-3.2c0-4.7-3.7-8.5-8.4-8.5C236.7,140.8,233.8,140.8,230.9,140.8z
			 M267.2,140.8c-1.1,0-2.3,0-3.4,0c-2.3,0-4.6-0.2-6.8,0.1c-3.6,0.5-7.5,4.3-7.1,9.3c0.1,1.7,0.4,2.4,2.3,2.3c4.5-0.2,9-0.3,13.5,0
			c5.9,0.4,11.4-4.8,12-10.4c0.1-1.1-0.1-1.4-1.1-1.4C273.4,140.8,270.3,140.8,267.2,140.8z M249.9,181.3c-1.4,0-2.8,0-4.1,0
			c-0.7,0-1-0.2-1-0.9c0-0.6,0.3-0.9,0.9-0.8c2.5,0.5,2.4-1.1,2.3-2.7c-0.1-0.8-0.1-1.7,0-2.5c0.1-1.2-0.3-1.3-1.3-0.9
			c-3.2,1.5-5.1,5.7-4,9.1c1,3.3,4.9,6,8,5.5c4.2-0.6,7.1-3.8,7.1-7.7c0-3.8-2.9-7.1-6.6-7.7c-0.8-0.1-1.4,0-1.4,1c0,1.5,0,3,0,4.5
			c0,0.9,0.4,1.3,1.3,1.3c1,0,1.9,0,2.9,0c0.7,0,1.2,0,1.2,0.9c0,0.9-0.6,0.9-1.2,0.9C252.5,181.3,251.2,181.3,249.9,181.3z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M261.5,179.5c0.8,0,1.5-0.1,1.4,0.9c0,1-0.8,0.8-1.4,0.8c-0.6,0-1.4,0.2-1.4-0.8
			C260.1,179.3,261,179.6,261.5,179.5z"/>
		<path style={{ display: "inline", fill: "#FFFFFF" }} className="st5" d="M238.4,181.3c-0.7,0-1.3,0.1-1.3-0.9c0-0.9,0.6-0.9,1.2-0.8c0.7,0,1.3-0.1,1.3,0.9
			C239.6,181.4,239,181.3,238.4,181.3z"/>
	</g>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M190.9,288.1c-1.8,0-3.4-0.6-4.7-1.9c-3.2-3.3-6.5-6.4-9.7-9.7c-0.8-0.8-1.3-1.1-2.1-0.1
		c-0.4,0.5-0.8,1.2-1.6,0.4c-0.8-0.7-0.3-1.2,0.2-1.8c0.4-0.4,1.1-0.8,0.5-1.5c-0.6-0.6-1.1-1.7-2.3-1.2c-1.3,0.5-2.6,1.1-4,1.7
		c-1,0.4-0.6,1.2-0.6,1.9c-0.1,3.2,0,3.2-3.1,3.2c-2.5,0-5.1,0-7.6,0c-1.1,0-1.8-0.2-1.6-1.5c0.5-2.5-0.6-3.6-3-4.5
		c-2-0.8-3.3-0.8-4.5,1c-0.9,1.2-1.7,1.1-2.7,0c-2-2.2-4.2-4.3-6.4-6.4c-0.9-0.8-0.9-1.5,0-2.2c2-1.4,2.3-2.9,0.9-4.9
		c-0.2-0.3-0.4-0.8-0.4-1.2c-0.2-1.4-1.1-1.7-2.4-1.7c-3.1,0.1-2.7,0.5-2.8-2.8c0-2.6,0-5.3,0-7.9c0-1.2,0.3-1.7,1.5-1.5
		c0.2,0,0.4,0,0.5,0c1.9,0.3,3.1-0.3,3.4-2.3c0-0.2,0.1-0.3,0.2-0.5c1.3-2,1.1-3.6-0.9-4.9c-1-0.6-0.9-1.3,0-2.2
		c2.3-2.2,4.5-4.4,6.6-6.6c0.8-0.9,1.5-0.9,2.2,0c1.5,2.2,3,1.9,5.3,1c2-0.8,2.8-1.7,2.5-3.7c-0.3-1.6,0.3-2.1,2-2
		c2.9,0.1,5.8,0.1,8.7,0c1.2,0,1.9,0.3,1.7,1.6c-0.4,2.3,0.4,3.6,2.7,4.4c2,0.8,3.3,1,4.6-0.9c0.9-1.3,1.7-1.2,2.8,0
		c2,2.2,4.2,4.3,6.4,6.4c0.7,0.7,1.1,1.3,0.1,2c-2.2,1.5-2.3,3.1-1.2,5.6c0.8,1.7,1.5,2.3,3.4,2.2c2.9-0.1,2.5-0.4,2.6,2.6
		c0,2.8,0,5.5,0,8.3c0,1-0.3,1.6-1.3,1.3c-3.3-0.7-4.4,1.2-5.2,3.8c-0.4,1.2-0.3,1.9,0.6,2.8c0.8,0.7,1.3,0.7,1.9,0
		c0.4-0.4,0.8-1,1.5-0.3c0.6,0.6,0.6,1.2-0.1,1.7c-1.1,0.8-0.6,1.4,0.1,2.1c3.1,3.1,6.3,6.1,9.3,9.3c1.8,2,2.9,4.3,1.9,7.1
		C195.6,286.7,193.6,288.1,190.9,288.1z M145.5,230.8c-0.3,0.3-0.6,0.5-0.8,0.7c-1.4,1.4-2.7,2.8-4.1,4.1c-1,0.9-1,1.4,0,2.2
		c1.3,1.1,1.5,2.4,0.7,4c-0.5,0.9-0.9,2-1.2,3c-0.5,1.8-1.6,2.7-3.5,2.5c-1.1-0.1-1.5,0.3-1.4,1.4c0.1,1.9,0.1,3.7,0,5.6
		c-0.1,1.3,0.4,1.7,1.6,1.6c1.6-0.2,2.6,0.7,3.1,2.2c0.3,1,0.6,2,1.1,2.8c1.3,1.9,1,3.4-0.7,4.8c-0.7,0.5-0.6,1,0,1.6
		c1.4,1.3,2.8,2.6,4.1,4.1c0.9,1.1,1.5,1,2.4-0.1c1.1-1.3,2.4-1.6,3.9-0.7c0.8,0.5,1.7,0.9,2.6,1.1c2.1,0.5,3.2,1.5,2.9,3.7
		c-0.1,1,0.3,1.4,1.3,1.3c2-0.1,4-0.1,5.9,0c1,0,1.4-0.4,1.3-1.4c-0.2-2.1,0.7-3.3,2.8-3.8c0.6-0.1,1.2-0.5,1.8-0.8
		c2.9-1.4,2.9-1.4,5.2,0.7c0.7,0.6,1.1,0.7,1.7,0c1.3-1.4,2.7-2.8,4.1-4.1c1-0.9,0.9-1.5-0.1-2.2c-1.6-1.2-1.9-2.7-0.8-4.5
		c0.4-0.6,0.6-1.3,0.8-2c0.5-2.3,1.8-3.4,4.2-3.1c0.8,0.1,1.3-0.1,1.3-1.1c0-2.2,0-4.3,0-6.5c0-0.7-0.3-1.2-1.1-1.1
		c-2.6,0.3-4-1-4.5-3.4c-0.1-0.5-0.4-0.9-0.6-1.3c-1.3-2.7-1.3-2.7,0.7-4.9c0.9-0.9,0.7-1.5-0.1-2.2c-1.2-1.1-2.4-2.2-3.4-3.4
		c-1-1.2-1.9-1.3-2.9,0c-1,1.3-2.3,1.4-3.8,0.6c-0.8-0.4-1.6-0.9-2.5-1.1c-2.2-0.5-3.3-1.7-3-4c0.1-0.9-0.3-1.3-1.2-1.3
		c-1.9,0-3.7,0.1-5.6,0c-1.4-0.1-2,0.4-1.8,1.8c0.2,1.7-0.7,2.6-2.2,3.1c-1.1,0.4-2.3,0.8-3.3,1.3c-1.5,0.8-2.7,0.5-3.8-0.7
		C146.4,231.6,146,231.2,145.5,230.8z M194.8,282c0.1-0.9-0.2-1.7-0.8-2.5c-3.2-3.9-7-7.2-10.5-10.8c-0.4-0.4-0.8-0.5-1.2,0
		c-1.6,1.6-3.1,3.1-4.7,4.7c-0.5,0.5-0.5,0.9,0,1.4c3.5,3.5,7,7.1,10.6,10.5c1.2,1.1,2.7,1.5,4.3,0.6C194,285.1,194.9,284,194.8,282
		z"/>
	<path style={{ fill: "#FFFFFF" }} className="st3" d="M160.3,239.7c6.8,0,12.1,5.2,12.1,12c0,6.4-5.1,12.2-12.1,12.2c-7,0-12.2-5.8-12.1-12.2
		C148.2,244.9,153.5,239.7,160.3,239.7z M160.2,262.1c4,0.1,8-2.6,9.6-6.4c0.2-0.4,0.7-0.9,0.2-1.3c-0.5-0.5-1,0.1-1.4,0.4
		c-3.2,1.8-6.5,3.3-10.4,2.3c-2.3-0.6-4.4-1.6-6.4-2.7c-0.4-0.2-0.8-0.7-1.3-0.3c-0.4,0.4-0.1,0.9,0.1,1.3
		C152.1,259.3,156.1,262,160.2,262.1z M170.2,249.4c0-0.5,0-0.8-0.1-1.1c-1.6-5.1-7.6-8.3-12.7-6.7c-3.1,1-5.4,3-6.7,6.1
		c-0.2,0.5-0.6,1.1-0.2,1.5c0.5,0.4,1-0.2,1.4-0.4c1-0.4,1.9-1,2.9-1.4c4-1.9,7.9-2,11.9,0.1C167.9,248.2,168.9,248.7,170.2,249.4z
		 M163.8,251.7c0-2-1.5-3.6-3.4-3.6c-1.9,0-3.5,1.5-3.5,3.6c0,2.1,1.4,3.6,3.4,3.6C162.2,255.3,163.7,253.7,163.8,251.7z
		 M165.3,254.3c1.8-0.5,3.7-1.3,4.2-2.6c0.3-0.9-2-1.6-3.1-2.4c-0.1-0.1-0.2-0.1-0.3-0.1c-0.5-0.1-0.8,0-0.6,0.6
		C165.8,251.2,165.6,252.6,165.3,254.3z M155,249.5c-1.5,0.5-3.2,1-3.6,2.1c-0.3,0.9,1.8,1.3,2.8,1.9c0.2,0.1,0.4,0.1,0.7,0.1
		C155,252.4,155,251.1,155,249.5z"/>
</g>
{/*English Gambodia */}
{commonStore.lang === "en" && surveyCode === "kh" && englishLevels_kh}


{/*Cambodia*/}
{commonStore.lang === "kh" && cambodiaLevels}
<g id="Numbers">
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M73.2,373.3c2.9-1,4.9-0.5,5.5,1.4c0.6,1.7-0.6,3.3-3.4,4.4c-2.8,1-4.9,0.3-5.5-1.4
		C69.3,375.8,70.5,374.2,73.2,373.3z M75,377.8c2.2-0.8,3.2-1.9,2.8-3c-0.4-1.2-2-1.2-4.2-0.5c-2.1,0.7-3.3,1.8-2.8,3
		C71.2,378.4,72.7,378.7,75,377.8z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M76.8,369l-10.5-2.3l-0.2-0.7l10.5,2.3L76.8,369z M69.8,368.8c1.8-0.6,3,0.1,3.4,1.2c0.3,1.1-0.2,2.3-2,2.8
		c-1.7,0.5-3-0.1-3.3-1.2C67.5,370.4,68.2,369.3,69.8,368.8z M70.9,371.9c1.1-0.3,1.8-1,1.6-1.7c-0.2-0.8-1.2-0.9-2.3-0.5
		c-1,0.3-1.8,0.9-1.6,1.7C68.8,372.2,69.8,372.3,70.9,371.9z M71.6,362.1c1.8-0.6,3,0.1,3.4,1.2c0.3,1.1-0.2,2.3-2,2.8
		c-1.7,0.5-3-0.1-3.4-1.2C69.3,363.7,70,362.6,71.6,362.1z M72.7,365.2c1.1-0.3,1.8-1,1.6-1.7c-0.2-0.8-1.2-0.9-2.3-0.5
		c-1,0.3-1.8,0.9-1.6,1.7C70.6,365.4,71.6,365.6,72.7,365.2z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M59.1,327.6l0.5,3.4l2.3,0c-0.1-0.2-0.1-0.4-0.2-0.7c-0.1-0.7,0-1.4,0.2-2c0.3-0.8,1-1.4,2.1-1.6
		c1.7-0.2,3.2,1,3.5,2.9c0.1,1,0,1.8-0.2,2.3l-1-0.2c0.2-0.4,0.3-1.2,0.2-2c-0.2-1.1-1-2-2.2-1.8c-1.2,0.2-1.9,1.1-1.6,2.8
		c0.1,0.5,0.2,0.9,0.3,1.2l-4.4,0l-0.6-4.3L59.1,327.6z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M57.4,287.7L57.4,287.7l0.8,1.6l-0.9,0.2l-1-2l0-1l9,0.4l0,1.2L57.4,287.7z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M61.3,277.4c3.1,0.2,4.7,1.5,4.5,3.5c-0.1,1.8-1.9,2.8-4.8,2.6c-3-0.2-4.6-1.6-4.5-3.5
		C56.7,278.1,58.5,277.2,61.3,277.4z M61.1,282.2c2.3,0.2,3.7-0.5,3.8-1.6c0.1-1.2-1.3-1.9-3.6-2.1c-2.2-0.2-3.7,0.3-3.8,1.6
		C57.4,281.2,58.7,282.1,61.1,282.2z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M63.7,242.5L63.7,242.5l0.5,1.7l-1,0l-0.6-2.2l0.2-1l8.8,2.1l-0.3,1.1L63.7,242.5z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M66.1,232.8l-0.9,3.3l2.1,0.9c0-0.2,0.1-0.4,0.1-0.7c0.2-0.7,0.5-1.3,1-1.7c0.6-0.6,1.5-0.9,2.6-0.6
		c1.7,0.5,2.6,2.2,2.1,4c-0.3,1-0.7,1.7-1.1,2l-0.8-0.5c0.3-0.3,0.8-0.9,1-1.7c0.3-1.1-0.2-2.3-1.3-2.6c-1.1-0.3-2.1,0.2-2.6,2
		c-0.1,0.5-0.2,0.9-0.2,1.2l-4-1.7l1.1-4.2L66.1,232.8z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M84.5,205l-0.7-0.3l-0.4-1.3c-1-3-1.7-4.4-2.9-5c-0.8-0.4-1.8-0.3-2.3,0.9c-0.3,0.7-0.2,1.5-0.1,2.1l-0.9,0
		c-0.2-0.8-0.2-1.8,0.2-2.7c0.8-1.8,2.4-2,3.5-1.4c1.5,0.7,2.2,2.3,3.1,4.8l0.3,0.9l0,0l1.7-3.7l0.9,0.4L84.5,205z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M85.9,191.2c2.7,1.4,3.8,3.1,2.9,4.9c-0.8,1.6-2.8,1.9-5.5,0.6c-2.7-1.3-3.6-3.2-2.8-4.9
		C81.4,190.1,83.4,189.9,85.9,191.2z M83.9,195.6c2.1,1,3.6,1,4.1,0c0.6-1.1-0.5-2.3-2.6-3.3c-2-1-3.5-1.1-4.1,0
		C80.9,193.3,81.7,194.6,83.9,195.6z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M106,166.5l-0.6-0.4l-0.2-1.3c-0.5-3.1-0.8-4.7-1.9-5.5c-0.7-0.5-1.7-0.7-2.5,0.4c-0.5,0.7-0.5,1.5-0.5,2
		l-0.9-0.2c-0.1-0.8,0.1-1.8,0.7-2.6c1.1-1.6,2.7-1.5,3.7-0.7c1.4,1,1.8,2.7,2.1,5.3l0.1,1l0,0l2.3-3.3l0.8,0.6L106,166.5z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M107,151.6l-2.1,2.7l1.6,1.7c0.1-0.2,0.2-0.4,0.4-0.6c0.4-0.6,1-1,1.6-1.3c0.7-0.3,1.7-0.3,2.6,0.4
		c1.4,1.1,1.6,3,0.4,4.5c-0.6,0.8-1.3,1.3-1.8,1.5l-0.6-0.8c0.4-0.2,1.1-0.6,1.6-1.2c0.7-0.9,0.7-2.2-0.3-2.9
		c-0.9-0.7-2.1-0.6-3.2,0.9c-0.3,0.4-0.5,0.8-0.7,1.1l-3.1-3.1l2.6-3.4L107,151.6z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M130,135.3c0.4-0.1,1.2-0.4,1.8-1c1.1-1.1,0.7-2.2,0.2-2.7c-0.9-0.9-2.1-0.5-2.9,0.4l-0.5,0.5l-0.6-0.6
		l0.5-0.5c0.6-0.6,1.1-1.7,0.3-2.5c-0.5-0.5-1.3-0.6-2.1,0.2c-0.5,0.5-0.8,1.2-0.9,1.7l-0.9-0.4c0.1-0.6,0.5-1.5,1.2-2.2
		c1.3-1.3,2.6-1.1,3.3-0.3c0.7,0.7,0.8,1.6,0.3,2.7l0,0c0.9-0.6,2.2-0.7,3.1,0.2c1,1,1.1,2.7-0.4,4.2c-0.7,0.7-1.6,1.1-2.1,1.2
		L130,135.3z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M137,124.1c2.1,2.2,2.4,4.2,1,5.6c-1.3,1.2-3.3,0.8-5.3-1.3c-2.1-2.2-2.3-4.3-0.9-5.6
		C133.1,121.5,135.1,122,137,124.1z M133.5,127.5c1.6,1.7,3,2.2,3.8,1.4c0.9-0.9,0.4-2.3-1.2-4c-1.5-1.6-2.9-2.3-3.8-1.4
		C131.5,124.2,131.9,125.7,133.5,127.5z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M164,106.7c0.4,0,1.3-0.2,2-0.6c1.3-0.9,1.1-2,0.7-2.6c-0.7-1-2-0.9-2.9-0.2l-0.6,0.4l-0.5-0.8l0.6-0.4
		c0.7-0.5,1.4-1.5,0.8-2.4c-0.4-0.6-1.1-0.9-2.1-0.2c-0.6,0.4-1,1.1-1.2,1.5l-0.8-0.6c0.2-0.6,0.8-1.3,1.6-1.9
		c1.5-1,2.7-0.6,3.3,0.4c0.5,0.8,0.5,1.7-0.2,2.7l0,0c1-0.4,2.3-0.2,3,0.8c0.8,1.2,0.6,2.9-1.2,4.1c-0.8,0.6-1.8,0.8-2.3,0.8
		L164,106.7z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M170.7,94.5l-2.9,1.8l0.9,2.1c0.2-0.1,0.3-0.3,0.6-0.4c0.6-0.4,1.3-0.6,1.9-0.6c0.8,0,1.7,0.3,2.3,1.3
		c0.9,1.5,0.4,3.4-1.2,4.4c-0.8,0.5-1.7,0.7-2.2,0.7l-0.2-0.9c0.4,0,1.2-0.2,1.9-0.6c1-0.6,1.4-1.8,0.8-2.8c-0.6-1-1.7-1.3-3.3-0.3
		c-0.4,0.3-0.7,0.5-1,0.7l-1.8-4l3.7-2.3L170.7,94.5z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M207.2,85l-0.9-2.3l-3.9,1.6l-0.3-0.7l1.5-6.9l1.2-0.5l2.1,5.2l1.2-0.5l0.4,0.9l-1.2,0.5l0.9,2.3L207.2,85z
		 M205.9,81.8l-1.2-2.8c-0.2-0.4-0.3-0.9-0.5-1.3l0,0c-0.1,0.6-0.1,1-0.2,1.5l-0.9,3.7l0,0L205.9,81.8z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M214.2,77.3c1.1,2.9,0.6,4.8-1.2,5.6c-1.6,0.6-3.3-0.5-4.4-3.3c-1.1-2.8-0.4-4.8,1.3-5.5
		C211.5,73.4,213.1,74.6,214.2,77.3z M209.6,79.2c0.8,2.2,2,3.2,3,2.8c1.2-0.4,1.2-2,0.4-4.2c-0.8-2.1-1.8-3.2-3-2.8
		C209,75.4,208.8,76.9,209.6,79.2z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M246,72.9l-0.5-2.4l-4.1,0.9l-0.2-0.8l2.7-6.5l1.3-0.3l1.2,5.5l1.2-0.3l0.2,0.9l-1.2,0.3l0.5,2.4L246,72.9z
		 M245.2,69.6l-0.6-2.9c-0.1-0.5-0.2-0.9-0.3-1.4l0,0c-0.2,0.6-0.3,1-0.4,1.5l-1.5,3.5l0,0L245.2,69.6z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M253,63.3l-3.4,0.6l0.1,2.3c0.2-0.1,0.4-0.1,0.7-0.2c0.7-0.1,1.4-0.1,2,0.1c0.8,0.3,1.5,0.9,1.7,2
		c0.3,1.7-0.8,3.3-2.7,3.7c-1,0.2-1.8,0.1-2.3-0.1l0.1-1c0.4,0.1,1.2,0.3,2,0.1c1.1-0.2,2-1.1,1.7-2.3c-0.2-1.1-1.1-1.8-2.9-1.5
		c-0.5,0.1-0.9,0.2-1.2,0.3l-0.2-4.4l4.2-0.8L253,63.3z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M291.2,59.6l-3.4,0.1l-0.3,2.3c0.2,0,0.4-0.1,0.7-0.1c0.7,0,1.4,0.1,2,0.4c0.7,0.4,1.3,1.1,1.4,2.3
		c0,1.8-1.3,3.1-3.3,3.2c-1,0-1.8-0.2-2.3-0.5l0.3-0.9c0.4,0.2,1.1,0.5,1.9,0.4c1.2,0,2.1-0.8,2.1-2c0-1.2-0.8-2-2.6-1.9
		c-0.5,0-0.9,0.1-1.2,0.1l0.5-4.3l4.3-0.1L291.2,59.6z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M299.1,63c0,3.1-1.2,4.8-3.2,4.7c-1.8,0-2.9-1.7-3-4.6c0-3,1.3-4.7,3.2-4.7C298,58.4,299.1,60.1,299.1,63z
		 M294.2,63.1c0,2.3,0.7,3.7,1.8,3.7c1.2,0,1.8-1.4,1.9-3.7c0-2.2-0.6-3.7-1.8-3.7C294.9,59.4,294.2,60.7,294.2,63.1z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M339.7,63.9l-3.4-0.6l-0.8,2.2c0.2,0,0.4,0,0.7,0.1c0.7,0.1,1.3,0.4,1.8,0.8c0.6,0.5,1.1,1.4,0.9,2.5
		c-0.3,1.7-1.9,2.8-3.9,2.4c-1-0.2-1.7-0.6-2.1-0.9l0.5-0.9c0.3,0.3,1,0.7,1.8,0.8c1.1,0.2,2.2-0.4,2.5-1.5c0.2-1.1-0.4-2.1-2.2-2.4
		c-0.5-0.1-0.9-0.1-1.2-0.1l1.3-4.2l4.2,0.8L339.7,63.9z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M346.8,65.3l-3.4-0.7l-0.8,2.2c0.2,0,0.4,0,0.7,0.1c0.7,0.1,1.3,0.4,1.8,0.9c0.6,0.5,1,1.4,0.8,2.5
		c-0.4,1.7-2,2.7-3.9,2.3c-1-0.2-1.7-0.7-2.1-1l0.5-0.8c0.3,0.3,1,0.7,1.8,0.9c1.1,0.2,2.2-0.3,2.5-1.5c0.2-1.1-0.4-2.1-2.1-2.5
		c-0.5-0.1-0.9-0.1-1.2-0.2l1.5-4.1l4.2,0.9L346.8,65.3z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M380.5,75.4c-0.2-0.1-0.5-0.2-0.9-0.3c-1.9-0.4-3.3,0.6-4.1,1.9l0,0c0.6-0.4,1.5-0.6,2.4-0.2
		c1.5,0.6,2.1,2,1.5,3.7c-0.6,1.5-2.2,2.6-3.9,1.9c-1.8-0.7-2.5-2.5-1.6-4.7c0.6-1.7,1.7-2.7,2.9-3.3c1-0.4,2.1-0.5,3.2-0.2
		c0.4,0.1,0.6,0.2,0.9,0.2L380.5,75.4z M378.3,80.2c0.5-1.2,0-2.2-1-2.6c-0.7-0.3-1.5-0.1-2,0.4c-0.1,0.1-0.2,0.2-0.3,0.5
		c-0.5,1.4-0.2,2.7,0.9,3.1C376.9,82,377.9,81.4,378.3,80.2z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M386.7,81.8c-1.2,2.8-2.9,4-4.7,3.2c-1.6-0.7-2.1-2.7-1-5.4c1.2-2.8,3-3.8,4.7-3.1
		C387.4,77.2,387.8,79.1,386.7,81.8z M382.1,80c-0.9,2.2-0.7,3.7,0.3,4.1c1.2,0.5,2.3-0.6,3.1-2.8c0.8-2.1,0.9-3.6-0.3-4.1
		C384.2,76.9,383,77.8,382.1,80z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M421.3,95.9c-0.2-0.1-0.5-0.3-0.8-0.4c-1.8-0.7-3.4-0.1-4.3,1.1l0,0c0.7-0.3,1.5-0.3,2.4,0.3
		c1.4,0.8,1.7,2.4,0.8,3.9c-0.9,1.4-2.6,2.1-4.2,1.1c-1.6-1-1.9-2.9-0.7-4.9c0.9-1.5,2.2-2.4,3.4-2.7c1-0.2,2.1-0.1,3.2,0.4
		c0.3,0.1,0.6,0.3,0.8,0.4L421.3,95.9z M418.3,100.2c0.7-1.1,0.5-2.1-0.5-2.7c-0.6-0.4-1.4-0.4-2.1,0c-0.1,0.1-0.3,0.2-0.4,0.4
		c-0.8,1.3-0.8,2.6,0.3,3.2C416.6,101.7,417.6,101.3,418.3,100.2z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M427.5,100.2l-2.9-1.9l-1.6,1.7c0.2,0.1,0.4,0.2,0.6,0.4c0.6,0.4,1.1,0.9,1.4,1.5c0.4,0.7,0.4,1.7-0.2,2.6
		c-1,1.5-2.9,1.8-4.5,0.7c-0.8-0.5-1.4-1.2-1.6-1.7l0.8-0.6c0.2,0.4,0.7,1,1.3,1.5c1,0.6,2.2,0.5,2.9-0.5c0.6-1,0.4-2.1-1.1-3.1
		c-0.4-0.3-0.8-0.5-1.1-0.6l2.9-3.3l3.6,2.4L427.5,100.2z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M458.6,123.7l-0.5,0.6l-8.4,3.4l-0.9-0.9l8.3-3.2l0,0l-3.2-3l0.7-0.7L458.6,123.7z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M460.9,132c-2.1,2.2-4.1,2.6-5.6,1.2c-1.3-1.2-1-3.2,1.1-5.4c2.1-2.2,4.2-2.4,5.5-1.2
		C463.3,128,462.9,130,460.9,132z M457.3,128.7c-1.6,1.7-2.1,3.1-1.3,3.9c0.9,0.9,2.3,0.2,3.9-1.4c1.6-1.6,2.2-3,1.3-3.9
		C460.4,126.6,459,127,457.3,128.7z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M487,155.8l-0.6,0.5l-8.9,1.8l-0.8-1l8.7-1.7l0,0l-2.7-3.5l0.8-0.6L487,155.8z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M490.1,161.9l-2-2.8l-2.1,1.1c0.1,0.2,0.3,0.3,0.5,0.6c0.4,0.6,0.7,1.2,0.7,1.9c0.1,0.8-0.2,1.7-1.1,2.4
		c-1.4,1-3.3,0.6-4.5-1c-0.6-0.8-0.8-1.6-0.8-2.2l0.9-0.3c0,0.4,0.2,1.2,0.7,1.9c0.7,0.9,1.8,1.3,2.8,0.6c0.9-0.7,1.2-1.8,0.1-3.3
		c-0.3-0.4-0.6-0.7-0.8-1l3.9-2l2.5,3.5L490.1,161.9z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M501.8,192.7c1-0.5,2-0.2,3,0.6l0,0c0-1.1,0.5-1.8,1.2-2.2c1.3-0.6,2.7,0,3.4,1.5c0.8,1.6,0.2,2.8-0.8,3.3
		c-0.7,0.3-1.6,0.4-2.5-0.4l0,0c0.1,1.2-0.3,2.2-1.3,2.7c-1.4,0.7-2.9-0.1-3.7-1.6C500.2,194.8,500.7,193.3,501.8,192.7z M504,197.1
		c1-0.5,1.1-1.4,0.9-2.6c-0.7-0.8-1.6-1-2.4-0.6c-0.8,0.4-1.3,1.3-0.8,2.4C502.3,197.1,503.2,197.5,504,197.1z M506.6,192.1
		c-0.8,0.4-0.9,1.2-0.7,2.3c0.6,0.6,1.3,0.9,2.1,0.5c0.6-0.3,1.1-1,0.7-2C508.1,191.9,507.3,191.7,506.6,192.1z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M509.6,203.7c-2.8,1.3-4.8,0.9-5.6-0.9c-0.7-1.6,0.3-3.4,3-4.6c2.8-1.2,4.8-0.7,5.6,0.9
		C513.3,200.9,512.2,202.6,509.6,203.7z M507.4,199.3c-2.1,1-3.1,2.2-2.6,3.2c0.5,1.1,2.1,1.1,4.2,0.1c2-0.9,3.1-2,2.6-3.2
		C511.2,198.5,509.7,198.3,507.4,199.3z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M518,234.3c1.1-0.3,2.1,0.2,2.8,1.1l0,0c0.2-1.1,0.8-1.7,1.6-1.9c1.4-0.4,2.6,0.5,3,2.1
		c0.5,1.7-0.4,2.8-1.5,3.1c-0.7,0.2-1.6,0-2.4-0.9l0,0c-0.1,1.2-0.7,2.1-1.8,2.4c-1.5,0.4-2.9-0.6-3.3-2.3
		C515.9,236,516.7,234.6,518,234.3z M519.3,238.9c1.1-0.3,1.4-1.2,1.4-2.4c-0.6-0.9-1.4-1.3-2.2-1.1c-0.9,0.2-1.5,1.1-1.2,2.2
		C517.5,238.7,518.4,239.2,519.3,238.9z M522.8,234.5c-0.9,0.2-1.2,1-1.2,2.1c0.5,0.7,1.1,1.1,1.9,0.9c0.7-0.2,1.3-0.8,1-1.9
		C524.3,234.7,523.5,234.3,522.8,234.5z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M526.6,245.3l-0.7-3.4l-2.3,0.2c0.1,0.2,0.1,0.4,0.2,0.7c0.1,0.7,0.1,1.4-0.1,2c-0.2,0.8-0.9,1.5-2,1.8
		c-1.7,0.4-3.3-0.7-3.7-2.6c-0.2-1-0.1-1.8,0.1-2.3l1,0.1c-0.1,0.4-0.2,1.2-0.1,2c0.2,1.1,1.2,1.9,2.4,1.7c1.1-0.3,1.8-1.2,1.4-3
		c-0.1-0.5-0.3-0.9-0.4-1.2l4.4-0.4l0.9,4.2L526.6,245.3z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M524.5,279.1c0,0.3,0,0.6,0.1,1c0.1,0.7,0.5,1.3,1,1.8c0.6,0.6,1.4,0.9,2.5,1l0,0c-0.6-0.5-1.1-1.1-1.1-2
		c-0.1-1.6,1-2.7,2.6-2.9c1.7-0.1,3.3,1,3.4,2.8c0.1,1.8-1.3,3.1-3.6,3.2c-2,0.1-3.4-0.4-4.3-1.3c-0.7-0.6-1.2-1.6-1.4-2.5
		c-0.1-0.4-0.1-0.8-0.1-1.1L524.5,279.1z M529.7,279.1c-1.1,0.1-1.9,0.8-1.8,1.9c0.1,0.8,0.5,1.4,1.1,1.7c0.1,0.1,0.3,0.1,0.5,0.1
		c1.5-0.1,2.7-0.8,2.6-2C532,279.7,531,279,529.7,279.1z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M528.9,291.2c-3.1,0.1-4.8-0.9-4.9-2.9c-0.1-1.8,1.5-3,4.5-3.2c3-0.1,4.7,1.1,4.8,2.9
		C533.5,290,531.8,291.1,528.9,291.2z M528.6,286.3c-2.3,0.1-3.6,0.9-3.6,2c0,1.2,1.5,1.8,3.8,1.7c2.2-0.1,3.6-0.7,3.6-2
		C532.4,287,531.1,286.3,528.6,286.3z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M523.8,323.3c-0.1,0.3-0.1,0.6-0.1,1c0,0.7,0.2,1.4,0.6,2c0.5,0.7,1.2,1.2,2.2,1.5l0,0
		c-0.5-0.6-0.8-1.3-0.7-2.2c0.2-1.6,1.5-2.5,3.1-2.3c1.7,0.2,3,1.6,2.8,3.4c-0.2,1.8-1.9,2.8-4.1,2.5c-2-0.2-3.3-1.1-4-2.1
		c-0.6-0.8-0.9-1.8-0.9-2.7c0-0.4,0-0.8,0.1-1.1L523.8,323.3z M528.9,324.4c-1.1-0.1-2,0.4-2.1,1.5c-0.1,0.8,0.2,1.5,0.7,1.9
		c0.1,0.1,0.2,0.1,0.4,0.2c1.5,0.2,2.8-0.2,2.9-1.5C531,325.4,530.2,324.6,528.9,324.4z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M529.2,336l0.5-3.4l-2.2-0.7c0,0.2,0,0.4-0.1,0.7c-0.1,0.7-0.4,1.3-0.8,1.8c-0.5,0.6-1.4,1.1-2.5,0.9
		c-1.7-0.3-2.8-1.9-2.5-3.8c0.2-1,0.6-1.8,0.9-2.1l0.9,0.4c-0.3,0.3-0.7,1-0.8,1.8c-0.2,1.1,0.4,2.2,1.6,2.4
		c1.2,0.2,2.1-0.5,2.4-2.3c0.1-0.5,0.1-0.9,0.1-1.2l4.2,1.2l-0.7,4.3L529.2,336z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M523.9,359.7L523.9,359.7l-0.4-1.8l1,0l0.5,2.2l-0.3,1l-8.7-2.4l0.3-1.1L523.9,359.7z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M517.8,368.9c-2.9-0.9-4.2-2.5-3.6-4.4c0.5-1.7,2.4-2.3,5.3-1.5c2.9,0.9,4.1,2.6,3.6,4.4
		C522.4,369.3,520.5,369.8,517.8,368.9z M519.1,364.2c-2.2-0.7-3.7-0.4-4.1,0.7c-0.4,1.2,0.8,2.2,3,2.9c2.1,0.7,3.7,0.5,4.1-0.7
		C522.4,366.1,521.4,365,519.1,364.2z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M515.4,375.7c-2.9-1-4.1-2.6-3.5-4.5c0.6-1.7,2.5-2.3,5.3-1.3c2.9,1,4,2.8,3.4,4.5
		C520.1,376.2,518.2,376.7,515.4,375.7z M516.9,371.1c-2.2-0.8-3.7-0.5-4.1,0.5c-0.4,1.2,0.8,2.2,3,3c2.1,0.7,3.7,0.7,4.1-0.5
		C520.2,373,519.2,371.9,516.9,371.1z"/>
	<path style={{ fill: "#3A3A3A" }} className="st6" d="M509.8,385.5c-1.8-0.7-2.3-2-1.9-3c0.4-1,1.6-1.6,3.3-1c1.7,0.7,2.3,1.9,1.9,3
		C512.6,385.7,511.4,386.1,509.8,385.5z M510.9,382.4c-1.1-0.4-2-0.3-2.3,0.4c-0.3,0.8,0.4,1.4,1.5,1.8c1,0.4,2,0.4,2.3-0.4
		C512.6,383.5,511.9,382.8,510.9,382.4z M510,376.9l6.8,8.3l-0.3,0.7l-6.8-8.3L510,376.9z M515.3,381.4c-1.8-0.7-2.3-2-1.9-3
		c0.4-1,1.6-1.6,3.3-1c1.7,0.6,2.3,1.9,1.8,3C518.2,381.6,516.9,382,515.3,381.4z M516.5,378.3c-1.1-0.4-2-0.4-2.3,0.4
		c-0.3,0.8,0.4,1.4,1.5,1.8c1,0.4,2,0.4,2.3-0.4C518.2,379.4,517.5,378.7,516.5,378.3z"/>
</g>
<g id="Points">
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M90.1,358.7l-6.9,2.1l-0.4-1.1l6.9-2.1L90.1,358.7z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M87.7,351l-7,1.9l-0.3-1.2l7-1.9L87.7,351z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M85.6,343.1l-7.1,1.5l-0.2-1.2l7.1-1.5L85.6,343.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M83.9,335.4l-7.1,1.2l-0.2-1.2l7.1-1.2L83.9,335.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M88.6,326.6l-13.2,1.5l-0.1-1.2l13.2-1.5L88.6,326.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M81.5,319.2l-7.2,0.4l-0.1-1.2l7.2-0.4L81.5,319.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M80.9,311l-7.2,0.4l-0.1-1.2l7.2-0.4L80.9,311z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M80.5,302.6l-7.2,0.3l0-1.2l7.2-0.3L80.5,302.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M80.3,294.6l-7.2,0l0-1.2l7.2,0L80.3,294.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M81.2,278.3l-7.2-0.5l0.1-1.2l7.2,0.5L81.2,278.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M88.2,286.6l-14.7-0.2l0-1.2l14.7,0.2L88.2,286.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M82,270.3l-7.2-0.7l0.1-1.2l7.2,0.7L82,270.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M83,262.2l-7.2-1l0.2-1.2l7.2,1L83,262.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M92.5,247.7l-13.5-3.2l0.3-1.2l13.5,3.2L92.5,247.7z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M84.6,254.2l-7.1-1.5l0.2-1.2l7.1,1.5L84.6,254.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M88.5,238.1l-7.1-1.6l0.3-1.2l7.1,1.6L88.5,238.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M91.2,230.8l-7-2l0.3-1.1l7,2L91.2,230.8z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M93.2,222.8l-6.8-2.5l0.4-1.1l6.8,2.5L93.2,222.8z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M96.3,215.3l-6.7-2.7l0.5-1.1l6.7,2.7L96.3,215.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M105.4,210.6l-12.8-5.7l0.5-1.1l12.8,5.7L105.4,210.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M102.9,200.5l-6.5-3.3l0.5-1.1l6.5,3.3L102.9,200.5z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M106.7,193.2l-6.3-3.5l0.6-1l6.3,3.5L106.7,193.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M110.9,186.2l-6.2-3.8l0.6-1l6.2,3.8L110.9,186.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M115.3,179.2l-6-4l0.7-1l6,4L115.3,179.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M126.4,177.3l-12.5-9.1l0.7-1l12.5,9.1L126.4,177.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M124.6,166.1l-5.7-4.5l0.7-0.9l5.7,4.5L124.6,166.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M129.5,159.5l-5.6-4.6l0.8-0.9l5.6,4.6L129.5,159.5z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M135,153.4l-5.3-4.9l0.8-0.9l5.3,4.9L135,153.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M140.4,147.4l-5.2-5l0.8-0.9l5.2,5L140.4,147.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M153.4,149.1l-12.1-12.6l0.9-0.8l12.1,12.6L153.4,149.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M152.3,136.3l-4.8-5.4l0.9-0.8l4.8,5.4L152.3,136.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M158.6,130.9l-4.7-5.5l0.9-0.8l4.7,5.5L158.6,130.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M171.6,121l-4.2-5.9l1-0.7l4.2,5.9L171.6,121z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M184.1,125.2l-9.7-14.6l1-0.6l9.7,14.6L184.1,125.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M185.3,112.2l-3.7-6.2l1-0.6l3.7,6.2L185.3,112.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M192.2,108.2l-3.3-6.4l1.1-0.5l3.3,6.4L192.2,108.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M199.6,104.4l-3.2-6.5l1.1-0.5l3.2,6.5L199.6,104.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M206.7,100.9l-2.9-6.6l1.1-0.5l2.9,6.6L206.7,100.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M217.7,106.9l-6-15.8l1.1-0.4l6,15.8L217.7,106.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M221.7,94.9l-2-7l1.1-0.3l2,7L221.7,94.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M229.5,92.4l-1.8-7l1.2-0.3l1.8,7L229.5,92.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M237.3,90l-1.8-7l1.2-0.3l1.8,7L237.3,90z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M245.3,88.1l-1.7-7l1.2-0.3l1.7,7L245.3,88.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M255.2,96.4l-3.1-17.3l1.2-0.2l3.1,17.3L255.2,96.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M261.4,84.8l-1.1-7.2l1.2-0.2l1.1,7.2L261.4,84.8z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M269.5,83.7l-0.8-7.2l1.2-0.1l0.8,7.2L269.5,83.7z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M277.5,83l-0.5-7.2l1.2-0.1l0.5,7.2L277.5,83z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M285.4,82.5l0.1-7.2l1.2,0l-0.1,7.2L285.4,82.5z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M292.7,92.6l-0.1-17.8l1.2,0l0.1,17.8L292.7,92.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M302.2,82.3l-0.1-7.2l1.2,0l0.1,7.2L302.2,82.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M310.1,82.9l0.5-7.2l1.2,0.1l-0.5,7.2L310.1,82.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M318.1,83.6l0.8-7.2l1.2,0.1l-0.8,7.2L318.1,83.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M333,93.6l2.8-14.6l1.2,0.2l-2.8,14.6L333,93.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M326.2,84.8l1.2-7.1l1.2,0.2l-1.2,7.1L326.2,84.8z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M342.3,87.7l1.7-7.1l1.2,0.3l-1.7,7.1L342.3,87.7z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M350.1,89.7l1.9-7l1.2,0.3l-1.9,7L350.1,89.7z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M357.9,91.9l2.2-6.9l1.1,0.4l-2.2,6.9L357.9,91.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M365.8,94.5l2.4-6.8l1.1,0.4l-2.4,6.8L365.8,94.5z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M372.2,100.6l4-9.8l1.1,0.5l-4,9.7L372.2,100.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M380.8,100.7l2.9-6.6l1.1,0.5l-2.9,6.6L380.8,100.7z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M388.2,103.8l3.3-6.4l1.1,0.5l-3.3,6.4L388.2,103.8z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M395.4,107.8l3.4-6.4l1.1,0.6l-3.4,6.4L395.4,107.8z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M402.6,111.8l3.7-6.2l1,0.6l-3.7,6.2L402.6,111.8z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M406.1,121.1l7.5-11.2l1,0.6l-7.5,11.2L406.1,121.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M416.2,120.4l4.3-5.8l1,0.7l-4.3,5.8L416.2,120.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M429.4,130.5l4.5-5.7l0.9,0.7l-4.5,5.7L429.4,130.5z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M435.6,135.4l4.9-5.4l0.9,0.8l-4.9,5.4L435.6,135.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M436.7,145.8l9.9-10.4l0.9,0.8l-9.9,10.4L436.7,145.8z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M447.5,146.7l5.3-5l0.8,0.9l-5.3,5L447.5,146.7z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M453.1,152.4l5.4-4.9l0.8,0.9l-5.4,4.9L453.1,152.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M458.3,158.9l5.6-4.6l0.8,0.9l-5.6,4.6L458.3,158.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M463.5,165.1l5.8-4.4l0.7,0.9l-5.8,4.4L463.5,165.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M465.6,173.5l8.7-6.1l0.7,1l-8.8,6.2L465.6,173.5z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M472.9,177.9l6.3-3.6l0.6,1l-6.3,3.6L472.9,177.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M477.2,185.1l6.2-3.7l0.6,1l-6.2,3.7L477.2,185.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M481.1,192.2l6.4-3.4l0.6,1.1l-6.4,3.4L481.1,192.2z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M485.1,199.3l6.5-3.2l0.5,1.1l-6.5,3.2L485.1,199.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M480.9,210.1l14.4-6.5l0.5,1.1l-14.4,6.5L480.9,210.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M492.2,213.9l6.7-2.8l0.5,1.1l-6.7,2.8L492.2,213.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M495.1,221.9l6.8-2.5l0.4,1.1l-6.8,2.5L495.1,221.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M497.4,230l7-2l0.3,1.2l-7,2L497.4,230z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M499.8,237.3l7-1.9l0.3,1.2l-7,1.9L499.8,237.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M493.2,247.3l15.8-4l0.3,1.2l-15.8,4L493.2,247.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M503.4,253l7.1-1.4l0.2,1.2l-7.1,1.4L503.4,253z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M505.3,260.9l7.2-1l0.2,1.2l-7.2,1L505.3,260.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M506.4,268.4l7.2-0.2l0,1.2l-7.2,0.2L506.4,268.4z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M507.7,276.9l7.2-0.1l0,1.2l-7.2,0.1L507.7,276.9z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M495.9,285.8l19.5-0.7l0.1,1.2l-19.5,0.7L495.9,285.8z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M508.3,293.3l7.2-0.1l0,1.2l-7.2,0.1L508.3,293.3z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M508.3,301.5l7.2,0.2l0,1.2l-7.2-0.2L508.3,301.5z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M507.7,309.6l7.2,0.4l-0.1,1.2l-7.2-0.4L507.7,309.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M507,318l7.2,0.2l0,1.2l-7.2-0.2L507,318z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M496.8,324.6l17,2.4l-0.2,1.2l-17-2.4L496.8,324.6z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M504.8,334l7.1,1.3l-0.2,1.2l-7.1-1.3L504.8,334z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M503.4,342l7.1,1.6l-0.3,1.2l-7.1-1.6L503.4,342z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M501.2,350l7,1.7l-0.3,1.2l-7-1.7L501.2,350z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M499.1,358.1l7,1.7l-0.3,1.2l-7-1.7L499.1,358.1z"/>
	<path style={{ fill: "#EFEFEF" }} className="st7" d="M488.4,362.9l15.8,5l-0.4,1.1l-15.8-5L488.4,362.9z"/>
</g>
<path style={{ fill: "#F5A00C", transform: getDegreeforthreepoints(), transformOrigin: "50% 72%" }} className="st9" id="Meter_00000154418245134401961610000007130915514126422450_" d="M81.4,368.3l0.3,1.1l186.6-59.6
	c2.3,4.2,5.7,7.8,10,10.5c13.6,8.4,31.5,4.2,40-9.4c8.4-13.6,4.2-31.5-9.4-40c-13.6-8.4-31.5-4.2-40,9.4c-3.8,6.2-5.1,13.3-4,20
	L81.4,368.3z"/>
</svg>

    </div>
</>
  return (
    <>
    {meterPoints === 6 && sixPointsMeter}
      {meterPoints === 3 && threePointsMeter}
    </>
  );
}
